import { AppBar, Backdrop, Box, Button, Chip, CircularProgress, Container, CssBaseline, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, InputLabel, LinearProgress, Link, List, Menu, MenuItem, Popover, Select, Switch, TextField, Tooltip, Typography } from "@mui/material";
import TranslateIcon from '@mui/icons-material/Translate';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import { CREATE, DELETE, DataAPIContext, GET_ONE, UPDATE } from "../api";
import { ReloadIcon } from "../components/actionIcons";
// Error as ErrorIcon: a bare Error import shadows the global constructor
// (`throw new Error(...)` → "wc.a is not a constructor" in the minified bundle).
import { AddCircleOutline, AttachFile, Close, Error as ErrorIcon, ErrorOutline, NavigateBefore, Send, Cancel } from "@mui/icons-material";
import { FileIcon, defaultStyles } from 'react-file-icon';

import { ReactComponent as AppSupportIcon } from './icons/cell_phone.svg';
import { ReactComponent as MultipleRecipientsIcon } from './icons/multiple_recipients_icon.svg';
import Divider from '@mui/material/Divider';
import { AttachFileButton } from "./AttachFileButton";
//import distinctColors from 'distinct-colors'
import Avatar from 'react-avatar';
import ChatItem from "./ChatItem";
import ConfirmationDialog from '../components/ConfirmationDialog';
import { DataGridPro } from '@mui/x-data-grid-pro';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import DragAndDrop from './components/DragAndDrop'
import { ReactComponent as GroupChat } from './icons/group_chat.svg';
import { ReactComponent as GuidesAndStaff } from './icons/guides_and_staff.svg';
import LinkIcon from '@mui/icons-material/Link';
import { ReactComponent as LinkOutIcon } from './icons/link_out.svg';
import { ReactComponent as MainOfficeIcon } from './icons/main_office.svg';
import { ReactComponent as MarkUnread } from './icons/mark_unread.svg';
//import useRef from "react";
import { ReactComponent as MarkUnreadDisabled } from './icons/mark_unread_disabled.svg';
import { ReactComponent as WaiverSignedIcon } from './icons/waiver_signed.svg';
import { Tag, chatColors, headerTourTagStyle, headerChatTagStyle, headerInternalTagStyle, headerPaxStyle } from './components/Tag';
import { checkoutTimeLabel } from './checkoutLabel';
import { tourDateRangeText } from './tourDateRange';
import { STATUS_RANK, UNREAD, indexReceipts, participantReadStatus, readAtText } from './readReceipts';
import { ReactComponent as Megaphone } from './icons/megaphone.svg';
import MoonLoader from "react-spinners/MoonLoader";
import { ReactComponent as NewNote } from './icons/new_note.svg';
import { ReactComponent as NewNoteDisabled } from './icons/new_note_disabled.svg';
import NotesItem from "./NotesItem";
import FormActionButtons from "../components/FormActionButtons";
import { ReactComponent as NotificationBellOff } from './icons/notification_bell_off_new.svg';
import { ReactComponent as NotificationBellOffGray } from './icons/notification_bell_off_gray_new.svg';
import { ReactComponent as NotificationBellOn } from './icons/notification_bell_on_new.svg';
import { ReactComponent as OnTripSupport } from './icons/on_trip_support.svg';
import { ReactComponent as PauseAutoCommunications } from './icons/pause_notifications.svg';
import { ReactComponent as UnpauseAutoCommunications } from './icons/unpause_notifications.svg';
import { ReactComponent as ChatBotSettingsGreenDot } from './icons/chatbot_settings_green_dot.svg'
import { ReactComponent as ChatBotSettingsRedDot } from './icons/chatbot_settings_red_dot.svg'
import { ReactComponent as ChatBotSettingsYellowDot } from './icons/chatbot_settings_yellow_dot.svg'
import ChatbotHandoffMarker from './ChatbotHandoffMarker';
import RebookingRequestCard from './RebookingRequestCard';
import { chatbotQuietSentence, chatbotStatusHeadline, describePauseCause, isHandoffMessage } from './chatbotStatus';
import React from "react";
import { ReactComponent as ViewParticipants } from './icons/view_all_participants.svg';
import { ReactComponent as ViewParticipantsDisabled } from './icons/view_all_participants_disabled.svg';
import TemplatedMessagesMenu from './TemplatedMessagesMenu'
import axios from "axios";
import config from '../config';
import { connect } from "react-redux";
import { getTwilioClient, getLastTwilioInitError, ensure_conversation_is_active_synced, formatTourTagsTooltip, tagCategoryLabel, reqConfig } from './utils/chat_utils';
import images from "../components/images";
import randomColor from "randomcolor";
import { useParams } from "react-router-dom";
import { withRouter } from "react-router";
import { withSnackbar } from 'notistack';
import InternalTagsMenu from './InternalTagsMenu'
import MoveToLicenseeButton from './MoveToLicenseeButton';
import { BookingRefsTooltipContent, bookingRefRows } from './BookingRefs';
import MoreOptionsMenu from './MoreOptionsMenu'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { ReactComponent as TemplatedMessagesIcon } from './icons/templated_messages.svg';
import { ReactComponent as TemplatedMessagesIconDisabled } from './icons/templated_messages_disabled.svg';
import DeleteMessageAction from './DeleteMessageAction';
import { ContextStore } from '../store/contextStore';
import { DIFFERENT_SENDER_GAP_PX } from './styles/messageTypeTokens';
import { cv } from '../themeVars';
import { getTourOperatorLogoUrl } from '../utils/pwaBranding';
import { isVisualKeyboardOpen, mobileChatPaneHeight, subscribeVisualViewport } from '../layout/visualViewport';
import './TypingDots.css';
import { andAiAutoReplies, aiStillSuggests } from './notificationPauseLabels';

const Chat = require("@twilio/conversations");

const AVATAR_COLOR_PALETTE = randomColor({ count: 1000, seed: 4, format: 'rgba', alpha: 0.9 });

/** Strip final extension for matching video ↔ preview image (same basename as mobile apps). */
function chatMediaFileBaseName(name) {
  if (!name || typeof name !== 'string') return '';
  if (!name.includes('.')) return name;
  return name.split('.').slice(0, -1).join('.');
}

const VIDEO_PREVIEW_MAX_EDGE_PX = 1280;

/**
 * JPEG preview File sharing the same basename as the video (e.g. clip.mp4 + clip.jpg) for mobile clients.
 */
async function generateVideoPreviewJpegFile(videoFile) {
  const previewName = `${chatMediaFileBaseName(videoFile.name) || 'video'}.jpg`;

  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    const url = URL.createObjectURL(videoFile);
    let settled = false;

    const cleanup = () => {
      URL.revokeObjectURL(url);
      video.removeAttribute('src');
      try {
        video.load();
      } catch (e) {
        /* ignore */
      }
    };

    const fail = (err) => {
      if (settled) return;
      settled = true;
      cleanup();
      reject(err);
    };

    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.preload = 'auto';
    video.src = url;

    video.onloadedmetadata = () => {
      let seek = 0.5;
      if (video.duration && isFinite(video.duration) && video.duration > 0) {
        seek = Math.min(0.5, Math.max(0.05, video.duration * 0.1));
      }
      try {
        video.currentTime = seek;
      } catch (e) {
        fail(e);
      }
    };

    video.onseeked = () => {
      try {
        let w = video.videoWidth;
        let h = video.videoHeight;
        if (!w || !h) {
          fail(new Error('video dimensions unavailable'));
          return;
        }
        if (w > VIDEO_PREVIEW_MAX_EDGE_PX || h > VIDEO_PREVIEW_MAX_EDGE_PX) {
          if (w >= h) {
            h = Math.round((h * VIDEO_PREVIEW_MAX_EDGE_PX) / w);
            w = VIDEO_PREVIEW_MAX_EDGE_PX;
          } else {
            w = Math.round((w * VIDEO_PREVIEW_MAX_EDGE_PX) / h);
            h = VIDEO_PREVIEW_MAX_EDGE_PX;
          }
        }
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, w, h);
        canvas.toBlob(
          (blob) => {
            if (settled) return;
            settled = true;
            cleanup();
            if (!blob) {
              reject(new Error('thumbnail blob empty'));
              return;
            }
            resolve(new File([blob], previewName, { type: 'image/jpeg' }));
          },
          'image/jpeg',
          0.88
        );
      } catch (e) {
        fail(e);
      }
    };

    video.onerror = () => fail(new Error('video load failed'));
  });
}

const IMAGE_COMPRESS_MAX_EDGE_PX = 2048;
const IMAGE_COMPRESS_TARGET_BYTES = 5 * 1024 * 1024; // keep under the MMS-compatible 5MB chat cap
const IMAGE_COMPRESS_TYPES = ['image/png', 'image/jpg', 'image/jpeg'];

/**
 * Downscale + re-encode an oversized image File to a JPEG under the chat's MMS-compatible size cap.
 * Phone screenshots are attached uncompressed at native resolution and a color-rich one can exceed
 * the 5MB limit; this brings it under transparently so the user isn't rejected for a screenshot.
 * Only images already over the byte target are touched — GIFs (animation), non-images, and images
 * already under the cap are returned untouched. Returns the original File on any failure (or if
 * compression doesn't shrink it) so the caller's size check still applies.
 */
async function compressChatImageFile(file, targetBytes = IMAGE_COMPRESS_TARGET_BYTES) {
  const type = file.type?.toLowerCase();
  if (!IMAGE_COMPRESS_TYPES.includes(type) || file.size <= targetBytes) return file;

  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error('image load failed'));
      image.src = url;
    });

    let w = img.naturalWidth;
    let h = img.naturalHeight;
    if (!w || !h) return file;

    // Downscale to a max edge, preserving aspect ratio.
    const scale = Math.min(1, IMAGE_COMPRESS_MAX_EDGE_PX / Math.max(w, h));
    w = Math.max(1, Math.round(w * scale));
    h = Math.max(1, Math.round(h * scale));

    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff'; // flatten any PNG transparency (JPEG has no alpha)
    ctx.fillRect(0, 0, w, h);
    ctx.drawImage(img, 0, 0, w, h);

    const encode = (quality) =>
      new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));

    // Step quality down until under the byte target; keep the last (smallest) attempt otherwise.
    let blob = null;
    for (const quality of [0.85, 0.7, 0.55, 0.4]) {
      blob = await encode(quality);
      if (blob && blob.size <= targetBytes) break;
    }
    if (!blob || blob.size >= file.size) return file; // no improvement — keep original

    const newName = `${chatMediaFileBaseName(file.name) || 'image'}.jpg`;
    return new File([blob], newName, { type: 'image/jpeg' });
  } catch (e) {
    console.warn('compressChatImageFile: falling back to original file', e);
    return file;
  } finally {
    URL.revokeObjectURL(url);
  }
}

// Browsers report audio MIME types from the OS registry, so the same file can arrive as
// audio/x-wav, audio/wave, or audio/vnd.wave — or, for .amr, with no type at all (CP-4481).
const AUDIO_TYPE_ALIASES = {
  'audio/x-wav': 'audio/wav',
  'audio/wave': 'audio/wav',
  'audio/vnd.wave': 'audio/wav',
  'audio/mp3': 'audio/mpeg',
};
const AUDIO_EXTENSION_TYPES = { wav: 'audio/wav', amr: 'audio/amr', mp3: 'audio/mpeg' };

/**
 * Canonicalize an attachment's MIME type so validation and the Content-Type sent to Twilio don't
 * depend on the sender's OS/browser. Returns the original File when no rewrite is needed;
 * unrecognized files pass through untouched for the caller's validator to reject.
 */
function normalizeChatAttachmentFile(file) {
  let type = file.type?.toLowerCase() || '';
  type = AUDIO_TYPE_ALIASES[type] || type;
  if (!type) {
    const ext = file.name?.includes('.') ? file.name.split('.').pop().toLowerCase() : '';
    type = AUDIO_EXTENSION_TYPES[ext] || '';
  }
  if (!type || type === file.type) return file;
  return new File([file], file.name, { type });
}

function withParams(Component) {
  return props => <Component {...props} params={useParams()} dataAPI={React.useContext(DataAPIContext)} hasPerm={React.useContext(ContextStore).hasPerm} hasRestriction={React.useContext(ContextStore).hasRestriction} />;
}

const mapStateToProps = state => ({
  settings: state.auth.settings
});

// Whitespace above the date text, and the target for below it once the
// following item's own top gap is taken into account.
const DATE_SEPARATOR_GAP_PX = 24;
// Same sentinel as the operator-wide Pause After Agent Reply setting.
const PAUSE_CHATBOT_UNLIMITED = -1;

// Day divider shown above the first message/note of each date (`styles` is
// assigned at the bottom of this module, well before any render runs).
// followingGap defaults to a chat message's different-sender gap; the notes
// lists pass their own (NotesItem.textBox uses 6px).
const DateSeparator = ({ children, followingGap = DIFFERENT_SENDER_GAP_PX }) => (
  <div style={styles.dateSeparator(followingGap)}>
    <span style={styles.dateSeparatorLine} />
    <span style={styles.dateSeparatorText}>{children}</span>
    <span style={styles.dateSeparatorLine} />
  </div>
);

class ChatScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      textAreaHasText: false,
      attachedFiles: [],
      attachedFileDiv: null,
      messages: [],
      notesList: [],
      internalTags: [],
      loading: false,
      conversationOpenError: null, // null | "no_access" | "deleted" | "connectivity" | "failed" — replaces the old alert()+redirect on open failure
      sendingProgress: null, // { current: 0, total: 0 } when sending to multiple conversations
      client: null,
      channel: null,
      conversation_id: this.props.selectedConversationUniqueName,
      channelSubjectID: this.props.selectedConversationUniqueName?.split('::')[2],
      channelTopicID: this.props.selectedConversationUniqueName?.split('::')[0],
      chatChannelID: this.props.selectedConversationUniqueName?.split('::')[1],
      conversation_name: "",
      participantsList: [],
      participantsDict: {},
      participantsRoleDict: {},
      participantsAvatarColorDict: {},
      participantsAvatarImgDict: {},
      showParticipantsList: false,
      showTemplatedMessagesPane: false,
      showChatbotSettingsPanel: false,
      showTrainResponsePanel: false,
      trainingMessage: null,
      trainingQuestion: "",
      trainingResponse: "",
      trainingNotes: "",
      originalTrainingResponse: "",
      originalTrainingNotes: "",
      existingSuggestedEditId: null,
      hasUserSuggestedEdit: false,
      savingTrainResponse: false,
      selectedMsgIdx: null,
      selectedMsgReceipts: null, // CP-7814: indexReceipts() for selectedMsgIdx
      showNotesPane: false,
      showMessageStatusPane: false,
      pauseChatbot: false,
      stopChatbot: false,
      pauseChatbotDuration: 10, // minutes
      chatbotResumeDateTime: null,
      savingChatbotSettings: false,
      // Saved state (what's actually committed to backend) - used for icon display
      savedPauseChatbot: false,
      savedStopChatbot: false,
      // Why the bot is quiet (backend chatbot_pause_meta): drives the status dot's
      // tooltip and the in-thread handoff marker. Null on rows paused before the
      // backend recorded a reason.
      chatbotPauseReason: null,
      chatbotPausedByName: null,
      chatbotPausedAt: null,
      resumingChatbotFromThread: false,
      numNotes: 0,
      selectedUserProfileID: null,
      notificationLevel: null,
      subjectUserHasMissingContactInfo: false,
      subjectUserHasOptedOutOfAllValidContactMethods: false,
      subjectUserMagicLink: null,
      subjectUserReviewLink: null,
      subjectUserPreCheckinLink: null,
      subjectUserLanguage: null,
      gtuNotificationsPaused: null,
      travelDate: "",
      lastDateOfTour: "",
      subjectCheckoutTs: null,
      tourTimezone: null,
      tourTags: [],
      chatChannelTitle: "",
      syncActive: false,
      conversationNotesText: "",
      conversationNotesTextHasChangedSinceLastSave: false,
      // CP-8461: "Share with guide pre-tour" on notes. The backend's notes list says whether it applies here
      // (a guest's chat on a departure with guide notes on); shareNewNoteWithGuide is the box for a new note.
      shareWithGuideAvailable: false,
      shareNewNoteWithGuide: false,
      conversationNotesAuthor: "",
      conversationNotesLastUpdatedTS: "",
      anotherUserTyping: null,
      isSmallScreen: this.props.isSmallScreen,
      isMediumScreen: false,
      show1pageScreen: this.props.show1pageScreen,
      isShortScreen: false,
      keyboardOpen: false,
      confirmationDialogAction: null,
      showTextAreaBorder: true,
      notesOverlayInputHeight: 0,
      noteInFocusID: null,
      templatedMsgInFocusID: null,
      templatedMsgRefreshKey: 0,
      issuesState: 0,
      assignedToAdmin: null,
      exclude_delivery_to_agents: false,
      exclude_delivery_to_sms_whatsapp: false,
      askToCloseTemplatedmessagesPaneKey: 0,
      debugDialogOpen: false,
      debugLoading: false,
      debugSummary: null,
      aiSuggestedReplyConfidence: null,
      missedTourRebooking: null,
      rebookingBusy: false,
      aiSuggestedReplyLanguage: null,
      aiIsProcessing: false,
      // On-demand translation of operator's draft reply.
      draftTranslationAnchorEl: null,   // anchor for the popover
      draftTranslationText: null,       // translated draft text
      draftTranslationLang: null,       // resolved target lang
      draftTranslationLoading: false,
      draftTranslationError: null,
    };

    this.scrollDiv = React.createRef();
    this.textAreaGridRef = React.createRef();
    this.textAreaContainerRef = React.createRef();
    this.textAreaRef = React.createRef();
    this.excludeAgentsCheckboxRef = React.createRef();
    this.fetchingChatbotStatusRef = React.createRef();
    this.fetchingChatbotStatusRef.current = false;
    this.aiProcessingPollIntervalRef = null;
    this.aiProcessingPollStartTimeRef = null;
    this.chatbotStatusFetchedForConversationRef = React.createRef();
    this.chatbotStatusFetchedForConversationRef.current = null;
    this.chatbotStatusPollIntervalRef = React.createRef();
    this.chatbotStatusPollIntervalRef.current = null;
    this.chatbotStatusLastSavedRef = React.createRef();
    this.chatbotStatusLastSavedRef.current = null;
    this.handleTextAreaBorderChangeTimeoutRef = React.createRef();
    this.handleTextAreaBorderChangeTimeoutRef.current = null;
    this.attachmentFileInput = React.createRef();
    this.attachButtonRef = React.createRef();
    this.notesTextAreaRef = React.createRef();
    this.notesSaveButtonRef = React.createRef();
    this.notesOverlayInputRef = React.createRef();
    this.tourUserLinkRef = React.createRef();
    this.tourUserBookingRef = React.createRef();
    this.tourUserRefDetails = React.createRef();
    this.tourUserLinkRef = React.createRef();
    this.chatListScrollTop = React.createRef();
    this.chatListHeight = React.createRef();
    // Whether the user is at (or near) the bottom of the chat list; async
    // content (image loads, prepended history) only auto-scrolls when pinned
    this.isPinnedToBottom = true;
    this.boundChannelMessageAddedListener = null;
    this.boundChannelUpdatedListener = null;
    this.cp4183ResyncTimeout = null;
    this.boundChannelTypingStartedListener = null;
    this.boundChannelTypingEndedListener = null;
    this.boundChannelJoinedListener = null;
    // Bound once so removeEventListener can actually match it.
    this.boundResizeListener = this.resize.bind(this);
    this.conversationNotesResource = "conversation_notes"
    this.subject_user_twilio_identity = ""
    // for now, limit to these file types and 5MB to ensure sending to SMS works (note that gif isn't in the first
    // link, but is likely supported - should test)
    // https://www.twilio.com/docs/conversations/conversations-limits#media-limits
    // https://www.twilio.com/docs/sms/accepted-mime-types
    this.validFileTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'audio/mpeg', 'audio/amr', 'audio/wav', 'video/mp4', 'video/quicktime', 'application/pdf']
    // File-picker accept list: also offer the audio extensions, since some OS registries map .wav
    // to audio/x-wav (or have no mapping for .amr at all) and would grey those files out if only
    // the canonical MIME types were listed. Selected files are canonicalized in attachFiles.
    this.acceptFileTypes = [...this.validFileTypes, '.wav', '.amr', '.mp3']
    //this.attachedFileDiv = React.useState();    
    /*
    const paletteOptions = {
      count: 100,
      chromaMin: 48,
      chromaMax: 100,
      lightMin: 55,
      lightMax: 100,
      quality: 50
    };
    this.palette = distinctColors(paletteOptions);
    */

    this.palette = AVATAR_COLOR_PALETTE;
    this.channel_attributes = null;
    this.conversation_is_active_synced = false

    this._bootstrap = JSON.parse(window.localStorage.getItem('bootstrap'));

    this.userIsAdmin = this._bootstrap?.user['is_admin'] || this._bootstrap?.user['is_rbac_user'];
    this.userIsGuide = this._bootstrap?.user['is_guide'];
    // Should probably be returned by our backend, but we'll hard-code the email pattern here for
    // now. Matches both brand-wide `help@curatedplanet.com` and any per-licensee help-desk
    // identity (`help+<licensee.code>@curatedplanet.com`).
    this.userIsAppSupport = /^help(\+[^@]+)?@curatedplanet\.com$/i.test(this._bootstrap?.user['email'] || "");
    this.userIsGuest = !(this.userIsAdmin || this.userIsGuide || this.userIsAppSupport);

    console.debug("userIsAdmin:", this.userIsAdmin)
    console.debug("userIsGuide:", this.userIsGuide)
    console.debug("userIsGuest:", this.userIsGuest)

    this.resetRoleGroups = () => {
      //console.debug("ChatList: resetting firsts in list")
      let labels = {
        "guest": "guest",
        "observer": "observer",
        "guide": "staff",
        "admin": "staff"
      }
      return labels;
    }
    this.roleGroups = React.createRef(this.resetRoleGroups());

    this.resetRoleLabels = () => {
      //console.debug("ChatList: resetting firsts in list")
      let labels = {
        "guest": { "id": null, "label": "Guests" },
        "observer": { "id": null, "label": "Observers" },
        "staff": { "id": null, "label": "Staff" },
      }
      return labels;
    }
    this.roleLabels = React.createRef(this.resetRoleLabels());

    this.resetReadStatusLabels = () => {
      //console.debug("ChatList: resetting firsts in list")
      let labels = {
        // shared (CP-7814): marked read without opening it -- a teammate in a shared RBAC group read it, or Mark all read
        "guest": { "read": { "id": null, "label": "READ", "count": 0 }, "shared": { "id": null, "label": "MARKED READ, NOT OPENED", "count": 0 }, "unread": { "id": null, "label": "UNREAD/UNKNOWN", "count": 0 } },
        "staff": { "read": { "id": null, "label": "READ", "count": 0 }, "shared": { "id": null, "label": "MARKED READ, NOT OPENED", "count": 0 }, "unread": { "id": null, "label": "UNREAD/UNKNOWN", "count": 0 } },
      }
      return labels;
    }
    this.readStatusLabels = React.createRef(this.resetReadStatusLabels());

    this.firstParticipantIdToShow = React.createRef(null);

    this._participantsSortCache = { participantsList: null, msgIdx: undefined, result: null, roleGroups: null, roleLabels: null, readStatusLabels: null, firstParticipantId: null };

  }

  // CP-8056: live getters (not constructor-captured flags) so RBAC changes made while
  // the chat screen is mounted take effect on the next render without a reload.
  get hasChatDeletePerm() {
    return this.props.hasPerm('chat', 'delete_messages');
  }

  // chat.delete_own_messages lets a user delete only the messages they sent.
  // delete_messages (any message) supersedes it.
  get hasChatDeleteOwnPerm() {
    return this.props.hasPerm('chat', 'delete_own_messages');
  }

  // chat.read_only is a restriction permission: when explicitly granted to
  // an RBAC user's access group, they may view conversations but not send
  // messages. Non-RBAC / full-access users are never restricted.
  get chatWriteRestricted() {
    return this.props.hasRestriction('chat', 'read_only');
  }

  // chat.post_guide_group_announcements (CP-8136) gates broadcasting in guide
  // groups ONLY. Normal tour channels keep the pre-existing rule (any staff
  // member may post): guides announcing to their own tour is a supported
  // workflow, so revoking the permission from a Guides group must never reach
  // beyond guide groups. Guests were already read-only in announcements
  // everywhere. Read at render time, never cached, so a permission change
  // takes effect on the next my_permissions poll without a reload.
  get canPostAnnouncements() {
    if (this.userIsGuest === true) { return false; }
    if (this.props.isGuideGroupChannel !== true) { return true; }
    return this.props.hasPerm('chat', 'post_guide_group_announcements');
  }

  clearAttachedFiles = () => {
    this.setState({ attachedFiles: [] })
  }

  removeAttachedFile = (indexToRemove) => {
    this.setState(prevState => ({
      attachedFiles: prevState.attachedFiles.filter((_, index) => index !== indexToRemove)
    }))
  }

  renderAttachedFileDiv = () => {

    if (typeof this.state.attachedFiles !== 'undefined' && this.state.attachedFiles.length > 0) {
      return (
        <div style={{ position: "relative" }}>
          <div style={{ 
            display: "flex", 
            flexWrap: "wrap", 
            gap: "18px",
            paddingTop: "14px"
          }}>
            {this.state.attachedFiles.map((file, index) => {
              let extension = file.type.replace(/(.*)\//g, '');
              var mediaUrl = URL.createObjectURL(file);
              var full_file_name = file.name;
              var file_name = full_file_name.substring(0, full_file_name.lastIndexOf('.')) || full_file_name;
              const file_type = file_name.split('.').pop();

              if (file_name.length > 16) {
                file_name = file_name.slice(0, 7) + '…' + full_file_name.slice(full_file_name.length - 7, full_file_name.length);
              }

              return (
                <div key={index} style={{ position: "relative", minWidth: "50px"}} title={full_file_name}>
                  <a style={styles.attachedFileDivLink} href={mediaUrl} target="_blank" rel="noreferrer">
                    <div style={{ position: "relative", width: "30px", marginLeft: "auto", marginRight: "auto" }}>
                      <Tooltip title="Remove attachment" arrow placement="top">
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.removeAttachedFile(index);
                        }}
                        style={{
                          position: "absolute",
                          right: -14,
                          top: -14,
                          zIndex: 10,
                          cursor: "pointer",
                          color: cv('text', 'black'),
                          fontSize: "18px",
                          fontWeight: 400,
                          lineHeight: "1"
                        }}
                      >
                        ×
                      </div>
                      </Tooltip>
                      <FileIcon extension={extension}  {...defaultStyles[extension]} />
                      <div style={{ alignItems: "center" }}></div>
                    </div>
                    <div style={{ marginLeft: "auto", marginRight: "auto" }}>{file_name}</div>
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      )
    }

    return ""
  }

  getParticipantName = async (participant) => {
    var u = await participant.getUser();
    this.setState(prevState => {
      const l = Object.keys(prevState.participantsAvatarColorDict).length;
      return {
        participantsDict: { ...prevState.participantsDict, [participant.state.identity]: u.friendlyName },
        participantsAvatarColorDict: { ...prevState.participantsAvatarColorDict, [participant.state.identity]: this.palette[l] }
      };
    });
  }

  onFileChange = (event) => {
    let files_to_attach = event.target.files;
    this.attachFiles(files_to_attach);
  };

  // CP-5173: per-conversation drafts. sessionStorage (per-tab, survives navigation and
  // reloads) so an unsent message stays with its conversation instead of carrying over
  // in the shared uncontrolled textarea. Only user-entered text is saved (all save paths
  // go through handleTypingChange / setTextAreaText) — AI-suggested prefills are not,
  // since they are re-fetched from the server on every open.
  draftStorageKey = (conversationId) => conversationId ? `cp_chat_draft::${conversationId}` : null;

  saveDraft = () => {
    if (this.props.checkboxMode) return; // bulk-compose text isn't a per-conversation draft
    const key = this.draftStorageKey(this.state.conversation_id);
    if (!key || !this.textAreaRef.current) return;
    const text = this.textAreaRef.current.value;
    try {
      if (text && text.trim()) {
        sessionStorage.setItem(key, text);
      } else {
        sessionStorage.removeItem(key);
      }
    } catch (e) {
      // storage unavailable or full — drafts are best-effort
    }
  };

  clearDraft = (conversationId) => {
    const key = this.draftStorageKey(conversationId);
    if (!key) return;
    try { sessionStorage.removeItem(key); } catch (e) { /* best-effort */ }
  };

  getDraft = (conversationId) => {
    const key = this.draftStorageKey(conversationId);
    if (!key) return "";
    try { return sessionStorage.getItem(key) || ""; } catch (e) { return ""; }
  };

  handleTypingChange = (event) => {
    const { channel, textAreaHasText, showTextAreaBorder, aiSuggestedReplyConfidence } = this.state
    this.saveDraft();
    if (this.textAreaRef.current.value.length > 0 && textAreaHasText === false) {
      this.setState({ textAreaHasText: true })
    }
    if (this.textAreaRef.current.value.length === 0 && textAreaHasText === true) {
      this.setState({ textAreaHasText: false })
    }
    if (aiSuggestedReplyConfidence != null) {
      this.setState({ aiSuggestedReplyConfidence: null });
    }
    if (this.textAreaRef.current.value.length > 0) {
      // else send the Typing Indicator signal
      channel?.typing();
    }
    // Handle if border for text area should be hidden (hide it if the text area grows past the boundary of the border)
    setTimeout(() => {
      this.handleTextAreaBorderChange()
    }, 5);
  }

  maintainChatListScrollPos = () => {
    const scrollHeight = this.scrollDiv?.current?.scrollHeight;
    const height = this.scrollDiv?.current?.clientHeight;
    const maxScrollTop = Number(scrollHeight) - Number(height);

    if (this.scrollDiv?.current && height != this.chatListHeight.current) {
      this.scrollDiv.current.scrollTop -= height - this.chatListHeight.current;
      if (height > this.chatListHeight.current){
        this.scrollDiv.current.scrollTop += 0.5;
      }
    }
    this.chatListScrollTop.current = this.scrollDiv.current?.scrollTop
    this.chatListHeight.current = height;
    
  }
  /**
   * Handles the visibility of the text area border based on the relative positions
   * of the text area and the exclude agents checkbox. When the text area sinks below
   * the border,the border is hidden to prevent visual overlap. When the text area bottom
   * is above the border position, the border is shown again. Uses throttling (50ms) 
   * to prevent infinite loops from layout recalculations, and maintains scroll 
   * position when the border state changes.
   * (Method isn't really used anymore since the text area grows UP the screen now, not down)
   */
  handleTextAreaBorderChange = () => {
    // Clear any pending timeout
    if (this.handleTextAreaBorderChangeTimeoutRef.current) {
      clearTimeout(this.handleTextAreaBorderChangeTimeoutRef.current);
      this.handleTextAreaBorderChangeTimeoutRef.current = null;
    }
    
    // Throttle to prevent infinite loops
    this.handleTextAreaBorderChangeTimeoutRef.current = setTimeout(() => {
      if (!this.mounted) return;
      const { showTextAreaBorder } = this.state;
      const textAreaBottom = this.textAreaGridRef.current?.getBoundingClientRect().bottom;
      const checkboxBottom = this.excludeAgentsCheckboxRef.current?.getBoundingClientRect().bottom;
      
      if (textAreaBottom !== undefined && checkboxBottom !== undefined) {
        let stateChanged = false;
        if (showTextAreaBorder === true && textAreaBottom < checkboxBottom) {
          this.setState({ showTextAreaBorder: false });
          stateChanged = true;
        } else if (showTextAreaBorder === false && textAreaBottom > checkboxBottom) {
          this.setState({ showTextAreaBorder: true });
          stateChanged = true;
        }
        // Only maintain scroll position if state actually changed
        if (stateChanged) {
          this.maintainChatListScrollPos();
        }
      }
      this.handleTextAreaBorderChangeTimeoutRef.current = null;
    }, 50);
  }
  handleIssuesStateChange = async (event) => {
    const dataAPI = this.props.dataAPI;
    const originalState = this.state.issuesState;
    if (event.target.checked !== undefined) {
      this.setState({
        issuesState: originalState === 0 || originalState === 2 ? 1 : 0
      })
      await(async () => {
        this.props.updateIssuesStateBadge(originalState === 0 || originalState === 2 ? 1 : 0)
        try {
          const res = await dataAPI(UPDATE, "chat/conversation_issues_state", {
            id: this.state.conversation_id,
            data: {
              issues_state: originalState === 0 || originalState === 2 ? 1 : 0
            }
          });

          if (res.statusCode === 200 || res.statusCode === 201) {
          }
          else {
            this.props.enqueueSnackbar("Error updating status", { variant: 'error' });
            this.setState({
              issuesState: originalState
            })
            this.props.updateIssuesStateBadge(originalState)
          }
        } catch {
          this.props.enqueueSnackbar("Error updating status", { variant: 'error' });
          this.setState({
            issuesState: originalState
          })
          this.props.updateIssuesStateBadge(originalState)
        }
      })();




  }
  }

  attachFiles = async (attachedFiles) => {
    if (!attachedFiles || attachedFiles.length === 0) return;

    const MAX_FILE_SIZE = 5 * 1024; // 5MB in KB
    const MAX_VIDEO_FILE_SIZE = 150 * 1024; // 150MB in KB

    // Compress oversized images (e.g. full-resolution phone screenshots) before validating, so they
    // fit under the MMS-compatible 5MB cap instead of being rejected. Snapshot the FileList to an
    // array first (synchronously, before any await) so the live input can't be cleared underneath us.
    const rawFiles = Array.from(attachedFiles);
    const filesArray = await Promise.all(rawFiles.map(
      async (file) => normalizeChatAttachmentFile(await compressChatImageFile(file))
    ));

    // Validate all files
    for (let i = 0; i < filesArray.length; i++) {
      const file = filesArray[i];
      const fileType = file.type?.toLowerCase();

      // Check file type
      if (!this.validFileTypes.includes(fileType)) {
        this.props.enqueueSnackbar(`Invalid filetype selected: ${file.name}`, { variant: 'error' });
        return;
      }

      // Check file size
      const fileSizeKiloBytes = file.size / 1024;
      const isVideo = fileType === 'video/mp4';
      const overLimit = isVideo
        ? fileSizeKiloBytes > MAX_VIDEO_FILE_SIZE
        : fileSizeKiloBytes > MAX_FILE_SIZE;
      if (overLimit) {
        // Images have already been through compression by this point, so a size failure means the
        // picture is genuinely too detailed to fit — point the user at cropping/resizing instead.
        const msg = IMAGE_COMPRESS_TYPES.includes(fileType)
          ? `Image is too large to send (Max=5MB). Try cropping or lowering the resolution.`
          : `File size is greater than maximum limit: ${file.name}`;
        this.props.enqueueSnackbar(msg, { variant: 'error' });
        return;
      }

      console.debug("onFileChange: files -> " + file.name);
    }

    // Combine with existing files if any, or use new files
    const existingFiles = this.state.attachedFiles || [];
    
    // Filter out duplicates by comparing name and size
    const newFiles = filesArray.filter(newFile => {
      return !existingFiles.some(existingFile => 
        existingFile.name === newFile.name && 
        existingFile.size === newFile.size
      );
    });
    
    // Show message if any duplicates were filtered out
    const duplicateCount = filesArray.length - newFiles.length;
    if (duplicateCount > 0) {
      this.props.enqueueSnackbar(
        `${duplicateCount} file${duplicateCount > 1 ? 's' : ''} already attached and skipped`,
        { variant: 'info' }
      );
    }
    
    const allFiles = [...existingFiles, ...newFiles];
    
    this.setState({ attachedFileDiv: null, attachedFiles: allFiles })
    this.renderAttachedFileDiv();
    //
    this.textAreaRef?.current?.focus();
  }

  fetchConversationInfo = async () => {
    const { conversation_id } = this.state
    // Navigating back to the list mid-open resets state.conversation_id to null while
    // the open is still in flight; without this, the request goes out for the literal
    // string "null" and 404s ("Conversation info HTTP 404 for null" alerts).
    if (!conversation_id) return;
    const conversationInfoResource = 'chat/conversation_info';
    const dataAPI = this.props.dataAPI;
    const res = await dataAPI(GET_ONE, conversationInfoResource, { id: conversation_id });
    // Screen was torn down while this was in flight: setState would be a no-op, so the
    // updates below would silently apply to nothing.
    if (!this.mounted) return;

    //console.debug("ChatScreen: Conversation details response: ", res);
    console.log("ChatScreen: Got conversation info details.");
    if (res.statusCode >= 400 && res.statusCode < 600) {
      console.log("ChatScreen: Error getting conversation by unique name", res.statusCode);
      // Reject so initializeChatScreen's Promise.all fails into the open-error
      // UI instead of continuing with a half-initialized header. Stale unique
      // names (post departure-channel move) used to return 200 {} from the
      // backend and crash below on friendlyName.split.
      throw new Error(`Conversation info HTTP ${res.statusCode} for ${conversation_id}`);
    } else {
      const chatChannelTitle = res.data.default_channel_name_without_date_or_tags
      const travelDate = res.data.tour_start_datetime;
      const lastDateOfTour = res.data.tour_end_datetime;
      // Null for non-Group-Tour channels (Main Office, App Support, ...); keep it an array
      // so tag lookups never have to null-check.
      const tourTags = res.data.tour_tags || [];
      const tourTZ = res.data.group_tour_timezone;
      const internalTags = res.data.internal_tags;
      const issuesState = res.data.issues_state;
      const isPaused = res.data.chatbot_is_active === false;
      const pausedUntil = res.data.chatbot_is_paused_until ? new Date(res.data.chatbot_is_paused_until) : null;
      const isStopped = isPaused && !pausedUntil; // Stopped if paused but no resume time
      
      const pauseChatbot = isPaused && !isStopped;
      const stopChatbot = isStopped;
      
      // Calculate pause duration from pausedUntil if available
      let pauseChatbotDuration = 10; // default
      /*if (pausedUntil) {
        const now = new Date();
        const diffMinutes = Math.round((pausedUntil - now) / (1000 * 60));
        if (diffMinutes > 0) {
          // Find closest matching duration option (round up to nearest option)
          const durationOptions = [5, 10, 15, 30, 60, 120, 240];
          pauseChatbotDuration = durationOptions.find(d => d >= diffMinutes) || durationOptions[durationOptions.length - 1];
        }
      }*/
      
      const chatbotResumeDateTime = pausedUntil;

      this.setState({
        chatChannelTitle: chatChannelTitle,
        travelDate: travelDate,
        lastDateOfTour: lastDateOfTour,
        tourTimezone: tourTZ,
        tourTags: tourTags,
        internalTags: internalTags,
        issuesState: issuesState,
        pauseChatbot: pauseChatbot,
        stopChatbot: stopChatbot,
        pauseChatbotDuration: pauseChatbotDuration,
        chatbotResumeDateTime: chatbotResumeDateTime,
        // Also update saved state (what's actually saved to backend)
        savedPauseChatbot: pauseChatbot,
        savedStopChatbot: stopChatbot,
        ...this.chatbotPauseMetaState(res.data),
      })

      let friendlyName = res.data?.twilio_conversation_friendly_name;
      // Empty/partial payloads (pre-404 backend, or unexpected shape) must not
      // TypeError on .split — surface as a conversation-open failure instead.
      // A string without '::' is fine: split()[1] is undefined, same cosmetic
      // outcome as before (blank header name), not worth failing the open.
      if (typeof friendlyName !== 'string') {
        throw new Error(`Conversation info incomplete for ${conversation_id}`);
      }
      friendlyName = friendlyName.split('::')[1]

      const subject_user_twilio_identity = res.data.subject_user_twilio_identity;
      this.subject_user_twilio_identity = subject_user_twilio_identity;

      const updatedAvatarColorDict = { ...this.state.participantsAvatarColorDict };
      const updatedAvatarImgDict = { ...this.state.participantsAvatarImgDict };

      if (subject_user_twilio_identity != null && !(subject_user_twilio_identity in updatedAvatarColorDict) && this.props.selectedConversationAvatarColor) {
        updatedAvatarColorDict[subject_user_twilio_identity] = this.props.selectedConversationAvatarColor;
      }

      const subject_user_avatar = res.data.subject_user_profile_img;
      if (subject_user_avatar != null) {
        const userProfileImgUrl = images.url(this.props.settings.images.base, subject_user_avatar, `cover_${43}x${43}`)
        updatedAvatarImgDict[subject_user_twilio_identity] = userProfileImgUrl
      }

      if (res.data.subject_gtu_id != null) {
        this.tourUserLinkRef.current = "/trip/" + this.state.channelTopicID + "/users/manager/" + res.data.subject_gtu_id;
      }
      this.tourUserBookingRef.current = res.data.subject_gtus_booking_refs;
      this.tourUserRefDetails.current = res.data.subject_gtus_ref_details;

      this.setState({
        conversation_name: friendlyName,
        notificationLevel: res.data.user_notification_level,
        subjectUserHasMissingContactInfo: res.data.subject_user_is_not_contactable,
        subjectUserHasOptedOutOfAllValidContactMethods: res.data.subject_user_has_opted_out_of_all_valid_contact_methods,
        subjectUserMagicLink: res.data.subject_user_magic_link,
        subjectUserReviewLink: res.data.subject_user_review_link,
        subjectUserPreCheckinLink: res.data.subject_user_precheckin_link,
        subjectUserLanguage: res.data.subject_user_language,
        subjectIsLeadBooker: res.data.subject_is_lead_booker,
        subjectPaxCount: res.data.subject_pax_count,
        subjectLeadBookerName: res.data.subject_lead_booker_name,
        subjectWaiverSigned: res.data.subject_waiver_signed,
        // A hotel guest's own check-out: the range ends on it, not on the channel's
        // last day (which is the LAST guest's check-out).
        subjectCheckoutTs: res.data.subject_checkout_ts || null,
        gtuNotificationsPaused: res.data.subject_gtu_all_notifications_paused,
        // filter out the tour tags to avoid duplicates if the tag creates chat conversations AND is a visible-only tag
        // (compare against this response's tourTags, not this.state, which still holds the
        // previously-opened conversation's value if the setState above never committed)
        visibleOnlyChatTags: (res.data.subject_gtu_visible_only_chat_tags_set || []).filter(vis_tag => tourTags.find(tag => tag.id === vis_tag.id) == null),
        participantsAvatarColorDict: updatedAvatarColorDict,
        participantsAvatarImgDict: updatedAvatarImgDict
      })
      const aiIsProcessing = !!res.data.latest_msg_ai_is_processing;

      if (aiIsProcessing) {
        if (!this.aiProcessingPollIntervalRef) {
          this.startAiProcessingPolling();
        }
      } else {
        if (this.state.aiIsProcessing) {
          this.stopAiProcessingPolling();
        }
      }

      const textAreaWasEmpty = this.textAreaRef.current == null || this.textAreaRef.current.value === "";
      let didPopulateTextArea = false;
      if (this.textAreaRef.current != null && textAreaWasEmpty) {
        //const tw_identity = this._bootstrap?.user['twilio_identity']
        //const identities = ["help_curatedplanet", "47_cancun1", "info_crowntours", "vatican_crowntours", "granada_crowntours", "seville_crowntours", "barcelona_crowntours", "53_info_ciaolforence_it_162209", "livia_ciaoflorence", "marco_ciaoflorence"]
        //const is_enabled_for_user = identities.some(v => tw_identity.includes(v)) || tw_identity?.startsWith("298_")
        if(this.textAreaRef.current) {
          didPopulateTextArea = !!(res.data.latest_msg_ai_auto_response);
          this.textAreaRef.current.value = (res.data.latest_msg_ai_auto_response) || "";
        }
      }
      if (didPopulateTextArea && this.scrollDiv?.current) {
        const el = this.scrollDiv.current;
        const wasNearBottom = (el.scrollHeight - el.scrollTop - el.clientHeight) < 80;
        setTimeout(() => {
          if (!this.scrollDiv?.current) return;
          if (wasNearBottom) {
            this.scrollToBottom();
          }
        }, 100);
      }
      const aiConfidence = (textAreaWasEmpty && res.data.latest_msg_ai_auto_response) ? (res.data.latest_msg_ai_auto_response_confidence ?? null) : null;
      const aiLanguage = (textAreaWasEmpty && res.data.latest_msg_ai_auto_response) ? (res.data.latest_msg_ai_auto_response_language ?? null) : null;
      const stateUpdate = { aiIsProcessing, aiSuggestedReplyConfidence: aiConfidence, aiSuggestedReplyLanguage: aiLanguage,
        missedTourRebooking: res.data.missed_tour_rebooking || null };
      if (!this.aiProcessingPollIntervalRef) {
        // CP-5173: a restored draft must keep the Send button enabled; an AI-populated
        // suggestion keeps the pre-existing behavior (disabled until the user touches it)
        stateUpdate.textAreaHasText = !didPopulateTextArea && !!this.textAreaRef.current?.value;
        stateUpdate.attachedFiles = [];
        stateUpdate.exclude_delivery_to_agents = false;
        stateUpdate.exclude_delivery_to_sms_whatsapp = false;
      }
      this.setState(stateUpdate);
    }
  };

  updateUsersFromCPBackend = async () => {
    const { conversation_id, channelSubjectID } = this.state
    const conversationParticipantsResource = 'chat/conversation_participants';
    const dataAPI = this.props.dataAPI;
    // include_former (CP-8243): also return soft-deleted participants (e.g. guides
    // swept after their tour) so their historical messages keep name/role styling.
    // They carry former: true and are filtered out of participantsList below, so
    // the participants panel and read receipts only reflect active members.
    const res = await dataAPI(GET_ONE, conversationParticipantsResource, { id: conversation_id, filter: { include_former: 1 } });

    // CP-8243 follow-up: this call is now kicked off at the start of
    // initializeChatScreen (so role-driven message styling lands with first
    // paint instead of snapping in after the Twilio loads). That means it can
    // race a conversation switch and the getUserFromTwilio name fetches, so:
    // discard responses that land after navigation, and merge via functional
    // setState below rather than spreading this.state (a stale spread could
    // clobber concurrently-added author/avatar entries).
    if (this.state.conversation_id !== conversation_id) {
      console.warn("ChatScreen: participants response for", conversation_id, "discarded after navigation.");
      return;
    }

    //console.debug("ChatScreen: Conversation details response: ", res);
    console.log("ChatScreen: Got conversation participant details.");
    if (res.statusCode >= 400 && res.statusCode < 600) {
      console.log("ChatScreen: Error getting conversation by unique name", res.statusCode);
    } else {
      let participants = res.data.participants;

      const newParticipantsDict = {};
      const newRoleDict = {};
      const newAvatarImgDict = {};

      for (let i = 0; i < participants.length; i++) {
        let appendedRole = ""
        let role_name_shown = ""
        if (participants[i].conversation_role === "admin") {
          appendedRole = " (Admin)";
          role_name_shown = "Admin";
        }
        else if (participants[i].conversation_role === "guide") {
          appendedRole = " (Guide)";
          role_name_shown = "Tour Guide";
        }
        else if (participants[i].conversation_role === "observer") {
          appendedRole = " (Observer)";
          role_name_shown = "Observer";
        }
        else if (participants[i].conversation_role === "guest" && participants[i].is_admin === true) {
          // this case is for an admin's personal app support conversation, for example
          appendedRole = " (Admin)";
          role_name_shown = "Admin";
        }
        else if (participants[i].conversation_role === "guest" && participants[i].is_guide === true) {
          // this case is for a guides's personal app support or main office conversation, for example
          appendedRole = " (Guide)";
          role_name_shown = "Tour Guide";
        }
        else {
          appendedRole = " (Guest)";
          role_name_shown = "Guest";
        }

        if (this.userIsGuest === true) {
          //shortened display name aims to hide last name from view
          newParticipantsDict[participants[i].twilio_identity] = participants[i].shortened_display_name;
        }
        else {
          newParticipantsDict[participants[i].twilio_identity] = participants[i].display_name;
        }
        newRoleDict[participants[i].twilio_identity] = role_name_shown;

        newAvatarImgDict[participants[i].twilio_identity] = null;
        if (participants[i].avatar != null) {
          const userProfileImgUrl = images.url(this.props.settings.images.base, participants[i].avatar, `cover_${43}x${43}`)
          newAvatarImgDict[participants[i].twilio_identity] = userProfileImgUrl
        }

        // set the group tour user resource for the conversation title if applicable
        if (!participants[i].former && parseInt(participants[i].id) === parseInt(channelSubjectID) && participants[i].gtu_id != null) {
          this.tourUserLinkRef.current = "/trip/" + this.state.channelTopicID + "/users/manager/" + participants[i].gtu_id;
        }
      }
      this.setState(prevState => {
        // Avatar colors depend on what's already assigned, so they're computed
        // against prevState inside the updater (palette index = current dict size)
        const mergedAvatarColorDict = { ...prevState.participantsAvatarColorDict };
        for (let i = 0; i < participants.length; i++) {
          const identity = participants[i].twilio_identity;
          const participant_identity_parts = identity?.split('_');
          const id_from_parts = participant_identity_parts?.[participant_identity_parts.length - 1];
          if (!(identity in mergedAvatarColorDict)) {
            if (channelSubjectID === id_from_parts) {
              mergedAvatarColorDict[identity] = this.props.selectedConversationAvatarColor;
            }
            else {
              mergedAvatarColorDict[identity] = this.palette[Object.keys(mergedAvatarColorDict).length];
            }
          }
        }
        return {
          participantsDict: { ...prevState.participantsDict, ...newParticipantsDict },
          participantsRoleDict: { ...prevState.participantsRoleDict, ...newRoleDict },
          participantsAvatarColorDict: mergedAvatarColorDict,
          participantsAvatarImgDict: { ...prevState.participantsAvatarImgDict, ...newAvatarImgDict },
          // Former participants feed the dicts above (message styling) but are
          // hidden from the participants panel and read receipts
          participantsList: participants.filter(p => !p.former)
        };
      });
      //console.debug("Participants list:", this.state.participantsList)
    }
  };

  // CP-8243: scheduled automation messages show the operator's logo as their
  // avatar (chatbot messages keep the bot symbol). Memoized: the logo cannot
  // change mid-session and bootstrap is too large to re-parse per render.
  getOperatorLogoUrl = () => {
    if (this._operatorLogoUrl === undefined) {
      try {
        const bootstrap = JSON.parse(window.localStorage.getItem('bootstrap'));
        this._operatorLogoUrl = getTourOperatorLogoUrl(bootstrap?.tour_operator, this.props.settings, `cover_${43}x${43}`);
      } catch (e) {
        console.warn('ChatScreen: could not resolve operator logo URL:', e);
        this._operatorLogoUrl = null;
      }
    }
    return this._operatorLogoUrl;
  };

  getUserFromTwilio = async (author) => {
    const { client } = this.state
    //console.debug("getUserFromTwilio called with author: ", author)

    let displayName = author;
    let avatarImgUrl = null;

    // This is a shortcut. All of our user Twilio identities include underscores. Our automated
    // senders (SYSTEM, Curated Planet, etc.) do not. So don't try to fetch those automated
    // sender friendly names
    if (!author.includes("_")) {
      avatarImgUrl = '/auto_sender_profile_img_43x43.png'
    }
    else {
      try {
        let u = await client.getUser(author);
        if (u.state.friendlyName != null) {
          displayName = u.state.friendlyName;
        }
      }
      catch {
        console.warn('ChatScreen: Could not fetch user matching identity = ' + author);
      }
    }

    this.setState(prevState => {
      const updates = {
        participantsDict: { ...prevState.participantsDict, [author]: displayName },
      };
      if (avatarImgUrl) {
        updates.participantsAvatarImgDict = { ...prevState.participantsAvatarImgDict, [author]: avatarImgUrl };
      }
      if (!(author in prevState.participantsAvatarColorDict)) {
        const l = Object.keys(prevState.participantsAvatarColorDict).length;
        updates.participantsAvatarColorDict = { ...prevState.participantsAvatarColorDict, [author]: this.palette[l] };
      }
      return updates;
    });
  }

  clearCp4183ResyncTimeout = () => {
    if (this.cp4183ResyncTimeout) {
      clearTimeout(this.cp4183ResyncTimeout);
      this.cp4183ResyncTimeout = null;
    }
  };

  componentWillUnmount = async () => {
    this.mounted = false;
    this.clearCp4183ResyncTimeout();
    // Clean up polling intervals
    this.stopChatbotStatusPolling();
    this.stopContinuousChatbotStatusPolling();
    this.stopAiProcessingPolling();
    this.state.channel?.off('messageAdded', this.boundChannelMessageAddedListener)
    this.state.channel?.off('typingStarted', this.boundChannelTypingStartedListener);
    this.state.channel?.off('typingEnded', this.boundChannelTypingEndedListener);
    this.state.channel?.off('updated', this.boundChannelUpdatedListener);
    // Clean up channelJoined listener from the shared Twilio client
    if (this.boundChannelJoinedListener && this.state.client) {
      this.state.client.off("channelJoined", this.boundChannelJoinedListener);
    }
    if (this.handleVisibilityChange) {
      document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }
    window.removeEventListener("resize", this.boundResizeListener);
    if (this.unsubscribeVisualViewport) {
      this.unsubscribeVisualViewport();
      this.unsubscribeVisualViewport = null;
    }
  }

  resize() {
    let currentIsMediumScreen = (window.innerWidth <= 1500);
    if (currentIsMediumScreen !== this.state.isMediumScreen) {
      this.setState({ isMediumScreen: currentIsMediumScreen });
    } 
    let currentIsSmallScreen = (window.innerWidth <= 1200);
    let currentShow1pageScreen = currentIsSmallScreen || this.props.show1pageScreen
    if (currentIsSmallScreen !== this.state.isSmallScreen) {
      this.setState({ isSmallScreen: currentIsSmallScreen });
    }
    if (currentShow1pageScreen !== this.state.show1pageScreen) {
      this.setState({ show1pageScreen: currentShow1pageScreen });
    }
    let currentIsShortScreen = (window.innerHeight <= 900);
    if (currentIsShortScreen !== this.state.isShortScreen) {
      this.setState({ isShortScreen: currentIsShortScreen });
    }
    const keyboardOpen = isVisualKeyboardOpen();
    if (keyboardOpen !== this.state.keyboardOpen) {
      this.setState({ keyboardOpen });
    }
    this.maintainChatListScrollPos();
  }

  initializeChatScreen = async () => {
    this.mounted = true;
    const twilio_identity = this._bootstrap?.user['twilio_identity']
    const { conversation_id, channelSubjectID } = this.state
    if (!conversation_id) {
      this.clearCp4183ResyncTimeout();
      this.setState({ loading: false });
      return;
    }

    if (!twilio_identity || !conversation_id) {
      this.props.history?.replace("chat");
    }

    this.setState({ loading: true, conversationOpenError: null, aiSuggestedReplyConfidence: null, aiIsProcessing: false, missedTourRebooking: null });
    this.reactivateResponse = null;
    this.stopAiProcessingPolling();

    // CP-8243 follow-up: fetch participant roles in parallel with the whole
    // Twilio open sequence (client init, channel fetch, messages) instead of
    // after it — the sender-type tags and border accents on Team/Guest bubbles
    // derive from these roles, and fetching them last made the styling visibly
    // snap in after first paint. Fire-and-forget: the method itself discards
    // responses that land after a conversation switch.
    this.updateUsersFromCPBackend();
    // CP-5173: restore this conversation's unsent draft (empty string if none)
    const draft = this.props.checkboxMode ? "" : this.getDraft(conversation_id);
    if (this.textAreaRef.current) this.textAreaRef.current.value = draft;
    if (this.state.textAreaHasText !== !!draft) this.setState({ textAreaHasText: !!draft });

    if (!this.userIsGuest) {
      // Fetch notes
      this.fetchConversationNotes();
    }
    // if selecting a new conversation, remove the old event listeners
    this.state.channel?.off('messageAdded', this.boundChannelMessageAddedListener);
    this.state.channel?.off('typingStarted', this.boundChannelTypingStartedListener);
    this.state.channel?.off('typingEnded', this.boundChannelTypingEndedListener);
    this.state.channel?.off('updated', this.boundChannelUpdatedListener);

    console.log("ChatScreen: Getting chat client...")

    const client = await getTwilioClient()
    // Token fetch or SDK initialization failed. This is before the try below, so
    // report and show the open-error screen here rather than dying on client.on(...)
    // or, worse, inside the SDK on a half-built client.
    if (!client) {
      // Init can block up to CLIENT_INIT_TIMEOUT_MS; if the user has since left this
      // conversation, the failure is moot — same navigation guard as the outer catch.
      if (this.state.conversation_id !== conversation_id) {
        console.warn("ChatScreen: open of", conversation_id, "abandoned after navigation (client unavailable).");
        return;
      }
      // Carry the underlying init failure (token fetch error, initFailed reason, or
      // init timeout) into the report — "failed to initialize" alone is undiagnosable.
      const initError = getLastTwilioInitError();
      const err = new Error(
        "Chat client unavailable: the Twilio client failed to initialize"
        + (initError ? ` — last init error: ${initError}` : "")
      );
      console.error(err, "Unable to open conversation.");
      await this.reportConversationOpenError(conversation_id, err);
      this.setState({ loading: false, conversationOpenError: "connectivity" });
      return;
    }

    console.log("ChatScreen: Client loaded!")

    // Remove previous channelJoined listener to prevent accumulation on the shared client
    if (this.boundChannelJoinedListener) {
      client.off("channelJoined", this.boundChannelJoinedListener);
    }
    this.boundChannelJoinedListener = async (channel) => {
      // getting list of all messages since this is an existing channel
      const messages = await channel.getMessages();
      this.setState({ messages: messages.items || [] });
      this.scrollToBottom();
    };
    client.on("channelJoined", this.boundChannelJoinedListener);

    console.log("ChatScreen: Fetching channel by unique name...")
    try {
      let channel;
      try {
        // If the conversation is active_synced, this will work; otherwise,
        // it will throw an exception
        channel = await client.getConversationByUniqueName(conversation_id);
      } catch (e) {
        console.debug("ChatScreen: Exception (" + e.toString() + ") in client.getConversationByUniqueName " + conversation_id + ". Calling ensure_conversation_is_active_synced")
        try {
          this.reactivateResponse = await ensure_conversation_is_active_synced(conversation_id);
        } catch (syncErr) {
          this.reactivateResponse = syncErr.response?.data || { message: syncErr.toString() };
          if (syncErr.response?.status === 403 && syncErr.response?.data?.reason === "not_entitled") {
            // The backend refused to restore us: this conversation isn't ours to open
            // (e.g. a hand-typed or stale URL). Show a no-access screen instead of the
            // generic error; the report goes out under a distinct "access refused" subject.
            this.reportConversationOpenError(conversation_id, e, "no_access");
            this.setState({ loading: false, conversationOpenError: "no_access" });
            return;
          }
          if (syncErr.response?.status === 400 && syncErr.response?.data?.reason === "deleted") {
            // The conversation was deleted backend-side and reactivate won't resurrect
            // it (by design). Retrying can never succeed, so show a terminal
            // "no longer available" screen; the report goes out under its own subject.
            this.reportConversationOpenError(conversation_id, e, "deleted");
            this.setState({ loading: false, conversationOpenError: "deleted" });
            return;
          }
          // Repair failed for another reason; fall through to the retry below, which routes
          // to the outer catch (and the error report) if the conversation still won't open.
        }
        this.conversation_is_active_synced = true;
        channel = await client.getConversationByUniqueName(conversation_id);
      }

      // getAttributes() is an async call, so this is a promise.
      // We wait for it at the end of this method (note that this is)
      // probably overkill as it returns very quickly)
      this.channel_attributes = channel.getAttributes()

      const notificationLevel = channel.notificationLevel

      console.log("ChatScreen: Joining channel...")
      await this.joinChannel(channel);
      console.log("ChatScreen: Channel joined!")

      console.log("ChatScreen: Fetching channel messages...")
      let messages = await channel.getMessages(100)
      const firstPageItems = messages.items || []

      // Progressive first paint: render the newest page immediately; older
      // pages are prepended behind it without moving the view
      this.isPinnedToBottom = true;
      this.setState({ loading: false, client, messages: firstPageItems });
      this.scrollToBottom();

      // Resolve author names for the first page before fetching more history
      const firstPageAuthors = [...new Set(
        firstPageItems.map(m => m.author).filter(a => !(a in this.state.participantsDict))
      )];
      await Promise.all(firstPageAuthors.map(author => this.getUserFromTwilio(author)));

      let pages_fetched = 1;
      while (messages.hasPrevPage === true && pages_fetched < 3) {
        messages = await messages.prevPage()
        this.prependOlderMessages(messages.items)
        pages_fetched++;
      }

      console.log("ChatScreen: # messages: ", this.state.messages.length)

      console.log("ChatScreen: Channel messages fetched!")

      const [unread_msg_count] = await Promise.all([
        channel.getUnreadMessagesCount(),
        this.fetchConversationInfo()
      ]);
      console.debug("ChatScreen: Unread message count in this conversation before joining:", unread_msg_count)
      if (unread_msg_count != null && unread_msg_count > 0) {
        // getUnreadMessagesCount() wasn't returning the right value, so I am updating (setAllMessagesRead)
        // no matter what if there is more than one message in the conversation
        //channel.setAllMessagesRead();
      }
      if (firstPageItems.length > 0) {
        channel.setAllMessagesRead();
      }

      // Resolve author names for the older, prepended pages
      const uniqueAuthors = [...new Set(
        this.state.messages.map(m => m.author).filter(a => !(a in this.state.participantsDict))
      )];
      await Promise.all(uniqueAuthors.map(author => this.getUserFromTwilio(author)));

      this.scrollToBottomIfPinned();

      if (firstPageItems.length > 0) {
        setTimeout(async () => {
          this.props.removeUnreadBadge();
        }, 1500);
      }

      // When all conversations in a tour are muted from the conversations list, they don't update in Twilio
      // right away (but they update in our backend database nearly instantaneously). So we get the notification
      // level from our database in updateUsersFromCPBackend() as a 'hack' for this racey condition. If this field
      // isn't available, then go ahead and grab the value from Twilio
      this.setState({ channel, loading: false, notificationLevel: this.state.notificationLevel || notificationLevel });

      // wait for the promise (it's probably returned by now anyway), and check the attributes to
      // see if it is active_synced
      this.channel_attributes = await this.channel_attributes;
      //console.debug("Attributes:", this.channel_attributes)
      var is_active_synced = (this.channel_attributes.non_guest_participants_state ?? null) === "active_synced";
      this.conversation_is_active_synced = (this.conversation_is_active_synced || is_active_synced);

      // If conversation is not active_synced, make sure to set it active_synced (this can be asynchronous)
      if (this.conversation_is_active_synced !== true) {
        // don't sync if guest and is announcements since they can't post to announcements
        if (channelSubjectID !== "announcements" || this.userIsGuest === false) {
          console.debug("componentDidMount: calling ensure_conversation_is_active_synced with conversation_id: ", conversation_id)
          ensure_conversation_is_active_synced(conversation_id).catch(err => {
            console.warn(`ChatScreen: background ensure_conversation_is_active_synced failed for ${conversation_id}:`, err);
          })
          this.conversation_is_active_synced = true;
        }
      }

    } catch (e) {
      // The user left this conversation while the open was in flight (the screen now
      // shows the list or another conversation). Whatever failed is moot — don't email
      // an alert or paint the error screen over what they're looking at now.
      if (this.state.conversation_id !== conversation_id) {
        console.warn("ChatScreen: open of", conversation_id, "abandoned after navigation:", e);
        return;
      }
      console.error(e, "Unable to open conversation.");
      // If the websocket isn't connected, this is client connectivity (idle tab after
      // sleep, network change): backend state is healthy, the SDK auto-reconnects, and
      // a retry succeeds. Classify it so these don't alert like real open bugs.
      const connectivity = !!client?.connectionState && client.connectionState !== "connected";
      await this.reportConversationOpenError(conversation_id, e, connectivity ? "connectivity" : undefined);
      this.setState({ loading: false, conversationOpenError: connectivity ? "connectivity" : "failed" });
    }
    this.textAreaRef?.current?.focus();
  }

  reportConversationOpenError = async (conversation_id, error, error_type = null) => {
    const u_id = String(this._bootstrap?.user?.id)
    const params = {
      conversation_identifier: conversation_id,
      user_id: u_id,
      error_msg: error?.toString(),
      error_stack: error?.stack?.toString(),
      conversation_link: window.location?.href,
      error_type: error_type,
      // What the reactivate/repair endpoint answered before we gave up, so the alert
      // email carries a diagnosis instead of just a minified stack trace.
      reactivate_response: this.reactivateResponse ? JSON.stringify(this.reactivateResponse) : null,
    }
    await axios.post(`${config.apiUrl}/chat/dashboard_error_debugging/`, params, reqConfig()).catch(() => {
      console.error("ChatScreen: Error sending error debugging!")
    });
  }

  componentDidMount = async () => {
    this.initializeChatScreen();
    window.addEventListener("resize", this.boundResizeListener);
    this.unsubscribeVisualViewport = subscribeVisualViewport(() => this.resize());
    this.resize();
    // Start continuous polling for chatbot status (for icon updates)
    this.startContinuousChatbotStatusPolling();
    // Refresh chatbot status immediately when tab regains focus
    this.handleVisibilityChange = () => {
      if (!document.hidden && this.state.conversation_id && !this.state.showChatbotSettingsPanel) {
        this.fetchChatbotStatus();
      }
    };
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    this.handleTextAreaBorderChange()
    this.props.onRef(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    const { conversation_id } = this.state;

    // Only proceed if props actually changed to prevent infinite loops
    const selectedScreenChanged = prevProps.selectedScreen !== this.props.selectedScreen;
    const conversationChanged = prevProps.selectedConversationUniqueName !== this.props.selectedConversationUniqueName;
    const layoutChanged = prevProps.show1pageScreen !== this.props.show1pageScreen || prevProps.show3PanelChat !== this.props.show3PanelChat;

    if (layoutChanged) {
      this.resize();
    }
    
    if (!selectedScreenChanged && !conversationChanged) {
      return; // No relevant prop changes, skip to avoid infinite loops
    }

    // Resize only when relevant props changed (avoids render cascades)
    this.resize();

    if ((this.props.selectedScreen !== "ChatScreen" && conversation_id != null) ||
      (this.props.selectedConversationUniqueName != null && conversation_id !== this.props.selectedConversationUniqueName)) {
      console.debug("Switching chat screen: ", this.props.selectedConversationUniqueName)
      this.clearCp4183ResyncTimeout();
      this.state.channel?.off('messageAdded', this.boundChannelMessageAddedListener)
      this.state.channel?.off('typingStarted', this.boundChannelTypingStartedListener);
      this.state.channel?.off('typingEnded', this.boundChannelTypingEndedListener);
      this.state.channel?.off('updated', this.boundChannelUpdatedListener);
      this.tourUserLinkRef.current = null;
      this.tourUserBookingRef.current = null;
      this.tourUserRefDetails.current = null;
      this.setState({
        textAreaHasText: false,
        attachedFiles: [],
        attachedFileDiv: null,
        messages: [],
        notesList: [],
        internalTags: [],
        loading: true,
        conversationOpenError: null,
        client: null,
        channel: null,
        conversation_id: this.props.selectedConversationUniqueName,
        channelSubjectID: this.props.selectedConversationUniqueName?.split('::')[2],
        channelTopicID: this.props.selectedConversationUniqueName?.split('::')[0],
        chatChannelID: this.props.selectedConversationUniqueName?.split('::')[1],
        conversation_name: "",
        tourTags: [],
        visibleOnlyChatTags: [],
        participantsList: [],
        participantsDict: {},
        participantsRoleDict: {},
        participantsAvatarColorDict: {},
        participantsAvatarImgDict: {},
        showParticipantsList: false,
        showTemplatedMessagesPane: false,
        showChatbotSettingsPanel: false,
        selectedMsgIdx: null,
        selectedMsgReceipts: null,
        showNotesPane: false,
        showMessageStatusPane: false,
        pauseChatbot: false,
        stopChatbot: false,
        pauseChatbotDuration: 10,
        chatbotResumeDateTime: null,
        savedPauseChatbot: false,
        savedStopChatbot: false,
        selectedUserProfileID: null,
        notificationLevel: null,
        anotherUserTyping: null,
        exclude_delivery_to_agents: false,
        exclude_delivery_to_sms_whatsapp: false
      }, () => {
        // Reset chatbot status fetch refs when conversation changes
        this.chatbotStatusFetchedForConversationRef.current = null;
        this.fetchingChatbotStatusRef.current = false;
        this.chatbotStatusLastSavedRef.current = null;
        // Stop polling for the previous conversation
        this.stopChatbotStatusPolling();
        this.stopContinuousChatbotStatusPolling();
        this.stopAiProcessingPolling();
        this.initializeChatScreen();
        // Restart continuous polling after initialization completes
        setTimeout(() => {
          this.startContinuousChatbotStatusPolling();
        }, 2000);
      });
    }
    if(this.props.selectedScreen !== "ChatScreen" && conversation_id == null){
      if(this.textAreaRef.current?.value != ""){
        this.textAreaRef.current.value = ""
      }
      if(this.state.textAreaHasText !== false || this.state.attachedFiles?.length || this.state.exclude_delivery_to_agents !== false || this.state.exclude_delivery_to_sms_whatsapp !== false){
        this.setState({ textAreaHasText: false, attachedFiles: [], exclude_delivery_to_agents: false, exclude_delivery_to_sms_whatsapp: false, aiSuggestedReplyConfidence: null });
      }
    }
    if (prevProps.selectedConversationAvatarColor != this.props.selectedConversationAvatarColor) {
      this.setState(prevState => ({
        participantsAvatarColorDict: { ...prevState.participantsAvatarColorDict, [this.subject_user_twilio_identity]: this.props.selectedConversationAvatarColor }
      }));
    }
  };

  joinChannel = async (channel) => {
    if (channel.status !== "joined") {
      await channel.join();
      console.log("ChatScreen: joinChannel: channel joined ", channel);
    }

    //set up the listener for the message added Conversation event
    this.boundChannelMessageAddedListener = this.handleConversationMessageAdded.bind(this);
    channel.on('messageAdded', this.boundChannelMessageAddedListener);

    //set up the listener for the typing started Conversation event
    this.boundChannelTypingStartedListener = this.handleConversationTypingStarted.bind(this);
    channel.on('typingStarted', this.boundChannelTypingStartedListener);

    //set the listener for the typing ended Conversation event
    this.boundChannelTypingEndedListener = this.handleConversationTypingEnded.bind(this);
    channel.on('typingEnded', this.boundChannelTypingEndedListener);

    //set the listener for the conversation updated event
    this.boundChannelUpdatedListener = this.handleConversationUpdated.bind(this);
    channel.on('updated', this.boundChannelUpdatedListener);

  };

  handleConversationMessageAdded = async (message) => {
    if (this.mounted === false) {
      return
    }
    const { messages, channel } = this.state;

    // if a message from a different channel is added, skip processing it
    if (message.conversation.sid !== channel?.sid) {
      return;
    }

    // Improved deduplication: check if message already exists in the messages array
    // This is more reliable than just checking the last message, especially for rapid sends
    const messageExists = messages.some(msg => msg.sid === message.sid);
    if (messageExists) {
      return;
    }

    if (!(message.author in this.state.participantsDict)) {
      await this.getUserFromTwilio(message.author);
    }


    this.setState(
      {
        messages: !!messages ? [...messages, message] : [message],
      },
    );

    channel.setAllMessagesRead();
    //channel.updateLastReadMessageIndex(message.state.index);
    // Always follow the user's own sends; for incoming messages only follow
    // when already at the bottom (don't yank the view while reading history)
    if (message.author === this._bootstrap?.user['twilio_identity']) {
      this.scrollToBottom();
    } else {
      this.scrollToBottomIfPinned();
    }
    this.setState({ loading: false });

    const { channelSubjectID } = this.state;
    var sender_id = message.author.split(/_+/).pop();
    // Both refreshes below land 2-3s after the message. By then the user may have closed the
    // screen or switched conversations, so pin them to the conversation the message arrived on:
    // otherwise issuesState is set on whatever conversation is open by then.
    const messageConversationId = this.state.conversation_id;
    const refreshStillApplies = () =>
      this.mounted && this.state.conversation_id === messageConversationId;

    if (!isNaN(Number(sender_id)) && sender_id == channelSubjectID) {
      this.setState({ issuesState: 1 });
      setTimeout(() => {
        // fetchConversationInfo throws on HTTP errors now; a failed background
        // refresh shouldn't surface as an unhandled rejection.
        if (refreshStillApplies()) this.fetchConversationInfo().catch(err =>
          console.warn("ChatScreen: background conversation info refresh failed:", err));
      }, 2000);
    } else {
      setTimeout(async () => {
        if (!isNaN(Number(sender_id)) && refreshStillApplies()) {
          this.setState({ issuesState: 0 });
          this.fetchConversationInfo().catch(err =>
            console.warn("ChatScreen: background conversation info refresh failed:", err));
        }
      }, 3000);
    }

  };

  handleConversationTypingStarted = function (participant) {
    const this_users_twilio_identity = this._bootstrap?.user['twilio_identity']
    console.log("typingStarted...", this.state.participantsDict[participant.state.identity])
    //process the participant to show typing
    //updateTypingIndicator(participant, true);
    // removed this_users_twilio_identity !== participant.state.identity condition per CP-4617
    // so that we show if someone else signed in with the same account is typing
    if (this.state.participantsDict[participant.state.identity]) {
      console.log("typingStarted...", this.state.participantsDict[participant.state.identity])
      this.setState({ anotherUserTyping: participant.state.identity })
    }
  };

  handleConversationTypingEnded = function (participant) {
    //process the participant to stop showing typing
    //updateTypingIndicator(participant, false);
    console.log("typingEnded...")
    this.setState({ anotherUserTyping: null })
  };

  handleConversationUpdated = function (data) {
    console.log("updated...", data.updateReasons, data)
    if (data.updateReasons.includes('notificationLevel')) {
      if (this.state.notificationLevel !== this.state.channel.notificationLevel) {
        console.log("updated...", data)
        this.setState({ notificationLevel: this.state.channel.notificationLevel })
      }
    }
    if (data.updateReasons.includes('lastReadMessageIndex')) {
      this.forceUpdate()
    }
    if (data.updateReasons.includes('attributes')) {
      if (this.state.channel?.attributes?.non_guest_participants_state === 'active_unsynced') {
        // Fix for CP-4183: Automated system messages don't appear by default (page refresh needed)
        // Admins/guides are removed before automated messages are sent to ensure staff don’t get push notifications for automated messages
        // To ensure that they aren't cut off from this conversation if already in the dashboard, wait X seconds after we see that 
        // the conversation has been set to active_unsynced, and set the conversation back to active_synced
        // Only one resync timer at a time: each attributes flicker used to stack another 15s
        // callback, and leaving the conversation left those firing with conversation_id=null
        // (CPBACKEND-2E3W). Keep the FIRST deadline rather than restarting it — the wait is
        // measured from when we saw active_unsynced, and rearming on every later attributes
        // write would push the resync out indefinitely while the conversation stays unsynced.
        // Cancellation on unmount / conversation switch is handled by clearCp4183ResyncTimeout().
        if (this.cp4183ResyncTimeout) {
          return;
        }
        const scheduledFor = this.state.conversation_id;
        if (!scheduledFor) {
          return;
        }
        this.cp4183ResyncTimeout = setTimeout(async () => {
          this.cp4183ResyncTimeout = null;
          if (!this.mounted || this.state.conversation_id !== scheduledFor) {
            return;
          }
          // Detaching before the rejoin means any failure in between leaves the screen with no
          // listeners at all — silently dead until the user reopens it. Hold the channel we
          // detached from so the catch can put the listeners back.
          const previousChannel = this.state.channel;
          let rejoined = false;
          previousChannel?.off('messageAdded', this.boundChannelMessageAddedListener)
          previousChannel?.off('typingStarted', this.boundChannelTypingStartedListener);
          previousChannel?.off('typingEnded', this.boundChannelTypingEndedListener);
          previousChannel?.off('updated', this.boundChannelUpdatedListener);
          try {
            await ensure_conversation_is_active_synced(scheduledFor);
            this.conversation_is_active_synced = true;
            let channel = await this.state.client.getConversationByUniqueName(scheduledFor);
            await this.joinChannel(channel);
            rejoined = true;
            // Read from the channel we just joined, not this.state.channel — joinChannel only
            // attaches listeners, so state still holds the pre-resync channel here.
            let messages = await channel.getMessages(100)
            if (!this.mounted || this.state.conversation_id !== scheduledFor) {
              return;
            }
            this.setState({ channel, messages: messages?.items || [] });
            this.scrollToBottom();
          } catch (err) {
            console.warn(`ChatScreen: CP-4183 resync failed for ${scheduledFor}:`, err);
            if (!rejoined && previousChannel && this.mounted && this.state.conversation_id === scheduledFor) {
              try {
                await this.joinChannel(previousChannel);
              } catch (rejoinErr) {
                console.warn(`ChatScreen: CP-4183 resync could not re-attach listeners for ${scheduledFor}:`, rejoinErr);
              }
            }
          }
        }, 15000);
      }
      else if (this.state.channel?.attributes?.non_guest_participants_state === 'deleted') {
        // Nothing left to resync into; drop any armed timer here rather than relying on the
        // navigation below reaching componentWillUnmount / the componentDidUpdate switch branch.
        this.clearCp4183ResyncTimeout();
        alert("This conversation has been removed!");
        this.props.history.replace("/chat")
      }
    }
  };

  scrollToBottom = (amt=null) => {
    const scrollHeight = this.scrollDiv?.current?.scrollHeight;
    const height = this.scrollDiv?.current?.clientHeight;
    const maxScrollTop = Number(scrollHeight) - Number(height);
    if (this.scrollDiv && this.scrollDiv.current) {
      this.scrollDiv.current.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
    }
    this.chatListScrollTop.current = this.scrollDiv.current?.scrollTop
    this.chatListHeight.current = height;
    this.isPinnedToBottom = true;
  };

  scrollToBottomIfPinned = () => {
    if (this.isPinnedToBottom) {
      this.scrollToBottom();
    }
  };

  handleChatListScroll = () => {
    const el = this.scrollDiv?.current;
    if (!el) return;
    this.isPinnedToBottom = (el.scrollHeight - el.scrollTop - el.clientHeight) < 80;
    this.chatListScrollTop.current = el.scrollTop;
  };

  // Insert older history above the current messages without moving what the
  // user is looking at: compensates scrollTop for the added height
  prependOlderMessages = (olderItems) => {
    if (!olderItems || olderItems.length === 0) return;
    const el = this.scrollDiv?.current;
    const prevScrollHeight = el ? el.scrollHeight : 0;
    const prevScrollTop = el ? el.scrollTop : 0;
    this.setState(
      (prev) => ({ messages: [...olderItems, ...(prev.messages || [])] }),
      () => {
        const after = this.scrollDiv?.current;
        if (after) {
          after.scrollTop = prevScrollTop + (after.scrollHeight - prevScrollHeight);
          this.chatListScrollTop.current = after.scrollTop;
        }
      }
    );
  };

  // Helper function to send a message with retry logic for 403 Forbidden errors
  sendMessageWithRetry = async (prepareMessageFn, errorContext = 'message') => {
    const { channel } = this.state;
    const maxRetries = 1; // Only retry once after token refresh
    
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
      try {
        // Get current channel (use state channel on retry attempts in case it was refreshed)
        let currentChannel = attempt > 0 ? this.state.channel : channel;
        if (!currentChannel) {
          // If channel is lost, try to re-obtain it
          const client = await getTwilioClient();
          const conversation_id = this.state.conversation_id;
          try {
            currentChannel = await client.getConversationByUniqueName(conversation_id);
            if (attempt > 0) {
              // Update state with re-obtained channel
              this.setState({ channel: currentChannel });
            }
          } catch (e) {
            console.error("ChatScreen: sendMessageWithRetry: Failed to re-obtain channel:", e);
            throw new Error("Failed to reconnect to conversation");
          }
        }
        
        // Prepare and send the message
        const preparedMessage = prepareMessageFn(currentChannel);
        const sendPromise = preparedMessage.build().send();
        
        // Wait for the send to complete
        await sendPromise;
        return; // Success, exit retry loop
        
      } catch (error) {
        const isForbidden = error?.status === 403 || 
                           error?.message === 'Forbidden' || 
                           (error?.message && error.message.includes('Forbidden'));
        
        if (isForbidden && attempt < maxRetries) {
          console.warn(`ChatScreen: sendMessageWithRetry: ${errorContext} failed with 403 Forbidden. Attempting token refresh and retry...`);
          
          try {
            // Refresh the token
            const client = await getTwilioClient();
            if (client) {
              // Get a new token and update the client
              const response = await axios.get(`${config.v1ApiUrl}/concierge/twilio/access-token/`, {
                headers: {
                  'Authorization': `Token ${this._bootstrap?.token}`
                }
              });
              const newToken = response.data.fcm_token_web;
              await client.updateToken(newToken);
              console.log("ChatScreen: sendMessageWithRetry: Token refreshed successfully");
              
              // Re-obtain the channel to ensure it uses the new token
              const conversation_id = this.state.conversation_id;
              try {
                const refreshedChannel = await client.getConversationByUniqueName(conversation_id);
                // Update state with refreshed channel
                this.setState({ channel: refreshedChannel });
                // Wait a brief moment for token to propagate
                await new Promise(resolve => setTimeout(resolve, 200));
                
                // Continue to retry with refreshed channel
                continue;
              } catch (channelError) {
                console.error("ChatScreen: sendMessageWithRetry: Failed to re-obtain channel after token refresh:", channelError);
                // Try to ensure conversation is synced
                await ensure_conversation_is_active_synced(conversation_id);
                const refreshedChannel = await client.getConversationByUniqueName(conversation_id);
                this.setState({ channel: refreshedChannel });
                await new Promise(resolve => setTimeout(resolve, 200));
                continue;
              }
            }
          } catch (tokenError) {
            console.error("ChatScreen: sendMessageWithRetry: Failed to refresh token:", tokenError);
            throw new Error(`Failed to refresh token: ${tokenError?.message || 'Unknown error'}`);
          }
        } else {
          // Not a 403 error, or we've exhausted retries
          throw error;
        }
      }
    }
  };

  /**
   * One Twilio message per batch. Pairs image+video with the same basename (e.g. foo.jpg + foo.mp4).
   * Unpaired videos get a generated JPEG preview so mobile can show a thumbnail without downloading the video.
   */
  buildAttachmentSendBatches = (files) => {
    if (!files || files.length === 0) return [];
    const n = files.length;
    const consumed = new Set();
    const batches = [];

    for (let i = 0; i < n; i++) {
      if (consumed.has(i)) continue;
      const fi = files[i];
      const baseI = chatMediaFileBaseName(fi.name);
      let pairJ = -1;

      for (let j = i + 1; j < n; j++) {
        if (consumed.has(j)) continue;
        const fj = files[j];
        if (chatMediaFileBaseName(fj.name) !== baseI) continue;
        const fiImg = fi.type.startsWith('image/');
        const fjImg = fj.type.startsWith('image/');
        const fiVid = fi.type.startsWith('video/');
        const fjVid = fj.type.startsWith('video/');
        if ((fiImg && fjVid) || (fjImg && fiVid)) {
          pairJ = j;
          break;
        }
      }

      if (pairJ >= 0) {
        const fj = files[pairJ];
        const img = fi.type.startsWith('image/') ? fi : fj;
        const vid = fi.type.startsWith('video/') ? fi : fj;
        batches.push({ files: [img, vid] });
        consumed.add(i);
        consumed.add(pairJ);
        continue;
      }

      if (fi.type.startsWith('video/')) {
        batches.push({ files: [fi], generatePreview: true });
      } else {
        batches.push({ files: [fi], generatePreview: false });
      }
      consumed.add(i);
    }

    return batches;
  };

  resolveAttachmentSendBatches = async (files) => {
    const raw = this.buildAttachmentSendBatches(files);
    const resolved = [];
    for (const batch of raw) {
      if (batch.generatePreview && batch.files.length === 1) {
        try {
          const thumb = await generateVideoPreviewJpegFile(batch.files[0]);
          resolved.push({ files: [thumb, batch.files[0]] });
        } catch (e) {
          console.warn('ChatScreen: video preview generation failed, sending video only', e);
          resolved.push({ files: batch.files });
        }
      } else {
        resolved.push({ files: batch.files });
      }
    }
    return resolved;
  };

  sendMessage = async () => {
    if (this.chatWriteRestricted) return;
    const { channel, attachedFiles, exclude_delivery_to_agents, exclude_delivery_to_sms_whatsapp } = this.state;
    const { selectedConversationsForMessaging, checkboxMode } = this.props;

    const text = this.textAreaRef.current.value;
    const hasText = text && String(text).trim();
    const hasAttachments = typeof attachedFiles !== 'undefined' && attachedFiles.length > 0;

    if (!hasText && !hasAttachments) return;

    this.setState({ loading: true });

    // If in checkbox mode with selected conversations, send to each individually
    if (checkboxMode && selectedConversationsForMessaging && selectedConversationsForMessaging.length > 0) {
      this.setState({ sendingProgress: { current: 0, total: selectedConversationsForMessaging.length } });
      await this.sendMessageToMultipleConversations(selectedConversationsForMessaging, text, attachedFiles, exclude_delivery_to_agents, exclude_delivery_to_sms_whatsapp);
      if (this.textAreaRef.current) this.textAreaRef.current.value = "";
      this.clearDraft(this.state.conversation_id);
      this.setState({ textAreaHasText: false, attachedFiles: [], exclude_delivery_to_agents: false, exclude_delivery_to_sms_whatsapp: false, loading: false, sendingProgress: null, aiSuggestedReplyConfidence: null });
      return;
    }

    let msgSent = false;

    // TEMPORARY: Send attachments and text as separate messages
    // TODO: Once backend/system supports combined messages (text + media in one message),
    // revert to the combined approach below (see commented code)
    if (hasAttachments) {
      // One Twilio message per batch; video + matching-basename image (or generated preview) share one message
      const resolvedBatches = await this.resolveAttachmentSendBatches(attachedFiles);
      const attachmentPromises = [];
      for (let i = 0, len = resolvedBatches.length; i < len; i++) {
        const batch = resolvedBatches[i];
        const namesForLog = batch.files.map((f) => f.name).join(' + ');
        console.log('ChatScreen: sendMessage: media batch:', namesForLog);

        const attachmentIndex = i;
        const attachmentName = batch.files.map((f) => f.name).join(', ');
        const sendPromise = this.sendMessageWithRetry((currentChannel) => {
          let preparedMessage = currentChannel.prepareMessage();
          for (let k = 0; k < batch.files.length; k++) {
            const formData = new FormData();
            formData.append(batch.files[k].name, batch.files[k]);
            preparedMessage.addMedia(formData);
          }

          const attributes = {};
          if (exclude_delivery_to_agents) {
            attributes.exclude_delivery_to_agents = true;
          }
          if (exclude_delivery_to_sms_whatsapp) {
            attributes.exclude_delivery_to_sms_whatsapp = true;
          }
          if (Object.keys(attributes).length > 0) {
            preparedMessage = preparedMessage.setAttributes(attributes);
          }

          return preparedMessage;
        }, `attachment batch ${attachmentIndex + 1}/${len}`).catch((error) => {
          console.error(`ChatScreen: sendMessage: Error sending attachment batch ${attachmentIndex + 1}/${len}:`, error);
          if (this.props.enqueueSnackbar) {
            this.props.enqueueSnackbar(
              `Failed to send attachment: ${attachmentName}. ${error?.message || 'Unknown error'}`,
              { variant: 'error' }
            );
          }
        });

        console.log(`ChatScreen: sendMessage: SENDING MEDIA MESSAGE ${i + 1}/${len}`);
        attachmentPromises.push(sendPromise);
      }
      msgSent = true;

      // Refresh messages to ensure all sent media messages appear
      // This helps catch media messages that might not have triggered messageAdded events immediately
      // Only needed for media messages, not text messages
      const numAttachments = resolvedBatches.length;
      const initialMessageCount = this.state.messages.length;
      const expectedMediaCount = initialMessageCount + numAttachments; // Only count media messages
      let refreshAttempt = 0;
      const maxRefreshAttempts = 3;
      const refreshDelays = [500, 1500, 3000]; // ms delays for each attempt
      
      const refreshMessages = async () => {
        if (!this.mounted || !this.state.channel || refreshAttempt >= maxRefreshAttempts) {
          return;
        }
        
        try {
          const messages = await this.state.channel.getMessages();
          const currentCount = messages.items?.length || 0;
          
          // Update if we got new messages or if we're still missing expected media messages
          if (currentCount > this.state.messages.length || currentCount < expectedMediaCount) {
            this.setState({ messages: messages.items || [] });
            this.scrollToBottom();
            
            // If we have all expected media messages, stop refreshing
            if (currentCount >= expectedMediaCount) {
              return;
            }
          }
          
          // Schedule next refresh if we haven't reached max attempts and still missing media messages
          refreshAttempt++;
          if (refreshAttempt < maxRefreshAttempts && currentCount < expectedMediaCount) {
            setTimeout(refreshMessages, refreshDelays[refreshAttempt] - refreshDelays[refreshAttempt - 1]);
          }
        } catch (error) {
          console.error("ChatScreen: sendMessage: Error refreshing messages:", error);
        }
      };
      
      // Start first refresh (only for media messages)
      setTimeout(refreshMessages, refreshDelays[0]);
    }

    // Send text message separately (after attachments)
    if (hasText) {
      console.log("ChatScreen: sendMessage: TEXT:", text)
      
      // Use retry helper for text messages
      const sendPromise = this.sendMessageWithRetry((currentChannel) => {
        let preparedMessage = currentChannel.prepareMessage();
        preparedMessage = preparedMessage.setBody(text);
        
        // Set attributes if needed
        const attributes = {};
        if (exclude_delivery_to_agents) {
          attributes.exclude_delivery_to_agents = true;
        }
        if (exclude_delivery_to_sms_whatsapp) {
          attributes.exclude_delivery_to_sms_whatsapp = true;
        }
        if (Object.keys(attributes).length > 0) {
          preparedMessage = preparedMessage.setAttributes(attributes);
        }
        
        return preparedMessage;
      }, 'text message').catch((error) => {
        console.error("ChatScreen: sendMessage: Error sending text message:", error);
        if (this.props.enqueueSnackbar) {
          this.props.enqueueSnackbar(
            `Failed to send message. ${error?.message || 'Unknown error'}`,
            { variant: 'error' }
          );
        }
      });
      
      console.log("ChatScreen: sendMessage: SENDING TEXT MESSAGE");
      msgSent = true;
    }

    // FUTURE: Combined message approach (uncomment when backend supports it)
    // This sends text and all attachments in a single message
    /*
    let preparedMessage = channel.prepareMessage();

    // Add all media attachments
    if (hasAttachments) {
      for (var i = 0, len = attachedFiles.length; i < len; i++) {
        console.log("ChatScreen: sendMessage: attached file:", attachedFiles[i].name)
        const formData = new FormData();
        formData.append(attachedFiles[i].name, attachedFiles[i]);
        preparedMessage.addMedia(formData);
      }
    }

    // Add text body if present
    if (hasText) {
      console.log("ChatScreen: sendMessage: TEXT:", text)
      preparedMessage = preparedMessage.setBody(text);
    }

    // Set attributes if needed
    const attributes = {};
    if (exclude_delivery_to_agents) {
      attributes.exclude_delivery_to_agents = true;
    }
    if (exclude_delivery_to_sms_whatsapp) {
      attributes.exclude_delivery_to_sms_whatsapp = true;
    }
    if (Object.keys(attributes).length > 0) {
      preparedMessage = preparedMessage.setAttributes(attributes);
    }

    // Send the single message with both text and/or media
    const messageType = hasText && hasAttachments ? "TEXT AND MEDIA" : hasAttachments ? "MEDIA" : "TEXT";
    console.log(`ChatScreen: sendMessage: SENDING ${messageType} MESSAGE`);
    preparedMessage.build().send();
    */

    if (this.textAreaRef.current) this.textAreaRef.current.value = ""
    this.clearDraft(this.state.conversation_id);
    this.setState({ textAreaHasText: false, attachedFiles: [], exclude_delivery_to_agents: false, exclude_delivery_to_sms_whatsapp: false, loading: false, aiSuggestedReplyConfidence: null });
  };

  sendMessageToMultipleConversations = async (conversationUniqueNames, text, attachedFiles, exclude_delivery_to_agents, exclude_delivery_to_sms_whatsapp) => {
    const client = await getTwilioClient();
    const hasText = text && String(text).trim();
    const hasAttachments = typeof attachedFiles !== 'undefined' && attachedFiles.length > 0;
    let resolvedAttachmentBatches = [];
    if (hasAttachments) {
      resolvedAttachmentBatches = await this.resolveAttachmentSendBatches(attachedFiles);
    }

    const total = conversationUniqueNames.length;
    let successCount = 0;
    let errorCount = 0;
    const errors = [];

    // Process in larger batches with higher concurrency for better performance
    const batchSize = 25; // Increased batch size for better throughput
    const progressUpdateInterval = 5; // Update progress every 5 messages to reduce React overhead
    
    for (let i = 0; i < conversationUniqueNames.length; i += batchSize) {
      const batch = conversationUniqueNames.slice(i, i + batchSize);
      
      // Process batch with high concurrency - all operations in parallel
      const batchPromises = batch.map(async (conversationUniqueName) => {
        try {
          // Start ensure_conversation_is_active_synced but don't wait for it (fire-and-forget for performance)
          // This API call is the main bottleneck - making it non-blocking significantly improves speed
          const ensurePromise = ensure_conversation_is_active_synced(conversationUniqueName).catch(err => {
            console.warn(`ChatScreen: ensure_conversation_is_active_synced failed for ${conversationUniqueName}:`, err);
          });
          
          // Get the conversation channel (try immediately, retry if needed)
          let channel;
          try {
            channel = await client.getConversationByUniqueName(conversationUniqueName);
          } catch (e) {
            // If getting channel fails, wait for ensure to complete and retry once
            console.warn(`ChatScreen: Error getting conversation ${conversationUniqueName}, waiting for ensure and retrying:`, e);
            try {
              await ensurePromise; // Wait for ensure to complete
              await new Promise(resolve => setTimeout(resolve, 100)); // Small delay for backend to process
              channel = await client.getConversationByUniqueName(conversationUniqueName);
            } catch (retryError) {
              console.error(`ChatScreen: Error getting conversation ${conversationUniqueName} after retry:`, retryError);
              errorCount++;
              errors.push(conversationUniqueName);
              return;
            }
          }

          // Send attachments if any (fire-and-forget, no need to await)
          if (hasAttachments && resolvedAttachmentBatches.length > 0) {
            for (let j = 0; j < resolvedAttachmentBatches.length; j++) {
              const mediaBatch = resolvedAttachmentBatches[j];
              let preparedMessage = channel.prepareMessage();
              for (let k = 0; k < mediaBatch.files.length; k++) {
                const formData = new FormData();
                formData.append(mediaBatch.files[k].name, mediaBatch.files[k]);
                preparedMessage.addMedia(formData);
              }

              const attributes = {};
              if (exclude_delivery_to_agents) {
                attributes.exclude_delivery_to_agents = true;
              }
              if (exclude_delivery_to_sms_whatsapp) {
                attributes.exclude_delivery_to_sms_whatsapp = true;
              }
              if (Object.keys(attributes).length > 0) {
                preparedMessage = preparedMessage.setAttributes(attributes);
              }

              preparedMessage.build().send(); // Fire-and-forget
            }
          }

          // Send text message if any (fire-and-forget, no need to await)
          if (hasText) {
            let preparedMessage = channel.prepareMessage();
            preparedMessage = preparedMessage.setBody(text);
            
            const attributes = {};
            if (exclude_delivery_to_agents) {
              attributes.exclude_delivery_to_agents = true;
            }
            if (exclude_delivery_to_sms_whatsapp) {
              attributes.exclude_delivery_to_sms_whatsapp = true;
            }
            if (Object.keys(attributes).length > 0) {
              preparedMessage = preparedMessage.setAttributes(attributes);
            }
            
            preparedMessage.build().send(); // Fire-and-forget
          }
          
          successCount++;
          
          // Update progress less frequently to reduce React state update overhead
          const processed = successCount + errorCount;
          if (processed % progressUpdateInterval === 0 || processed === total) {
            this.setState({ sendingProgress: { current: processed, total: total } });
          }
          
          // Log progress for large batches
          if (total > 50 && processed % 25 === 0) {
            console.log(`ChatScreen: Progress: ${processed}/${total} conversations processed`);
          }
        } catch (error) {
          console.error(`ChatScreen: Error sending message to conversation ${conversationUniqueName}:`, error);
          errorCount++;
          errors.push(conversationUniqueName);
          
          // Update progress on error too
          const processed = successCount + errorCount;
          if (processed % progressUpdateInterval === 0 || processed === total) {
            this.setState({ sendingProgress: { current: processed, total: total } });
          }
        }
      });
      
      // Wait for batch to complete (all conversations processed in parallel)
      await Promise.all(batchPromises);
      
      // No delay between batches - the API calls and message sends are already async
      // Removing the delay significantly improves performance for large batches
    }
    
    // Log summary
    if (errorCount > 0) {
      console.warn(`ChatScreen: Completed sending messages. Success: ${successCount}, Errors: ${errorCount}`);
      if (this.props.enqueueSnackbar) {
        this.props.enqueueSnackbar(
          `Messages sent to ${successCount} conversations. ${errorCount} failed.`,
          { variant: errorCount > successCount ? 'error' : 'warning', autoHideDuration: 5000 }
        );
      }
    } else if (total > 10) {
      // Only show success message for large batches
      if (this.props.enqueueSnackbar) {
        this.props.enqueueSnackbar(
          `Messages sent to ${successCount} conversations successfully.`,
          { variant: 'success', autoHideDuration: 3000 }
        );
      }
    }
  };

  goBack = (e, chatViewOverride = null) => {
    e.stopPropagation();

    const { conversation_id, channelTopicID, chatChannelID, channelSubjectID } = this.state;
    const firstBulkUniqueName = this.props.selectedConversationsForMessaging?.[0];
    const channelIdFromSelection = typeof firstBulkUniqueName === 'string' ? firstBulkUniqueName.split('::')[1] : undefined;
    const effectiveChatChannelID =
      chatChannelID ||
      this.props.chatChannelIdForNavigation ||
      this.props.params?.id ||
      channelIdFromSelection;

    const userID = String(this._bootstrap?.user?.id);
    const effectiveChatView = chatViewOverride !== null ? chatViewOverride : this.props.chatView;

    if (channelSubjectID === userID &&
      (channelTopicID === "main_office" || channelTopicID === "app_support")) {
      this.props.history.push("/chat", { from: "ChatScreen" });
    }
    else if (effectiveChatView === 'recent_activity') {
      this.props.history.push("/chat", { from: "ChatScreen" });
    }
    else if (effectiveChatChannelID != null && effectiveChatChannelID !== '') {
      this.props.history.push("/chat/" + effectiveChatChannelID + "/conversations", {
        from: "ChatScreen",
        ChatListSearchText: this.props.location?.state?.ChatListSearchText,
        ConversationsListSearchText: this.props.location?.state?.ConversationsListSearchText,
        ChatListPageNum: this.props.location?.state?.ChatListPageNum,
        ChatListPerPage: this.props.location?.state?.ChatListPerPage,
        ChatListOnlyShowUnread: this.props.location?.state?.ChatListOnlyShowUnread,
        ConversationsListOnlyShowUnread: this.props.location?.state?.ConversationsListOnlyShowUnread,
        ConversationsListOnlyShowMissingInfo: this.props.location?.state?.ConversationsListOnlyShowMissingInfo,
        ConversationsListPageNum: this.props.location?.state?.ConversationsListPageNum,
        ConversationsListPerPage: this.props.location?.state?.ConversationsListPerPage,
      });
    }
    else {
      this.props.history.push("/chat", { from: "ChatScreen" });
    }
  }

  markConversationUnread = async (e) => {
    e.stopPropagation()
    const { channel } = this.state;
    if (channel.lastReadMessageIndex === 0 || channel.lastReadMessageIndex === null) {
      channel.setAllMessagesUnread();
    }
    else {
      channel.updateLastReadMessageIndex(channel.lastReadMessageIndex - 1);
    }
    // Update the badge count after marking as unread
    setTimeout(async () => {
      // Check if component is still mounted and channel hasn't changed
      if (!this.mounted || this.state.channel !== channel) return;
      const unreadCount = await channel.getUnreadMessagesCount();
      if (unreadCount != null && this.props.updateUnreadBadgeCount) {
        this.props.updateUnreadBadgeCount(unreadCount);
      }
    }, 500);
  }

  setAssignedToAdmin = (admin) => {
    this.setState({ assignedToAdmin: admin })
  }

  setTextAreaText = (text) => {
    this.textAreaRef.current.value += text
    this.saveDraft();
  }

  setInternalTags = (tags) => {
    this.setState({ internalTags: tags })
  }

  ConfirmationDialogText = {
    mute_conversations: { title: 'Please confirm', body: 'Are you sure you wish to mute this conversation?', okButtonText: 'Confirm', cancelButtonText: 'Cancel' },
    unmute_conversations: { title: 'Please confirm', body: 'Are you sure you wish to unmute this conversation?', okButtonText: 'Confirm', cancelButtonText: 'Cancel' },
    delete_note: { title: 'Please confirm', body: 'Are you sure you wish to delete this note?', okButtonText: 'Delete', cancelButtonText: 'Cancel' },
    pause_guest_notifications: { title: 'Please confirm', body: `Are you sure you wish to pause notifications${andAiAutoReplies()} to this guest?${aiStillSuggests()}`, okButtonText: 'Confirm', cancelButtonText: 'Cancel' },
    unpause_guest_notifications: { title: 'Please confirm', body: `Are you sure you wish to unpause notifications${andAiAutoReplies()} to this guest?`, okButtonText: 'Confirm', cancelButtonText: 'Cancel' },
    delete_templated_msg: { title: 'Please confirm', body: 'Are you sure you wish to delete this templated message?', okButtonText: 'Delete', cancelButtonText: 'Cancel' },
    delete_templated_msg_topic: { title: 'Please confirm', body: `Are you sure you wish to delete this topic? It contains <b>{templatedMsgTopicInFocusNumAssociatedMsgs} message(s)</b>. Deleting the topic will leave those messages without a topic and label them as "<b>No topic assigned</b>"`, okButtonText: 'Delete', cancelButtonText: 'Cancel' },
    close_chatbot_settings: { title: 'Unsaved changes', body: 'You have unsaved changes to the chatbot settings. Are you sure you want to close without saving?', okButtonText: 'Close without saving', cancelButtonText: 'Cancel' },
    discard_note: { title: 'Unsaved note', body: 'Discard this note? What you typed will be lost.', okButtonText: 'Discard', cancelButtonText: 'Keep editing' },
  };

  confirmationDialogCancel = () => {
    this.setState({ confirmationDialogAction: null })
  };
  confirmationDialogConfirm = () => {
    console.log('confirm', this.state.confirmationDialogAction);
    switch (this.state.confirmationDialogAction) {
      case 'mute_conversations':
      case 'unmute_conversations':
        this.toggleNotificationLevel();
        break;
      case 'delete_note':
        this.deleteNote();
        break;
      case 'discard_note':
        this.discardNotesDraft();
        break;
      case 'pause_guest_notifications':
      case 'unpause_guest_notifications':
        this.gtuNotificationsUpdate();
        break;
      case 'delete_templated_msg':
          this.deleteTemplatedMsg();
          break;
      case 'delete_templated_msg_topic':
          this.deleteTemplatedMsgTopic();
          break;
      case 'close_chatbot_settings':
          // Close the pane and reset to original state
          this.resetChatbotSettingsToOriginal();
          this.setState({ showChatbotSettingsPanel: false }, () => {
            this.stopChatbotStatusPolling();
          });
          break;
      default:
        break;
    }
    this.confirmationDialogCancel();
  };

  handleToggleNotificationLevel = (ev) => {
    if (this.state.notificationLevel === 'default') {
      this.setState({ confirmationDialogAction: 'mute_conversations' })
    } else {
      this.setState({ confirmationDialogAction: 'unmute_conversations' })
    }
  };

  toggleNotificationLevel = async () => {
    //e.stopPropagation();

    if (this.state.notificationLevel === 'default') {
      this.state.notificationLevel = 'muted';
    }
    else {
      this.state.notificationLevel = 'default';
    }

    this.setState({ notificationLevel: this.state.notificationLevel })

    const { conversation_id } = this.state;
    const tw_identity = this._bootstrap?.user['twilio_identity']

    const params = { conversation_identifier: conversation_id, user_identity: tw_identity, notification_level: this.state.notificationLevel }

    const response = await axios.post(`${config.apiUrl}/chat/set_conversation_notification_level/`, params, reqConfig()).then(response => {
      //console.debug(this.state.channel.notificationLevel, " -- ", this.state.notificationLevel )
      this.props.refreshFromBackendFunc?.current()
    }).catch((error) => {
      if (error.response) {
        console.error("ChatScreen: Error setting notification level!")
        // sync back up with Twilio
        if (this.state.channel.notificationLevel !== this.state.notificationLevel) {
          this.setState({ notificationLevel: this.state.channel.notificationLevel })
        }
      }
    });
  }

  handleDeleteNote = (ev, id) => {
    this.setState({ confirmationDialogAction: 'delete_note', noteInFocusID: id })
  };

  deleteNote = async () => {
    const { conversation_id } = this.state;
    //disableMuiButton(deleteRef.current);
    (async () => {
      try {
        const dataAPI = this.props.dataAPI;

        //const res = await dataAPI(DELETE, this.conversationNotesResource + "/" + conversation_id, { data: {note_id: this.state.noteInFocusID} });
        const res = await dataAPI(DELETE, this.conversationNotesResource + "/" + conversation_id, { id: this.state.noteInFocusID });
        if (res.statusCode === 204) {
          var idx = this.state.notesList.findIndex(item => item.id === this.state.noteInFocusID);
          if (idx > -1) {
            this.state.notesList.splice(idx, 1);
            this.setState({
              numNotes: this.state.numNotes - 1,
              notesList: this.state.notesList
            })
          }
        }
        if (res.statusCode === 406 || res.statusCode === 404) {
          if (res.data && res.data.message) {
            this.props.enqueueSnackbar(res.data.message, { variant: 'error', autoHideDuration: 5000 });
          } else {
            this.props.enqueueSnackbar('Error deleting note', { variant: 'error' });
          }
        } else {
          this.props.enqueueSnackbar('Note deleted', { variant: 'default' });
        }
      } catch (e) {
        this.props.enqueueSnackbar('Error deleting note', { variant: 'error' });
      } finally {
      }
    })();
  }

  handleDeleteTemplatedMsg = (id) => {
    this.setState({ confirmationDialogAction: 'delete_templated_msg', templatedMsgInFocusID: id })
  };

  handleDeleteTemplatedMsgTopic = (id, num_associated_templated_messages) => {
    this.setState({ confirmationDialogAction: 'delete_templated_msg_topic', templatedMsgTopicInFocusID: id, templatedMsgTopicInFocusNumAssociatedMsgs: num_associated_templated_messages })
  };

  handleDebugMessage = async ({ recompute = false } = {}) => {
    this.setState({ debugLoading: true, debugDialogOpen: true });
    
    try {
      const u_id = String(this._bootstrap?.user?.id);
      const params = {
        message_idx: this.state.selectedMsgIdx, 
        conversation_sid: this.state.channel?.sid, 
        user_id: u_id,
        ...(recompute && { recompute: true }),
      };
      
      const response = await axios.post(`${config.apiUrl}/chat/debug_message/`, params, reqConfig());
      console.debug('Debug message response:', response);
      
      this.setState({ 
        debugSummary: response.data,
        debugLoading: false 
      });
    } catch (error) {
      console.error('Error debugging message:', error);
      this.setState({ 
        debugSummary: { error: 'Failed to load debug information' },
        debugLoading: false 
      });
    }
  };

  handleCloseDebugDialog = () => {
    this.setState({ 
      debugDialogOpen: false, 
      debugSummary: null 
    });
  };

  isSelectedMessageFromGuest = () => {
    try {
      const selectedIdx = this.state.selectedMsgIdx;
      if (selectedIdx == null) {
        return false;
      }
      const messages = this.state.messages || [];
      // Twilio messages expose .index; guard for potential .state.index as well
      const selectedMessage = messages.find(m => (m && (m.index === selectedIdx || m.state?.index === selectedIdx)));
      const authorIdentity = selectedMessage?.author;
      if (!authorIdentity) {
        return false;
      }
      const participants = this.state.participantsList || [];
      const authorParticipant = participants.find(p => p?.twilio_identity === authorIdentity);
      return authorParticipant?.conversation_role === 'guest';
    } catch (e) {
      return false;
    }
  }

  isSelectedMessageOwn = () => {
    try {
      const selectedIdx = this.state.selectedMsgIdx;
      if (selectedIdx == null) {
        return false;
      }
      const messages = this.state.messages || [];
      const selectedMessage = messages.find(m => (m && (m.index === selectedIdx || m.state?.index === selectedIdx)));
      const authorIdentity = selectedMessage?.author;
      const myIdentity = this._bootstrap?.user?.['twilio_identity'];
      return !!authorIdentity && !!myIdentity && authorIdentity === myIdentity;
    } catch (e) {
      return false;
    }
  }


  deleteTemplatedMsg = async () => {
    try {
      const res = await this.props.dataAPI(DELETE, "templated_chat_messages", { id: this.state.templatedMsgInFocusID });
      console.log("RES", res.statusCode, res.status)
      if (res.statusCode === 204) {
        this.updateTemplatedMsgRefreshKey()
        this.props.enqueueSnackbar('Templated message deleted', { variant: 'default' });
      }
      if (res.statusCode === 406 || res.statusCode === 404) {
        if (res.data && res.data.message) {
          this.props.enqueueSnackbar(res.data.message, { variant: 'error', autoHideDuration: 5000 });
        } else {
          this.props.enqueueSnackbar('Error deleting templated message', { variant: 'error' });
        }
      } else {
      }
    } catch (e) {
      this.props.enqueueSnackbar('Error deleting templated message', { variant: 'error' });
    } finally {
    }
  }

  deleteTemplatedMsgTopic = async () => {
    try {
      const res = await this.props.dataAPI(DELETE, "templated_chat_message_topics", { id: this.state.templatedMsgTopicInFocusID });
      console.log("Delete templated_chat_message_topics result:", res.statusCode, res.status)
      if (res.statusCode === 204) {
        this.updateTemplatedMsgRefreshKey()
        this.props.enqueueSnackbar('Templated message deleted', { variant: 'default' });
      }
      if (res.statusCode === 406 || res.statusCode === 404) {
        if (res.data && res.data.message) {
          this.props.enqueueSnackbar(res.data.message, { variant: 'error', autoHideDuration: 5000 });
        } else {
          this.props.enqueueSnackbar('Error deleting templated message', { variant: 'error' });
        }
      } else {
      }
    } catch (e) {
      this.props.enqueueSnackbar('Error deleting templated message', { variant: 'error' });
    } finally {
    }
  }

  toggleParticipantsList = (e, msgIdx = null) => {
    e.stopPropagation();
    const should_show = !this.state.showParticipantsList;
    if (should_show) {
      this.updateUsersFromCPBackend();
      if (msgIdx != null) {
        this.fetchSelectedMsgReceipts(msgIdx);
      }
    }
    this.setState({
      showParticipantsList: should_show,
      selectedMsgIdx: msgIdx,
      selectedMsgReceipts: null
    })
  }

  // CP-7814: who opened the selected message themselves vs. was marked read by a teammate
  fetchSelectedMsgReceipts = async (msgIdx) => {
    const { conversation_id } = this.state;
    try {
      const res = await this.props.dataAPI(GET_ONE, 'chat/message_read_receipts', {
        id: conversation_id,
        filter: { message_idx: msgIdx },
        keepSessionOn403: true,
      });
      // Discard if the panel moved on (another message or conversation) while this was in flight
      if (this.state.conversation_id !== conversation_id || this.state.selectedMsgIdx !== msgIdx) {
        return;
      }
      if (res.statusCode >= 400) {
        return; // the panel keeps the read-horizon status
      }
      this.setState({ selectedMsgReceipts: indexReceipts(res.data) });
    } catch (e) {
      console.warn("ChatScreen: could not load read receipts", e);
    }
  }

  toggleNotesPane = (e) => {
    e.stopPropagation();
    this.setState({ showNotesPane: !this.state.showNotesPane })
  }

  toggleTemplatedMessagesPane = (e) => {
    e.stopPropagation();
    this.setState({ showTemplatedMessagesPane: !this.state.showTemplatedMessagesPane })
  }

  closeTemplatedMessagesPane = () => {
    this.setState({ showTemplatedMessagesPane: false })
  }

  fetchChatbotStatus = async () => {
    const { conversation_id } = this.state;
    if (!conversation_id || this.fetchingChatbotStatusRef.current) return;
    
    // Don't fetch if we just saved (within last 2 seconds) to prevent overwriting saved state
    // This gives the backend time to process the save
    if (this.chatbotStatusLastSavedRef.current) {
      const timeSinceSave = Date.now() - this.chatbotStatusLastSavedRef.current;
      if (timeSinceSave < 2000) {
        console.log("Skipping chatbot status fetch because we just saved");
        return;
      }
    }
    
    this.fetchingChatbotStatusRef.current = true;
    const dataAPI = this.props.dataAPI;
    try {
      const res = await dataAPI(GET_ONE, 'chat/conversation_chatbot_status', { id: conversation_id });
      if (res.statusCode === 200 && res.data) {
        const isPaused = res.data.chatbot_is_active === false;
        const pausedUntil = res.data.chatbot_is_paused_until ? new Date(res.data.chatbot_is_paused_until) : null;
        const isStopped = isPaused && !pausedUntil; // Stopped if paused but no resume time
        
        const newPauseChatbot = isPaused && !isStopped;
        const newStopChatbot = isStopped;
        
        // Calculate pause duration from pausedUntil if available
        // Note: We estimate the original duration from remaining time, as we don't store the original selection
        let pauseDuration = 10; // default
        if (pausedUntil) {
          const now = new Date();
          const diffMinutes = Math.round((pausedUntil - now) / (1000 * 60));
          if (diffMinutes > 0) {
            // Find closest matching duration option (round up to nearest option)
            const durationOptions = [5, 10, 15, 30, 60, 120, 240];
            pauseDuration = durationOptions.find(d => d >= diffMinutes) || durationOptions[durationOptions.length - 1];
          }
        }
        
        // Update state with fetched values
        // Don't overwrite user changes if pane is open and there are unsaved changes
        const hasUnsavedChanges = this.state.showChatbotSettingsPanel && this.hasChatbotSettingsChanged();
        
        const currentState = this.state;
        const shouldUpdateToggles = !hasUnsavedChanges && (
          currentState.pauseChatbot !== newPauseChatbot ||
          currentState.stopChatbot !== newStopChatbot ||
          currentState.pauseChatbotDuration !== pauseDuration ||
          (currentState.chatbotResumeDateTime?.getTime() !== pausedUntil?.getTime() &&
           !(currentState.chatbotResumeDateTime === null && pausedUntil === null))
        );
        
        // Always update saved state (for icon display), but only update toggle state if no unsaved changes
        const pauseMeta = this.chatbotPauseMetaState(res.data);
        const shouldUpdateSavedState = (
          currentState.savedPauseChatbot !== newPauseChatbot ||
          currentState.savedStopChatbot !== newStopChatbot ||
          Object.keys(pauseMeta).some((key) => currentState[key] !== pauseMeta[key])
        );

        if (shouldUpdateToggles || shouldUpdateSavedState) {
          const updateState = {};
          if (shouldUpdateToggles) {
            // Update toggle state only if no unsaved changes
            updateState.pauseChatbot = newPauseChatbot;
            updateState.stopChatbot = newStopChatbot;
            updateState.chatbotResumeDateTime = pausedUntil;
            updateState.pauseChatbotDuration = pauseDuration;
          }
          if (shouldUpdateSavedState) {
            // Always update saved state (for icon + tooltip)
            updateState.savedPauseChatbot = newPauseChatbot;
            updateState.savedStopChatbot = newStopChatbot;
            Object.assign(updateState, pauseMeta);
          }
          this.setState(updateState);
        }
      } else if (res.statusCode >= 400 && res.statusCode < 600) {
        console.error('Error fetching chatbot status:', res.statusCode);
        // Don't show snackbar here as this is a background fetch
      }
    } catch (error) {
      console.error('Error fetching chatbot status:', error);
      // Don't show snackbar here as this is a background fetch
    } finally {
      this.fetchingChatbotStatusRef.current = false;
    }
  }

  openTrainResponsePanel = (message, prevMsg) => {
    // Get the question from the previous message
    let question = "";
    if (prevMsg && prevMsg.body) {
      question = prevMsg.body.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
    }
    
    // Get the most recent suggested edit from the current user, or use the original response
    let response = message.body ? message.body.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim() : "";
    let notes = "";
    let existingSuggestedEditId = null;
    let hasUserSuggestedEdit = false;
    try {
      const currentUserId = this._bootstrap?.user?.id;
      if (currentUserId) {
        const attributes = typeof message.attributes === 'string' 
          ? JSON.parse(message.attributes)
          : message.attributes;
        
        const aiFeedback = attributes?.ai_feedback;
        if (aiFeedback?.feedback_entries && Array.isArray(aiFeedback.feedback_entries)) {
          const currentUserIdNum = Number(currentUserId);
          // Check if user has any suggested edit (same logic as ChatItem for green pencil)
          hasUserSuggestedEdit = aiFeedback.feedback_entries.some(
            (entry) => entry.feedback_type === 'suggested_edit' && Number(entry.reviewed_by_id) === currentUserIdNum
          );
          
          // Find all suggested edits from current user, sorted by created_ts (most recent first)
          const userSuggestedEdits = aiFeedback.feedback_entries
            .filter(entry => entry.feedback_type === 'suggested_edit' && Number(entry.reviewed_by_id) === currentUserIdNum)
            .sort((a, b) => new Date(b.created_ts) - new Date(a.created_ts));
          
          if (userSuggestedEdits.length > 0) {
            const mostRecentEdit = userSuggestedEdits[0];
            if (mostRecentEdit.suggested_edit_text) {
              response = mostRecentEdit.suggested_edit_text;
            }
            // Get notes from the most recent edit if available
            if (mostRecentEdit.notes) {
              notes = mostRecentEdit.notes;
            }
            // Try multiple possible ID field names
            // Check explicitly for undefined/null, as 0 could be a valid ID
            if (mostRecentEdit.id !== undefined && mostRecentEdit.id !== null) {
              existingSuggestedEditId = mostRecentEdit.id;
            } else if (mostRecentEdit.feedback_id !== undefined && mostRecentEdit.feedback_id !== null) {
              existingSuggestedEditId = mostRecentEdit.feedback_id;
            } else if (mostRecentEdit.pk !== undefined && mostRecentEdit.pk !== null) {
              existingSuggestedEditId = mostRecentEdit.pk;
            }
          }
        }
      }
    } catch (error) {
      console.error('Error getting suggested edit:', error);
    }
    
    this.setState({
      showTrainResponsePanel: true,
      trainingMessage: message,
      trainingQuestion: question,
      trainingResponse: response,
      trainingNotes: notes,
      originalTrainingResponse: response,
      originalTrainingNotes: notes,
      existingSuggestedEditId: existingSuggestedEditId,
      hasUserSuggestedEdit: hasUserSuggestedEdit
    });
  }

  // Translate an inbound ChatMessage into the operator's preferred language.
  // Identifies the message by (twilio_msg_idx, twilio_conversation_sid) — the same
  // (idx, sid) pair the AI feedback flow uses.
  translateMessage = async (message) => {
    const dataAPI = this.props.dataAPI;
    if (!dataAPI || !this.state.channel) {
      return { error: "Translation isn't available right now." };
    }
    // target_lang is omitted: the backend defaults to request.user.lang.
    const res = await dataAPI(CREATE, 'chat/translate_message', {
      data: {
        twilio_msg_idx: message.index,
        twilio_conversation_sid: this.state.channel.sid,
      },
    });
    if (res?.statusCode >= 200 && res.statusCode < 300) {
      return res.data;
    }
    const detail = res?.data?.detail || res?.data?.error || `Couldn't translate (${res?.statusCode}).`;
    return { error: detail };
  };

  // Translate the operator's current draft. Used both for "Preview in customer language"
  // (targetLang = subjectUserLanguage) and for "Translate to my language" on the AI suggestion
  // chip (targetLang = bootstrap.user.lang).
  openDraftTranslationPreview = async (anchorEl, targetLang) => {
    const text = this.textAreaRef.current?.value?.trim();
    if (!text) {
      this.props.enqueueSnackbar?.('Type a reply first, then preview.', { variant: 'info' });
      return;
    }
    // targetLang may be null/undefined — the backend will resolve from request.user.lang,
    // falling back to DEFAULT_LANG. We surface whatever the backend resolves in state.
    this.setState({
      draftTranslationAnchorEl: anchorEl,
      draftTranslationLoading: true,
      draftTranslationError: null,
      draftTranslationText: null,
      draftTranslationLang: targetLang || null,
    });
    try {
      const body = { text };
      if (targetLang) body.target_lang = targetLang;
      const res = await this.props.dataAPI(CREATE, 'chat/translate_draft', { data: body });
      if (res?.statusCode >= 200 && res.statusCode < 300 && res.data?.translated_text) {
        this.setState({
          draftTranslationText: res.data.translated_text,
          draftTranslationLang: res.data.target_lang || targetLang || null,
          draftTranslationLoading: false,
        });
      } else {
        const detail = res?.data?.detail || res?.data?.error || `Couldn't translate (${res?.statusCode}).`;
        this.setState({ draftTranslationLoading: false, draftTranslationError: detail });
      }
    } catch (e) {
      console.warn("ChatScreen.openDraftTranslationPreview:", e);
      this.setState({
        draftTranslationLoading: false,
        draftTranslationError: e?.message || "Couldn't translate.",
      });
    }
  };

  closeDraftTranslationPreview = () => {
    this.setState({
      draftTranslationAnchorEl: null,
      draftTranslationText: null,
      draftTranslationLang: null,
      draftTranslationLoading: false,
      draftTranslationError: null,
    });
  };

  // Replace the textarea contents with the translated draft. Only meaningful
  // when the popover was opened with target_lang = customer language; should
  // NOT be exposed when the popover was opened from the AI-suggestion chip
  // (where the target is the operator's own language, and replacing would
  // mean sending the customer a reply in the wrong language).
  useDraftTranslation = () => {
    const translated = this.state.draftTranslationText;
    if (!translated || !this.textAreaRef.current) {
      return;
    }
    this.textAreaRef.current.value = translated;
    // Mimic the side-effects of a normal text change so the Send button enables.
    this.handleTypingChange({ target: this.textAreaRef.current });
    this.closeDraftTranslationPreview();
  };

  closeTrainResponsePanel = () => {
    this.setState({
      showTrainResponsePanel: false,
      trainingMessage: null,
      trainingQuestion: "",
      trainingResponse: "",
      trainingNotes: "",
      originalTrainingResponse: "",
      originalTrainingNotes: "",
      existingSuggestedEditId: null,
      hasUserSuggestedEdit: false,
      savingTrainResponse: false
    });
  }

  handleSaveTrainResponse = async () => {
    if (!this.state.trainingResponse.trim()) {
      this.props.enqueueSnackbar('Please enter a response', { variant: 'warning' });
      return;
    }

    if (this.state.savingTrainResponse) {
      return; // Prevent multiple submissions
    }

    const message = this.state.trainingMessage;
    if (!message || !this.state.channel) {
      this.props.enqueueSnackbar('Error: Message or conversation not found', { variant: 'error' });
      return;
    }

    const dataAPI = this.props.dataAPI;
    const feedbackResource = 'tour_operator/ai_auto_reply_feedback';

    this.setState({ savingTrainResponse: true });

    try {
      let res;
      if (this.state.existingSuggestedEditId) {
        // Update existing suggested edit
        const updateId = typeof this.state.existingSuggestedEditId === 'string' 
          ? parseInt(this.state.existingSuggestedEditId, 10) 
          : this.state.existingSuggestedEditId;
        res = await dataAPI(UPDATE, feedbackResource, {
          id: updateId,
          data: {
            suggested_edit_text: this.state.trainingResponse.trim(),
            notes: this.state.trainingNotes.trim() || null
          }
        });
      } else {
        // Create new suggested edit
        res = await dataAPI(CREATE, feedbackResource, {
          data: {
            twilio_msg_idx: message.index,
            twilio_conversation_sid: this.state.channel.sid,
            feedback_type: 'suggested_edit',
            suggested_edit_text: this.state.trainingResponse.trim(),
            notes: this.state.trainingNotes.trim() || null
          }
        });
      }
      
      if (res.statusCode >= 200 && res.statusCode < 300) {
        // Update the message's local state to immediately reflect the change
        if (message.updateSuggestedEditState) {
          message.updateSuggestedEditState(true);
        }
        this.props.enqueueSnackbar('Response saved for training', { variant: 'success' });
        this.closeTrainResponsePanel();
      } else {
        console.error('Error saving training response - response:', res);
        const errorMessage = res?.data?.detail || res?.data?.message || res?.data?.error || `Failed to save training response (${res.statusCode})`;
        this.props.enqueueSnackbar(errorMessage, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error saving training response:', error);
      const errorMessage = error?.json?.detail || error?.json?.message || error?.json?.error || error?.message || 'Failed to save training response';
      this.props.enqueueSnackbar(errorMessage, { variant: 'error' });
    } finally {
      this.setState({ savingTrainResponse: false });
    }
  }

  handleDeleteTrainResponse = async () => {
    if (!this.state.existingSuggestedEditId) {
      return;
    }

    const dataAPI = this.props.dataAPI;
    const feedbackResource = 'tour_operator/ai_auto_reply_feedback';

    this.setState({ savingTrainResponse: true });

    try {
      const res = await dataAPI(DELETE, feedbackResource, { id: this.state.existingSuggestedEditId });
      
      if (res.statusCode >= 200 && res.statusCode < 300) {
        // Update the message's local state to immediately reflect the change
        const message = this.state.trainingMessage;
        if (message && message.updateSuggestedEditState) {
          message.updateSuggestedEditState(false);
        }
        this.props.enqueueSnackbar('Suggested edit deleted', { variant: 'success' });
        this.closeTrainResponsePanel();
      } else {
        const errorMessage = res?.data?.detail || res?.data?.message || `Failed to delete suggested edit (${res.statusCode})`;
        this.props.enqueueSnackbar(errorMessage, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error deleting suggested edit:', error);
      const errorMessage = error?.json?.detail || error?.message || 'Failed to delete suggested edit';
      this.props.enqueueSnackbar(errorMessage, { variant: 'error' });
    } finally {
      this.setState({ savingTrainResponse: false });
    }
  }

  handleThumbsUpFeedback = async (message) => {
    if (!message || !this.state.channel) {
      this.props.enqueueSnackbar('Error: Message or conversation not found', { variant: 'error' });
      return;
    }

    const dataAPI = this.props.dataAPI;
    const feedbackResource = 'tour_operator/ai_auto_reply_feedback';

    // Check if user has already given thumbs up
    let existingFeedbackId = null;
    try {
      const currentUserId = this._bootstrap?.user?.id;
      if (currentUserId) {
        const attributes = typeof message.attributes === 'string' 
          ? JSON.parse(message.attributes)
          : message.attributes;
        
        const aiFeedback = attributes?.ai_feedback;
        if (aiFeedback?.feedback_entries && Array.isArray(aiFeedback.feedback_entries)) {
          const currentUserIdNum = Number(currentUserId);
          const existingEntry = aiFeedback.feedback_entries.find(
            (entry) => entry.feedback_type === 'thumbs_up' && Number(entry.reviewed_by_id) === currentUserIdNum
          );
          if (existingEntry && existingEntry.id) {
            existingFeedbackId = existingEntry.id;
          }
        }
      }
    } catch (error) {
      console.error('Error checking existing feedback:', error);
    }

    try {
      let res;
      if (existingFeedbackId) {
        // Delete existing feedback
        res = await dataAPI(DELETE, feedbackResource, { id: existingFeedbackId });
        
        if (res.statusCode >= 200 && res.statusCode < 300) {
          // Update local state in ChatItem to change color immediately
          if (message.updateThumbsUpState) {
            message.updateThumbsUpState(false);
          }
          this.props.enqueueSnackbar('Feedback removed', { variant: 'success' });
        } else {
          const errorMessage = res?.data?.detail || res?.data?.message || `Failed to remove feedback (${res.statusCode})`;
          this.props.enqueueSnackbar(errorMessage, { variant: 'error' });
        }
      } else {
        // Create new feedback
        res = await dataAPI(CREATE, feedbackResource, {
          data: {
            twilio_msg_idx: message.index,
            twilio_conversation_sid: this.state.channel.sid,
            feedback_type: 'thumbs_up'
          }
        });
        
        if (res.statusCode >= 200 && res.statusCode < 300) {
          // Update local state in ChatItem to change color immediately
          if (message.updateThumbsUpState) {
            message.updateThumbsUpState(true);
          }
          this.props.enqueueSnackbar('Feedback saved', { variant: 'success' });
        } else {
          // Check if it's a duplicate feedback error (400)
          if (res.statusCode === 400 || res?.data?.detail?.includes('already exists')) {
            this.props.enqueueSnackbar('You have already provided feedback for this message', { variant: 'info' });
          } else {
            const errorMessage = res?.data?.detail || res?.data?.message || `Failed to save feedback (${res.statusCode})`;
            this.props.enqueueSnackbar(errorMessage, { variant: 'error' });
          }
        }
      }
    } catch (error) {
      console.error('Error handling thumbs up feedback:', error);
      // Check if it's a duplicate feedback error (400)
      if (error?.statusCode === 400 || error?.json?.detail?.includes('already exists')) {
        this.props.enqueueSnackbar('You have already provided feedback for this message', { variant: 'info' });
      } else {
        const errorMessage = error?.json?.detail || error?.message || 'Failed to save feedback';
        this.props.enqueueSnackbar(errorMessage, { variant: 'error' });
      }
    }
  }

  toggleChatbotSettingsPanel = (e) => {
    if (e) e.stopPropagation();
    const willShow = !this.state.showChatbotSettingsPanel;
    
    // If closing the pane, check for unsaved changes
    if (!willShow && this.hasChatbotSettingsChanged()) {
      // Show confirmation dialog before closing with unsaved changes
      this.setState({ confirmationDialogAction: 'close_chatbot_settings' });
      return;
    }
    
    this.setState({ showChatbotSettingsPanel: willShow }, () => {
      if (willShow) {
        // Store original state when opening pane (for cancel functionality)
        this.originalChatbotState = {
          pauseChatbot: this.state.pauseChatbot,
          stopChatbot: this.state.stopChatbot,
          pauseChatbotDuration: this.state.pauseChatbotDuration,
          chatbotResumeDateTime: this.state.chatbotResumeDateTime
        };
        // Track if pause was toggled (for showing dropdown when toggled off and back on)
        this.pauseWasToggled = false;
        // Don't fetch immediately - use existing state from initializeChatScreen
        // The background polling will keep it updated, and we'll fetch when pane opens
        // only if we need to (via the polling that starts below)
        // Start polling to check if pause expires while pane is open
        // This will also do an initial fetch
        this.startChatbotStatusPolling();
      } else {
        // Stop polling when pane closes
        this.stopChatbotStatusPolling();
        // Reset to original state if closing without saving
        this.resetChatbotSettingsToOriginal();
      }
    });
  }

  resetChatbotSettingsToOriginal = () => {
    // Reset to original values (from when pane was opened)
    if (this.originalChatbotState) {
      this.setState({
        pauseChatbot: this.originalChatbotState.pauseChatbot,
        stopChatbot: this.originalChatbotState.stopChatbot,
        pauseChatbotDuration: this.originalChatbotState.pauseChatbotDuration,
        chatbotResumeDateTime: this.originalChatbotState.chatbotResumeDateTime
      });
    }
    this.pauseWasToggled = false; // Reset toggle tracking when canceling/closing
  }

  startChatbotStatusPolling = () => {
    // Clear any existing interval
    this.stopChatbotStatusPolling();
    
    // Poll every 10 seconds to check if pause has expired while pane is open
    // Don't do an initial fetch - use the existing state from initializeChatScreen
    // The state comparison in fetchChatbotStatus will prevent unnecessary updates
    this.chatbotStatusPollIntervalRef.current = setInterval(() => {
      if (this.state.showChatbotSettingsPanel) {
        this.fetchChatbotStatus();
      }
    }, 10000); // 10 seconds
  }

  stopChatbotStatusPolling = () => {
    if (this.chatbotStatusPollIntervalRef.current) {
      clearInterval(this.chatbotStatusPollIntervalRef.current);
      this.chatbotStatusPollIntervalRef.current = null;
    }
  }

  startContinuousChatbotStatusPolling = () => {
    // Poll every 30 seconds to update icon status (even when pane is closed)
    // This is separate from the pane-specific polling
    if (!this.continuousChatbotStatusPollIntervalRef) {
      this.continuousChatbotStatusPollIntervalRef = setInterval(() => {
        // Skip polling when the tab is hidden to save network requests
        if (document.hidden) return;
        // Only fetch if we have a conversation and pane is not open
        // (when pane is open, the faster polling handles it)
        if (this.state.conversation_id && !this.state.showChatbotSettingsPanel) {
          this.fetchChatbotStatus();
        }
      }, 30000); // 30 seconds
    }
  }

  stopContinuousChatbotStatusPolling = () => {
    if (this.continuousChatbotStatusPollIntervalRef) {
      clearInterval(this.continuousChatbotStatusPollIntervalRef);
      this.continuousChatbotStatusPollIntervalRef = null;
    }
  }

  startAiProcessingPolling = () => {
    this.stopAiProcessingPolling();
    this.aiProcessingPollStartTimeRef = Date.now();
    this.aiProcessingPollIntervalRef = setInterval(async () => {
      if (!this.mounted) {
        this.stopAiProcessingPolling();
        return;
      }
      if (Date.now() - this.aiProcessingPollStartTimeRef > 120000) {
        this.stopAiProcessingPolling();
        this.setState({ aiIsProcessing: false });
        return;
      }
      try {
        await this.fetchConversationInfo();
      } catch (err) {
        // Polling refresh; fetchConversationInfo can throw on HTTP errors now
        console.warn("ChatScreen: AI-processing poll conversation info failed:", err);
      }
    }, 5000);
  }

  stopAiProcessingPolling = () => {
    if (this.aiProcessingPollIntervalRef) {
      clearInterval(this.aiProcessingPollIntervalRef);
      this.aiProcessingPollIntervalRef = null;
      this.aiProcessingPollStartTimeRef = null;
    }
  }

  calculateResumeDateTime = (minutes) => {
    if (!minutes || minutes < 0) return null;
    const resumeDate = new Date();
    resumeDate.setMinutes(resumeDate.getMinutes() + minutes);
    return resumeDate;
  }

  handlePauseChatbotChange = (checked) => {
    const { pauseChatbotDuration } = this.state;

    // Track that pause was toggled
    this.pauseWasToggled = true;

    if (checked) {
      // If pausing, disable stop and calculate resume time
      const resumeDateTime = this.calculateResumeDateTime(pauseChatbotDuration);
      this.setState({ 
        pauseChatbot: true, 
        stopChatbot: false,
        chatbotResumeDateTime: resumeDateTime
      });
    } else {
      // When toggled OFF, just update local state (will be saved when SAVE is pressed)
      this.setState({ 
        pauseChatbot: false,
        chatbotResumeDateTime: null 
      });
    }
  }

  handleStopChatbotChange = (checked) => {
    if (checked) {
      // If stopping, disable pause
      this.setState({ 
        stopChatbot: true, 
        pauseChatbot: false,
        chatbotResumeDateTime: null
      });
    } else {
      // When toggled OFF, just update local state (will be saved when SAVE is pressed)
      this.setState({ 
        stopChatbot: false
      });
    }
  }

  handlePauseDurationChange = (minutes) => {
    const resumeDateTime = this.calculateResumeDateTime(minutes);
    this.setState({ 
      pauseChatbotDuration: minutes,
      chatbotResumeDateTime: resumeDateTime
    });
  }

  // Why the bot is quiet, as state, from any conversation payload that carries the
  // backend's chatbot_pause_meta fields. A backend that predates them omits the
  // keys: then keep what we have, unless the caller names what just happened
  // ('manual' = a stop/pause this user just saved, 'resumed' = they resumed it).
  chatbotPauseMetaState = (data, justDid = null) => {
    if (data && ('chatbot_pause_reason' in data)) {
      return {
        chatbotPauseReason: data.chatbot_pause_reason || null,
        chatbotPausedByName: data.chatbot_paused_by_name || null,
        chatbotPausedAt: data.chatbot_paused_at || null,
      };
    }
    if (justDid === 'resumed') {
      return { chatbotPauseReason: null, chatbotPausedByName: null, chatbotPausedAt: null };
    }
    if (justDid === 'manual') {
      const me = this._bootstrap?.user || {};
      return {
        chatbotPauseReason: 'manual',
        chatbotPausedByName: me.display_name || me.first_name || null,
        chatbotPausedAt: new Date().toISOString(),
      };
    }
    return {};
  }

  // Resume from the in-thread handoff marker: same call as the panel's Resume,
  // without opening or closing the panel.
  handleResumeFromThread = async () => {
    const { conversation_id } = this.state;
    if (!conversation_id || this.state.resumingChatbotFromThread) return;
    this.setState({ resumingChatbotFromThread: true });
    try {
      this.chatbotStatusLastSavedRef.current = Date.now();
      const res = await this.resumeChatbot(conversation_id);
      const resumed = {
        pauseChatbot: false,
        stopChatbot: false,
        chatbotResumeDateTime: null,
        savedPauseChatbot: false,
        savedStopChatbot: false,
        ...this.chatbotPauseMetaState(res?.data, 'resumed'),
      };
      if (this.originalChatbotState) {
        this.originalChatbotState = {
          pauseChatbot: false,
          stopChatbot: false,
          pauseChatbotDuration: this.state.pauseChatbotDuration,
          chatbotResumeDateTime: null
        };
      }
      this.setState(resumed);
      this.props.enqueueSnackbar('Chatbot resumed', { variant: 'success' });
    } catch (error) {
      this.props.enqueueSnackbar('Failed to resume chatbot', { variant: 'error' });
    } finally {
      this.setState({ resumingChatbotFromThread: false });
    }
  }

  // Missed-tour rebooking request (backend demo.lib.missed_tour_rebooking). Approve puts the
  // payment-link message in the composer for staff to finish; nothing is sent or charged here.
  resolveRebooking = async (action, edits = {}) => {
    const request = this.state.missedTourRebooking;
    if (!request || this.state.rebookingBusy) return;
    this.setState({ rebookingBusy: true });
    try {
      const res = await this.props.dataAPI(CREATE, `chat/missed_tour_rebooking/${request.id}`, {
        urlSuffix: 'resolve/',
        data: { action, ...edits },
      });
      if (res?.statusCode !== 200 || !res?.data) {
        const detail = res?.data?.detail || 'Could not update the rebooking request';
        this.props.enqueueSnackbar(detail, { variant: 'error' });
        if (res?.statusCode === 409) this.setState({ missedTourRebooking: null });
        return;
      }
      this.setState({ missedTourRebooking: null });
      if (action === 'approve' && res.data.confirmation_text && this.textAreaRef.current) {
        this.textAreaRef.current.value = res.data.confirmation_text;
        this.saveDraft();
        this.setState({ textAreaHasText: true, aiSuggestedReplyConfidence: null });
        this.props.enqueueSnackbar('Rebooking approved. Add the payment link to the message, then send it.', { variant: 'success' });
      } else {
        this.props.enqueueSnackbar(action === 'approve' ? 'Rebooking approved' : 'Rebooking request declined', { variant: 'success' });
      }
    } catch (error) {
      this.props.enqueueSnackbar('Could not update the rebooking request', { variant: 'error' });
    } finally {
      this.setState({ rebookingBusy: false });
    }
  }

  pauseChatbot = async (conversationUniqueName, minutes) => {
    const dataAPI = this.props.dataAPI;
    try {
      const res = await dataAPI(UPDATE, 'chat/conversation_chatbot_status', {
        id: conversationUniqueName,
        data: {
          is_paused: true,
          pause_for_minutes: (minutes == null || minutes < 0) ? null : minutes
        }
      });
      // Check for successful response
      if (res.statusCode === 200 || res.statusCode === 201) {
        return res;
      } else {
        // Non-success status code
        const error = new Error(`Failed to pause chatbot: ${res.statusCode}`);
        error.statusCode = res.statusCode;
        error.response = res;
        throw error;
      }
    } catch (error) {
      console.error('Error pausing chatbot:', error);
      throw error;
    }
  }

  stopChatbot = async (conversationUniqueName) => {
    const dataAPI = this.props.dataAPI;
    try {
      const res = await dataAPI(UPDATE, 'chat/conversation_chatbot_status', {
        id: conversationUniqueName,
        data: {
          is_paused: true,
          pause_for_minutes: null
        }
      });
      // Check for successful response
      if (res.statusCode === 200 || res.statusCode === 201) {
        return res;
      } else {
        // Non-success status code
        const error = new Error(`Failed to stop chatbot: ${res.statusCode}`);
        error.statusCode = res.statusCode;
        error.response = res;
        throw error;
      }
    } catch (error) {
      console.error('Error stopping chatbot:', error);
      throw error;
    }
  }

  resumeChatbot = async (conversationUniqueName) => {
    const dataAPI = this.props.dataAPI;
    try {
      const res = await dataAPI(UPDATE, 'chat/conversation_chatbot_status', {
        id: conversationUniqueName,
        data: {
          is_paused: false,
          pause_for_minutes: null
        }
      });
      // Check for successful response
      if (res.statusCode === 200 || res.statusCode === 201) {
        return res;
      } else {
        // Non-success status code
        const error = new Error(`Failed to resume chatbot: ${res.statusCode}`);
        error.statusCode = res.statusCode;
        error.response = res;
        throw error;
      }
    } catch (error) {
      console.error('Error resuming chatbot:', error);
      throw error;
    }
  }

  handleSaveChatbotSettings = async () => {
    const { conversation_id, pauseChatbot, stopChatbot, pauseChatbotDuration } = this.state;
    if (!conversation_id) return;

    // Set loading state
    this.setState({ savingChatbotSettings: true });

    try {
      let res;
      let savedState = null; // Track the state that was saved
      
      if (stopChatbot) {
        // Set cooldown immediately to prevent polling from interfering
        this.chatbotStatusLastSavedRef.current = Date.now();
        savedState = {
          chatbotResumeDateTime: null,
          pauseChatbot: false,
          stopChatbot: true,
          pauseChatbotDuration: pauseChatbotDuration,
          savedPauseChatbot: false,
          savedStopChatbot: true
        };
        res = await this.stopChatbot(conversation_id);
        Object.assign(savedState, this.chatbotPauseMetaState(res?.data, 'manual'));
        // Show snackbar immediately for better UX
        this.props.enqueueSnackbar('Chatbot stopped for this conversation', { variant: 'success' });
        // Update original state immediately so save button disables right away
        if (this.originalChatbotState) {
          this.originalChatbotState = {
            pauseChatbot: savedState.pauseChatbot,
            stopChatbot: savedState.stopChatbot,
            pauseChatbotDuration: savedState.pauseChatbotDuration,
            chatbotResumeDateTime: savedState.chatbotResumeDateTime
          };
        }
        this.setState(savedState);
      } else if (pauseChatbot) {
        // Set cooldown immediately to prevent polling from interfering
        this.chatbotStatusLastSavedRef.current = Date.now();
        res = await this.pauseChatbot(conversation_id, pauseChatbotDuration);
        const pausedMeta = this.chatbotPauseMetaState(res?.data, 'manual');
        // Show snackbar immediately for better UX
        this.props.enqueueSnackbar(
          pauseChatbotDuration < 0
            ? 'Chatbot paused indefinitely'
            : `Chatbot paused for ${pauseChatbotDuration} minutes`,
          { variant: 'success' }
        );
        // Update resume datetime from API response if available, otherwise calculate it
        const resumeDateTime = res.data?.chatbot_is_paused_until 
          ? new Date(res.data.chatbot_is_paused_until)
          : this.calculateResumeDateTime(pauseChatbotDuration);
        savedState = {
          pauseChatbot: true,
          stopChatbot: false,
          chatbotResumeDateTime: resumeDateTime,
          pauseChatbotDuration: pauseChatbotDuration,
          savedPauseChatbot: true,
          savedStopChatbot: false,
          ...pausedMeta,
        };
        // Update original state immediately so save button disables right away
        if (this.originalChatbotState) {
          this.originalChatbotState = {
            pauseChatbot: savedState.pauseChatbot,
            stopChatbot: savedState.stopChatbot,
            pauseChatbotDuration: savedState.pauseChatbotDuration,
            chatbotResumeDateTime: savedState.chatbotResumeDateTime
          };
        }
        this.pauseWasToggled = false; // Reset toggle tracking after save
        this.setState(savedState);
      } else {
        // Both toggles are OFF, resume the chatbot
        // Set cooldown immediately to prevent polling from interfering
        this.chatbotStatusLastSavedRef.current = Date.now();
        savedState = {
          pauseChatbot: false,
          stopChatbot: false,
          chatbotResumeDateTime: null,
          pauseChatbotDuration: pauseChatbotDuration,
          savedPauseChatbot: false,
          savedStopChatbot: false
        };
        res = await this.resumeChatbot(conversation_id);
        Object.assign(savedState, this.chatbotPauseMetaState(res?.data, 'resumed'));
        // Show snackbar immediately for better UX
        this.props.enqueueSnackbar('Chatbot resumed', { variant: 'success' });
        // Update original state immediately so save button disables right away
        if (this.originalChatbotState) {
          this.originalChatbotState = {
            pauseChatbot: savedState.pauseChatbot,
            stopChatbot: savedState.stopChatbot,
            pauseChatbotDuration: savedState.pauseChatbotDuration,
            chatbotResumeDateTime: savedState.chatbotResumeDateTime
          };
        }
        this.pauseWasToggled = false; // Reset toggle tracking after save
        this.setState(savedState);
      }
      // Note: originalChatbotState is updated immediately above (before setState) so save button disables right away
      // Panel stays open after saving - user can make more changes or close manually
    } catch (error) {
      this.props.enqueueSnackbar('Failed to update chatbot status', { variant: 'error' });
    } finally {
      // Clear loading state
      this.setState({ savingChatbotSettings: false });
    }
  }

  handleResumeNow = async () => {
    const { conversation_id } = this.state;
    if (!conversation_id) return;

    // Set loading state to show spinner on save button
    this.setState({ savingChatbotSettings: true });

    try {
      const res = await this.resumeChatbot(conversation_id);
      const newState = {
        pauseChatbot: false, 
        stopChatbot: false,
        chatbotResumeDateTime: null,
        // Update saved state since we just saved to backend
        savedPauseChatbot: false,
        savedStopChatbot: false,
        savingChatbotSettings: false,
        ...this.chatbotPauseMetaState(res?.data, 'resumed'),
      };
      // Update original state so unsaved changes check passes when closing panel
      if (this.originalChatbotState) {
        this.originalChatbotState = {
          pauseChatbot: false,
          stopChatbot: false,
          pauseChatbotDuration: this.state.pauseChatbotDuration,
          chatbotResumeDateTime: null
        };
      }
      this.setState(newState);
      this.props.enqueueSnackbar('Chatbot resumed', { variant: 'success' });
      this.toggleChatbotSettingsPanel();
    } catch (error) {
      this.setState({ savingChatbotSettings: false });
      this.props.enqueueSnackbar('Failed to resume chatbot', { variant: 'error' });
    }
  }

  hasChatbotSettingsChanged = () => {
    // Check if current state differs from original state
    if (!this.originalChatbotState) return false;
    
    const { pauseChatbot, stopChatbot, pauseChatbotDuration, chatbotResumeDateTime } = this.state;
    const original = this.originalChatbotState;
    
    return (
      pauseChatbot !== original.pauseChatbot ||
      stopChatbot !== original.stopChatbot ||
      pauseChatbotDuration !== original.pauseChatbotDuration ||
      (chatbotResumeDateTime?.getTime() !== original.chatbotResumeDateTime?.getTime() &&
       !(chatbotResumeDateTime === null && original.chatbotResumeDateTime === null))
    );
  }

  handleCancelChatbotSettings = () => {
    // Reset to original values (from when pane was opened)
    if (this.originalChatbotState) {
      this.setState({
        pauseChatbot: this.originalChatbotState.pauseChatbot,
        stopChatbot: this.originalChatbotState.stopChatbot,
        pauseChatbotDuration: this.originalChatbotState.pauseChatbotDuration,
        chatbotResumeDateTime: this.originalChatbotState.chatbotResumeDateTime
      });
    } else {
      // Fallback to defaults if original state wasn't stored
      this.setState({
        pauseChatbot: false,
        stopChatbot: false,
        pauseChatbotDuration: 10,
        chatbotResumeDateTime: null
      });
    }
    this.pauseWasToggled = false; // Reset toggle tracking when canceling
    this.toggleChatbotSettingsPanel();
  }

  toggleTagsEntry = (e) => {
    e.stopPropagation();
    this.setState({ showNotesPane: !this.state.showNotesPane })
  }

  setSelectedUserProfileID = (id) => {
    this.setState({ selectedUserProfileID: id })
  }

  updateTemplatedMsgRefreshKey = () => {
    this.setState({ templatedMsgRefreshKey: this.state.templatedMsgRefreshKey + 1 })
  }

  onUserProfileRowClick = () => {}

  formatPhoneNumber = (str) => {
    //Filter only numbers from the input
    let cleaned = ('' + str).replace(/\D/g, '');

    //Check if the input is of correct
    let match = cleaned.match(/^(\d{1,3})?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      //Remove the matched extension code
      //Change this to format for any country code.
      let intlCode = (match[1] ? '+' + match[1] + ' ' : '')
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }

    return null;
  }

  tourNameSubtext = () => {
    const { chatChannelTitle } = this.state;

    return (chatChannelTitle)
  }

  dateSubtext = () => {
    const { travelDate, tourTimezone, subjectCheckoutTs } = this.state;
    const lastDateOfTour = subjectCheckoutTs || this.state.lastDateOfTour;

    // CP-8136: a guide group's dates are an artifact of its tour modelling and
    // mean nothing (it never expires) -- same suppression as the chat-list rows
    // and the conversations-list header.
    if (this.props.isGuideGroupChannel === true) {
      return "";
    }
    if (isNaN(Date.parse(travelDate)) === true) {
      return "";
    }
    return tourDateRangeText(travelDate, lastDateOfTour, tourTimezone) || "";
  }

  tagsSubtext = () => {
    const { tourTags } = this.state;

    if (tourTags) {
      // Plain spans (no per-chip tooltip): the whole header subtext line carries a
      // single combined tooltip (see headerSubtextTooltip) so clipped chips stay
      // recoverable without nested tooltips.
      const tag_spans = tourTags.map(tag =>
        <span key={tag.id} style={headerTourTagStyle(tag.category === 'departure')}>{tag.data?.friendly_name || tag.name}</span>
      )
      return tag_spans
    }
  }

  // Combined hover content for the truncating header subtext line. The line can
  // clip tags and the PAX/+1 chip off the right edge, where a per-chip tooltip is
  // unreachable; rendering every chip here keeps them all recoverable on hover.
  // Returns a node (rendered as actual chips) so the tooltip mirrors the inline
  // tag styling; the chips drop their marginLeft and rely on the flex gap.
  headerSubtextTooltip = () => {
    const { tourTags, visibleOnlyChatTags } = this.state;
    const hasPax = this.state.subjectIsLeadBooker != null;
    const waiver = !!this.state.subjectWaiverSigned;
    const checkout = this.props.isGuideGroupChannel === true ? null : checkoutTimeLabel(this.state.subjectCheckoutTs, this.state.tourTimezone);
    const hasContent = tourTags?.length || visibleOnlyChatTags?.length || hasPax || waiver || checkout;
    if (!hasContent) return '';

    // Each row is a single self-contained chip: the category (for tour tags) and the
    // PAX/waiver details live *inside* the chip rather than as floating text beside it.
    const chipWrap = { whiteSpace: 'normal' };

    let paxLabel = '';
    let paxDetail = '';
    if (hasPax) {
      const isLead = this.state.subjectIsLeadBooker;
      const others = Math.max(0, (this.state.subjectPaxCount || 1) - 1);
      paxLabel = isLead ? `PAX: ${this.state.subjectPaxCount || 1}` : '+1';
      paxDetail = isLead
        ? `Lead Booker, +${others} passenger${others === 1 ? '' : 's'}`
        : (this.state.subjectLeadBookerName ? `${this.state.subjectLeadBookerName} +1` : 'Party member (+1)');
      if (waiver) paxDetail += ', Waiver signed';
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 4, maxWidth: 340 }}>
        {tourTags?.map((tag) => {
          const label = tagCategoryLabel(tag);
          const value = tag.data?.friendly_name || tag.name;
          return (
            <span key={`t${tag.id}`} style={{ ...headerTourTagStyle(tag.category === 'departure'), marginLeft: 0, ...chipWrap }}>
              {label ? <><b>{label}:</b> {value}</> : value}
            </span>
          );
        })}
        {visibleOnlyChatTags?.map((tag) => (
          <span key={`c${tag.id}`} style={{ ...headerChatTagStyle(), marginLeft: 0, ...chipWrap }}>{tag.data?.friendly_name || tag.name}</span>
        ))}
        {hasPax && (
          <span style={{ ...headerPaxStyle(true), marginLeft: 0, ...chipWrap }}><b>{paxLabel}</b> · {paxDetail}</span>
        )}
        {!hasPax && waiver && (
          <span style={{ ...headerPaxStyle(true), marginLeft: 0, ...chipWrap }}>Waiver signed</span>
        )}
        {checkout && (
          <span style={{ ...this.checkoutChipStyle(checkout), marginLeft: 0, ...chipWrap }}>{checkout.tooltip}</span>
        )}
      </div>
    );
  }

  checkoutChipStyle = (checkout) => ({
    ...headerPaxStyle(true),
    color: checkout.past ? chatColors.checkoutPastText : chatColors.checkoutText,
    background: checkout.past ? chatColors.checkoutPastBg : chatColors.checkoutBg,
  })

  navigate_to_on_trip_support = (e) => {

    //e.stopPropagation();

    const userID = String(this._bootstrap?.user?.id);

    const { conversation_id, chatChannelID, channelTopicID } = this.state;

    // Set the conversation to the user's associated on-trip support conversation
    const conversation_unique_name = `${channelTopicID}::${chatChannelID}::${userID}`

    //this.props.history.push("..", { from: "ChatScreen" });
    this.props.history.push(`../${conversation_unique_name}/interactivechat`, { from: "ChatScreen" });
  }

  // Calls our backend to ensure that the conversation is active_synced. If
  // include_user_id is true, the call is optimized to return faster (it syncs that user
  // first and returns a response before asyncronously syncing anyone else who needs synced) 
  fetchConversationNotes = async () => {
    console.debug("ChatScreen: fetching conversation notes...")

    const { conversation_id } = this.state;
    const dataAPI = this.props.dataAPI;
    const userID = String(this._bootstrap?.user?.id);
    const notesText = this.notesTextAreaRef?.current?.value;

    (async () => {
      try {
        const res = await dataAPI(GET_ONE, this.conversationNotesResource + "_list/" + conversation_id, {});

        if (res.statusCode === 200 || res.statusCode === 201) {
          console.info("Internal conversation notes fetched", res.data);
          this.setState({
            numNotes: res.data.results.length,
            notesList: res.data.results,
            shareWithGuideAvailable: res.data.share_with_guide_available === true,
            conversationNotesText: res.data.results[0]?.internal_notes,
            conversationNotesAuthor: res.data.results[0]?.author,
            conversationNotesLastUpdatedTS: res.data.results[0]?.updated_ts
          })
        } else if (res.statusCode === 406) {
          console.warn("Validation error when fetching internal conversation notes", res);
        }
        else {
          console.warn("Error when fetching internal conversation notes", res);
        }
      } finally {
        //this.setState({syncActive: false});
      }
    })();

  };

  // CP-8423: discard the unsaved draft in the notes pane (the pane stays open),
  // asking first when there is typed text so a stray click can't lose a note.
  handleNotesCancel = () => {
    const draft = this.notesTextAreaRef.current?.value || "";
    if (draft.trim()) {
      this.setState({ confirmationDialogAction: 'discard_note' });
      return;
    }
    this.discardNotesDraft();
  };

  discardNotesDraft = () => {
    if (this.notesTextAreaRef.current) this.notesTextAreaRef.current.value = "";
    this.setState({ conversationNotesTextHasChangedSinceLastSave: false });
  };

  handleNotesSave = (ev) => {
    const { conversation_id } = this.state;
    const dataAPI = this.props.dataAPI;
    const userID = String(this._bootstrap?.user?.id);
    const notesText = this.notesTextAreaRef.current.value;

    if (!notesText || !notesText.trim()) {
      if(this.notesTextAreaRef.current) this.notesTextAreaRef.current.value = ""
      this.setState({
        conversationNotesText: "",
        conversationNotesTextHasChangedSinceLastSave: false,
      })
      return
    }

    this.setState({ syncActive: true });
    //disableMuiButton(saveRef.current);
    (async () => {
      try {
        const res = await dataAPI(CREATE, this.conversationNotesResource + "/" + conversation_id, {
          data: {
            author_id: userID,
            twilio_conversation_unique_name: conversation_id,
            notes: notesText,
            share_with_guide: this.state.shareWithGuideAvailable && this.state.shareNewNoteWithGuide
          }
        });

        if (res.statusCode === 200 || res.statusCode === 201) {
          this.props.enqueueSnackbar(res.data.share_with_guide ? "Note saved and shared with the guide" : "Note saved", { variant: 'success' });
          var updatedNotesList = [res.data].concat(this.state.notesList)
          if(this.notesTextAreaRef.current) this.notesTextAreaRef.current.value = ""
          this.setState({
            conversationNotesText: "",
            conversationNotesTextHasChangedSinceLastSave: false,
            shareNewNoteWithGuide: false,
            conversationNotesAuthor: res.data.author,
            conversationNotesLastUpdatedTS: res.data.updated_ts,
            numNotes: this.state.numNotes + 1,
            notesList: updatedNotesList
          })

          console.log("Notes List:", this.state.notesList)
        } else if (res.statusCode === 406) {
          this.props.enqueueSnackbar("Note validation error", { variant: 'warning' });
          //setServerErrors(res.data.errors);
        }
        else {
          this.props.enqueueSnackbar("Error saving note", { variant: 'error' });
        }
      } finally {
        this.setState({ syncActive: false });
      }
    })();
    //}
  }

  // CP-8461: tick or untick "Share with guide pre-tour" on a saved note. Answers the saved note, or null.
  handleShareWithGuide = async (id, share) => {
    const { conversation_id } = this.state;
    const res = await this.props.dataAPI(UPDATE, this.conversationNotesResource + "/" + conversation_id, {
      id: id,
      data: { share_with_guide: share }
    });
    if (res.statusCode !== 200) {
      this.props.enqueueSnackbar("Couldn't change sharing with the guide", { variant: 'error' });
      return null;
    }
    this.props.enqueueSnackbar(share ? "Shared with the guide" : "No longer shared with the guide", { variant: 'success' });
    this.setState({ notesList: this.state.notesList.map(n => (n.id === id ? { ...n, ...res.data } : n)) });
    return res.data;
  };

  handleNotesUpdate = async (ev, id, updatedText) => {
    const { conversation_id } = this.state;
    const dataAPI = this.props.dataAPI;
    const userID = String(this._bootstrap?.user?.id);
    const notesText = updatedText;
    var updateWasSuccessful = false;

    if (!notesText || !notesText.trim()) {
      this.props.enqueueSnackbar("Note can't be empty", { variant: 'warning' });
      return false;
    }

    this.setState({ syncActive: true });

    await (async () => {
      try {
        const res = await dataAPI(UPDATE, this.conversationNotesResource + "/" + conversation_id, {
          id: id,
          data: {
            //author_id: userID,
            //twilio_conversation_unique_name: conversation_id,
            note_text: notesText
          }
        });

        if (res.statusCode === 200 || res.statusCode === 201) {
          this.props.enqueueSnackbar("Note saved", { variant: 'success' });
          if(this.notesTextAreaRef.current) this.notesTextAreaRef.current.value = ""

          var idx = this.state.notesList.findIndex(item => item.id === this.state.noteInFocusID);
          if (idx > -1) {
            this.state.notesList[idx] = notesText;
            this.setState({
              notesList: this.state.notesList
            })
          }
          console.log("Notes List:", this.state.notesList)
          updateWasSuccessful = true;
        }
        else if (res.statusCode === 406) {
          this.props.enqueueSnackbar("Note validation error", { variant: 'warning' });
          //setServerErrors(res.data.errors);
        }
        else {
          this.props.enqueueSnackbar("Error saving note", { variant: 'error' });
        }
      } finally {
        this.setState({ syncActive: false });
      }
    })();

    return updateWasSuccessful;
    //}
  }

  handleToggleGtuNotifications = (ev) => {
    if (this.state.gtuNotificationsPaused === true) {
      this.setState({ confirmationDialogAction: 'unpause_guest_notifications' })
    } else {
      this.setState({ confirmationDialogAction: 'pause_guest_notifications' })
    }
  };

  gtuNotificationsUpdate = async (ev) => {
    const { conversation_id } = this.state;
    const dataAPI = this.props.dataAPI;
    const userID = String(this._bootstrap?.user?.id);
    var updateWasSuccessful = false;

    this.setState({ syncActive: true });

    //await (async () => {
    const updated_state = !this.state.gtuNotificationsPaused

    const params = {
      twilio_conversation_unique_name: conversation_id,
      action: updated_state === true ? "PAUSE" : "UNPAUSE",
      user_id: userID
    }

    const response = await axios.post(`${config.apiUrl}/chat/pause_group_tour_user_notifications/`, params, reqConfig()).then(response => {
      this.setState({ gtuNotificationsPaused: updated_state });
      this.props.refreshFromBackendFunc?.current()
      updateWasSuccessful = true;
    }).catch((error) => {
      if (error.response) {
        this.props.enqueueSnackbar("Error pausing/unpausing guest notifications", { variant: 'error' });
        console.error("ChatScreen: Error pausing/unpausing guest notifications")
      }
    }).finally(() => {
      this.setState({ syncActive: false });
    });

    return updateWasSuccessful;
    // })
  }

  participantsListSortedByReadStatus = (participantsList, msgIdx, receipts = null) => {
    // Return cached result if inputs haven't changed
    const cache = this._participantsSortCache;
    if (cache.result && cache.participantsList === participantsList && cache.msgIdx === msgIdx && cache.receipts === receipts) {
      this.roleGroups = cache.roleGroups;
      this.roleLabels = cache.roleLabels;
      this.readStatusLabels = cache.readStatusLabels;
      this.firstParticipantIdToShow.current = cache.firstParticipantId;
      return cache.result;
    }

    // Sort by role, then by read status, then by name
    // if msgIdx is null, that means we are just showing 
    //the participants list, so don't sort by read status in that case
    this.roleGroups = this.resetRoleGroups();
    this.roleLabels = this.resetRoleLabels();
    this.readStatusLabels = this.resetReadStatusLabels();


    //if (msgIdx === null){
    //this.firstParticipantId.current = participantsList[0].id
    //return participantsList;
    //}

    let participantsListSorted = JSON.parse(JSON.stringify(participantsList))

    // CP-7814: read / marked read by a teammate / unread, with the read time, per participant
    if (msgIdx != null) {
      for (const p of participantsListSorted) {
        const { status, readAt, readViaName, readViaMarkAll } = participantReadStatus(p, msgIdx, receipts);
        p.read_status = status;
        p.read_at = readAt;
        p.read_via_name = readViaName;
        p.read_via_mark_all = readViaMarkAll;
      }
    }

    participantsListSorted.sort(function (a, b) {
      var keyA = a.conversation_role,
        keyB = b.conversation_role,
        keyC = STATUS_RANK[a.read_status] ?? STATUS_RANK[UNREAD],
        keyD = STATUS_RANK[b.read_status] ?? STATUS_RANK[UNREAD],
        keyE = a.display_name.toLowerCase(),
        keyF = b.display_name.toLowerCase();
      // Compare the 2 dates
      if (keyA === keyB || ((keyA === 'guide' || keyA === 'admin') && (keyB === 'guide' || keyB === 'admin'))) {
        if (msgIdx != null && keyC > keyD) {
          return -1;
        }
        else if (msgIdx != null && keyD > keyC) {
          return 1;
        }
        else {
          if (keyE < keyF) {
            return -1;
          }
          else if (keyE > keyF) {
            return 1;
          }
          else {
            return 0;
          }
        }
      }
      else if (keyA === 'guest' && (keyB === 'guide' || keyB === 'admin')) return -1;
      else if (keyA === 'guide' && keyB === 'admin') return -1;
      else return 1;
    });


    for (let i = 0; i < participantsListSorted.length; i++) {
      // Don't include current signed-in user in message details per CP-4024
      if (msgIdx != null && participantsListSorted[i].id === this._bootstrap?.user?.id) {
        continue;
      }
      const role_group_key = this.roleGroups[participantsListSorted[i].conversation_role]
      // Guard against unmapped/blank conversation_role: roleGroups only knows
      // guest/observer/guide/admin, and readStatusLabels only has guest/staff.
      // An unknown role would make role_group_key undefined and crash the render
      // (white screen) on the .id / .read accesses below.
      if (!role_group_key || !this.roleLabels[role_group_key] || !this.readStatusLabels[role_group_key]) {
        continue;
      }
      if (this.roleLabels[role_group_key]['id'] === null) {
        this.roleLabels[role_group_key]['id'] = participantsListSorted[i].id
        // Overwrite the "Guests" label if Main Office/App Support and role isn't actually guest
        if (participantsListSorted[i].is_admin && this.roleLabels[role_group_key]['label'] === "Guests") {
          this.roleLabels[role_group_key]['label'] = "Admins"
        }
        else if (participantsListSorted[i].is_guide && this.roleLabels[role_group_key]['label'] === "Guests") {
          this.roleLabels[role_group_key]['label'] = "Guides"
        }
      }

      // read / shared / unread bucket; the first participant of each bucket carries its heading
      const bucket = this.readStatusLabels[role_group_key][participantsListSorted[i].read_status || UNREAD];
      bucket['count']++;
      if (msgIdx != null && bucket['id'] === null) {
        bucket['id'] = participantsListSorted[i].id;
      }
    }

    if (!participantsListSorted || participantsListSorted.length === 0) {

    }
    else if (msgIdx != null && participantsListSorted[0].id === this._bootstrap?.user?.id) {
      if (participantsListSorted.length >= 2) {
        this.firstParticipantIdToShow.current = participantsListSorted[1].id
      }
    }
    else {
      this.firstParticipantIdToShow.current = participantsListSorted[0].id
    }

    // Cache the result and all side effects
    this._participantsSortCache = {
      participantsList,
      msgIdx,
      receipts,
      result: participantsListSorted,
      roleGroups: this.roleGroups,
      roleLabels: this.roleLabels,
      readStatusLabels: this.readStatusLabels,
      firstParticipantId: this.firstParticipantIdToShow.current
    };

    return participantsListSorted;
  }

  handleAttachmentDrop = (files_to_attach) => {
    if (this.props.selectedScreen === "ChatScreen") {
      this.attachFiles(files_to_attach);
    }
    else {
      this.props.enqueueSnackbar('Please select a conversation before attaching files', { variant: 'error' })
    }
  }

  render() {
    const { loading, textAreaHasText, messages, channel, conversation_name, visibleOnlyChatTags, conversation_id, channelSubjectID, channelTopicID, attachedFiles,
      participantsAvatarColorDict, participantsAvatarImgDict, travelDate, isSmallScreen, isMediumScreen, show1pageScreen } = this.state;
    //const { location } = this.props;
    //const { state } = location || {};
    const userID = String(this._bootstrap?.user?.id);
    const tw_identity = this._bootstrap?.user['twilio_identity']
    // Index (in `messages`) of the most recent web-widget handoff, if any: the
    // in-thread marker under that one carries the live chatbot state + Resume.
    const latestHandoffIndex = messages ? messages.map(isHandoffMessage).lastIndexOf(true) : -1;

    if (this.state.conversationOpenError) {
      const noAccess = this.state.conversationOpenError === "no_access";
      const deleted = this.state.conversationOpenError === "deleted";
      const connectivity = this.state.conversationOpenError === "connectivity";
      return (
        <Container component="main" style={{
          minWidth: 350,
          display: (show1pageScreen && this.props.selectedScreen !== "ChatScreen") ? "none" : "flex",
          alignItems: "center",
          justifyContent: "center",
        }} >
          <div style={{ textAlign: "center", marginTop: "25vh", maxWidth: 420 }}>
            <Typography variant="h6" style={{ marginBottom: 8 }}>
              {noAccess ? "You don't have access to this conversation"
                : deleted ? "This conversation is no longer available"
                : connectivity ? "We couldn't reach the chat service"
                : "We couldn't open this conversation"}
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 24 }}>
              {noAccess
                ? "If you believe you should have access, please contact your administrator."
                : deleted
                ? "It has been deleted and can't be reopened. If you got here from a link or notification, it's out of date."
                : connectivity
                ? "Your connection to chat was interrupted. If this dashboard is open in another window or tab (even minimized), close it there — then check your internet connection and try again."
                : "We hit a sync issue and couldn't repair it automatically. Our team has been notified and is looking into it."}
            </Typography>
            {!noAccess && !deleted &&
              <Button variant="contained" color="primary" style={{ marginRight: 8 }}
                onClick={() => { this.setState({ conversationOpenError: null, loading: true }); this.initializeChatScreen(); }}>
                Try again
              </Button>
            }
            <Button variant="outlined"
              onClick={() => { this.setState({ conversationOpenError: null }); this.props.history?.replace("/chat"); }}>
              Back to chats
            </Button>
          </div>
        </Container>
      );
    }

    // see if the subject user is in the dictionary. If so, match their
    // avatar colors
    let avatarColor = "white";
    let avatarImg = null;

    let conversation_display_name = conversation_name;

    let showAnnouncementsHeader = false;
    let showGuidesAndStaffHeader = false;
    let showGroupChatHeader = false;
    let showMainOfficeHeader = false;
    let showAppSupportHeader = false;
    let showOnTripSupportHeader = false;

    if (channelSubjectID === "announcements") {
      showAnnouncementsHeader = true;
      conversation_display_name = "Announcements"
    }
    else if (channelSubjectID === "guides_and_staff") {
      // In a guide group every participant is staff, so this thread IS the group
      // chat and is labelled as such (CP-8136). The real Group Chat thread type is
      // guest-bearing by design, which is exactly why guide groups don't use it.
      if (this.props.isGuideGroupChannel) {
        showGroupChatHeader = true
        conversation_display_name = "Group Chat"
      } else {
        showGuidesAndStaffHeader = true
        conversation_display_name = "INTERNAL: Guides/Staff"
      }
    }
    else if (channelSubjectID === "group_chat") {
      showGroupChatHeader = true;
      conversation_display_name = "Group Chat"
    }
    else if (channelTopicID === "main_office" && userID === channelSubjectID) {
      showMainOfficeHeader = true
      if (this.userIsGuest === true) {
        conversation_display_name = "New Bookings";
      }
      else {
        conversation_display_name = "Main Office";
      }
    }
    else if (channelTopicID === "app_support" && userID === channelSubjectID) {
      showAppSupportHeader = true
      conversation_display_name = "App Support"
    }
    else if (userID === channelSubjectID) {
      showOnTripSupportHeader = true
      // A guide's own tour 1:1 is their line to the office -- titled "Manager",
      // matching the mobile apps (CP-8286).
      conversation_display_name = this.userIsGuide ? "Manager" : "Tour Guides/Support"
    }
    else {
      const user_profile_link = "/user/" + channelSubjectID;
      conversation_display_name = conversation_name;

      for (var user_identity in participantsAvatarColorDict) {
        const user_identity_parts = user_identity.split('_');
        const id_from_parts = user_identity_parts[user_identity_parts.length - 1]
        if (channelSubjectID === id_from_parts) {
          avatarColor = participantsAvatarColorDict[user_identity];
          avatarImg = participantsAvatarImgDict[user_identity];
        }
      }
    }

    const chatWindowCols = 12;
    const isRecentActivityView = this.props.chatView === 'recent_activity';

    return (
      
      <Container component="main" style={{
        paddingLeft: !show1pageScreen ? 0 : null,
        marginTop: show1pageScreen && isSmallScreen ? window.innerWidth < 500 ? "4px" : "4px" : show1pageScreen ? "18px" : null,
        // Single-page path: height is the *visual* viewport minus the app-bar
        // region. 100svh does not shrink when the iOS/Android keyboard opens,
        // so the composer (and send button) sat under the keyboard and
        // overflow:hidden on <main> made it untappable. --app-visual-height is
        // written from visualViewport (see layout/visualViewport.js).
        height: show1pageScreen ? mobileChatPaneHeight() : null,
        minWidth: 350,
        display: (show1pageScreen && this.props.selectedScreen !== "ChatScreen") ? "none" : null,
        flex: (isRecentActivityView && !show1pageScreen) ? 2 : undefined,
        marginLeft: (isRecentActivityView && show1pageScreen) ? 'auto' : (isRecentActivityView ? 0 : undefined),
        marginRight: (isRecentActivityView && show1pageScreen) ? 'auto' : (isRecentActivityView ? 0 : undefined),
      }} >
        {/*this.scrollToBottom()*/}
        <Backdrop open={loading} style={{ zIndex: 99999 }}>
          <CircularProgress style={{ color: "white" }} />
        </Backdrop>
        <Backdrop open={this.state.showNotesPane} style={{ zIndex: 10, backgroundColor: "rgba(15, 22, 48, .40)" }} onClick={e => this.toggleNotesPane(e)}>
        </Backdrop>
        <Backdrop open={this.state.showParticipantsList} style={{ zIndex: 10, backgroundColor: "rgba(15, 22, 48, .40)" }} onClick={e => this.toggleParticipantsList(e)}>
        </Backdrop>
        <Backdrop open={this.state.showTemplatedMessagesPane} style={{ zIndex: 10, backgroundColor: "rgba(15, 22, 48, .40)" }} onClick={e => this.setState({askToCloseTemplatedmessagesPaneKey: this.state.askToCloseTemplatedmessagesPaneKey + 1})}>
        </Backdrop>
        <Backdrop open={this.state.showChatbotSettingsPanel} style={{ zIndex: 10, backgroundColor: "rgba(15, 22, 48, .40)" }} onClick={e => this.toggleChatbotSettingsPanel(e)}>
        </Backdrop>
        <Backdrop open={this.state.showTrainResponsePanel} style={{ zIndex: 10, backgroundColor: "rgba(15, 22, 48, .40)" }} onClick={e => this.closeTrainResponsePanel(e)}>
        </Backdrop>
        <CssBaseline />

        {/* Single-page path: cap the grid at the definite height the Container
            passes down so the chat column can flex-shrink on short viewports.
            maxHeight (not height) so short content creates no free space —
            the INTERNAL TAGS wrapper below has flex-grow 3 and would balloon
            into it. nowrap because MUI Grid containers default to wrap, which
            would push the overflowing column into a second flex line. */}
        <Grid container direction="column" style={show1pageScreen ? { ...styles.mainGrid, maxHeight: "100%", minHeight: 0, flexWrap: "nowrap" } : styles.mainGrid}>
          {
            this.state.showNotesPane ?
              <div xs={12 - chatWindowCols} style={{ position: "absolute", width: "90%", right: 0, height: "100%", border: `1px solid ${cv('border', 'rgb(224, 224, 224)')}`, backgroundColor: cv('surface', 'white'), zIndex: 11, padding: "2%", borderRadius: "16px" }} >
                <span style={{ position: "absolute", left: 0, top: 0, height: "50px", width: "100%", backgroundColor: cv('surface-muted', '#F5F5F5'), borderRadius: "15px 15px 0px 0px" }}>
                  <span style={{ fontSize: "1rem", lineHeight: "50px", paddingLeft: "16px", fontWeight: 600 }}>Notes ({this.state.numNotes})</span>
                  <span onClick={e => this.toggleNotesPane(e)} style={styles.closeButton}>&times;</span>
                </span>


                {!this.userIsGuest ?
                  <Grid item style={{ flex: 3, marginTop: "55px" }} ref={this.notesOverlayInputRef}>

                    <TextField
                      label="Internal Notes"
                      inputRef={this.notesTextAreaRef}
                      style={styles.textField}
                      placeholder="Enter a note (will not be visible to guests)"
                      variant="outlined"
                      multiline
                      minRows={3}
                      maxRows={6}
                      //defaultValue={this.state.conversationNotesText}
                      InputLabelProps={{ shrink: true }}
                      onChange={(event) => {
                        if (this.state.conversationNotesTextHasChangedSinceLastSave === false && event.target.value !== "") {
                          this.setState({ conversationNotesTextHasChangedSinceLastSave: true })
                        }
                        if (this.state.conversationNotesTextHasChangedSinceLastSave === true && event.target.value === "") {
                          this.setState({ conversationNotesTextHasChangedSinceLastSave: false })
                        }
                        // Handle if border for text area should be hidden (hide it if the text area grows past the boundary of the border)
                        setTimeout(() => {
                          if (this.state.notesOverlayInputHeight !== this.notesOverlayInputRef.current?.clientHeight) {
                            this.setState({ notesOverlayInputHeight: this.notesOverlayInputRef.current?.clientHeight })
                          }
                        }, 5);
                      }
                      }
                    />
                    {this.state.shareWithGuideAvailable ?
                      <Tooltip arrow placement="bottom-start" title="Guide notes pass this note to the departure's guides word for word: in the pre-tour notes, or as an update if they already went out.">
                        <FormControlLabel
                          sx={{ ml: 0, mt: 0.5 }}
                          label="Share with guide pre-tour"
                          control={
                            <Checkbox
                              size="small"
                              checked={this.state.shareNewNoteWithGuide}
                              onChange={(ev) => this.setState({ shareNewNoteWithGuide: ev.target.checked })}
                              inputProps={{ 'aria-label': 'Share with guide pre-tour' }}
                            />
                          }
                        />
                      </Tooltip> : ""
                    }

                  </Grid> : ""
                }

                {!this.userIsGuest ?
                  <FormActionButtons
                    mode="edit"
                    size="large"
                    sx={{ my: 0.5 }}
                    submitRef={this.notesSaveButtonRef}
                    submitDisabled={!this.state.conversationNotesTextHasChangedSinceLastSave}
                    onSubmit={this.handleNotesSave}
                    onCancel={this.handleNotesCancel}
                    cancelDisabled={!this.state.conversationNotesTextHasChangedSinceLastSave}
                  />
                  : ("")}
                {/*(!this.userIsGuest && this.state.conversationNotesLastUpdatedTS) ?
                  <span style={{ alignSelf: "flex-end", fontSize: "0.75em" }}>Last updated: {new Date(this.state.conversationNotesLastUpdatedTS).toLocaleString()} by {this.state.conversationNotesAuthor.display_name}</span>
                : ("")*/}

                {!this.userIsGuest && this.state.notesList && this.state.notesList.length > 0 ?
                  <Grid item style={{ flex: 3 }}>

                    <Grid item xs={chatWindowCols} style={styles.notesItemListInOverlay(this.notesOverlayInputRef.current?.clientHeight)}>
                      <List dense={true}>
                        {this.state.notesList &&
                          this.state.notesList.map((note, index, arr) => {
                            const prevMsg = arr[index - 1];
                            const nextMsg = arr[index + 1];
                            return (
                              <div key={note.id}>
                                {(() => {
                                  return ((index === 0 || new Date(prevMsg.updated_ts).toDateString() !== new Date(note.updated_ts).toDateString()) ?
                                    <DateSeparator followingGap={6}>
                                      {new Date(note.updated_ts).toLocaleDateString('en-gb', { weekday: "short", month: "long", day: "numeric" })}
                                    </DateSeparator> : "")
                                })()}
                                <NotesItem
                                  key={note.id}
                                  message={note}
                                  tw_identity={tw_identity}
                                  //scrollToBottom={this.scrollToBottom}
                                  participantsDict={this.state.participantsDict}
                                  participantsRoleDict={this.state.participantsRoleDict}
                                  colorPalette={this.palette}
                                  participantsAvatarColorDict={this.state.participantsAvatarColorDict}
                                  participantsAvatarImgDict={this.state.participantsAvatarImgDict}
                                  getUserFromTwilio={this.getUserFromTwilio}
                                  prevMsg={prevMsg}
                                  nextMsg={nextMsg}
                                  showNotesPane={this.state.showNotesPane}
                                  handleDeleteNote={this.handleDeleteNote}
                                  handleNotesUpdate={this.handleNotesUpdate}
                                  shareWithGuideAvailable={this.state.shareWithGuideAvailable}
                                  handleShareWithGuide={this.handleShareWithGuide}
                                  noteID={note.id}
                                >
                                </NotesItem>
                              </div>
                            )
                          })}
                      </List>
                    </Grid>
                  </Grid> : ("")}

              </div> : ""
          }

          {this.state.showParticipantsList ?
            <div xs={12 - chatWindowCols} style={{ position: "absolute", width: "90%", right: 0, height: "100%", border: `1px solid ${cv('border', 'rgb(212, 212, 212)')}`, backgroundColor: cv('surface', 'white'), zIndex: 11, padding: "2%", borderRadius: "16px" }} >
              <span style={{ position: "absolute", left: 0, top: 0, height: "50px", width: "100%", backgroundColor: cv('surface-muted', '#F5F5F5'), borderRadius: "15px 15px 0px 0px" }}>
                <span style={{ fontSize: "1rem", lineHeight: "50px", paddingLeft: "16px", fontWeight: 600 }}>{this.state.selectedMsgIdx == null ? "Participants" : "Message Status"}</span>
                <span onClick={e => this.toggleParticipantsList(e)} style={styles.closeButton}>&times;</span>
              </span>
              {this.state.selectedMsgIdx != null && (this.hasChatDeletePerm || (this.hasChatDeleteOwnPerm && this.isSelectedMessageOwn()) || this.props.hasPerm('ai', 'write')) ?
                <div style={{ marginTop: "44px", marginBottom: "-40px", marginLeft: "2px", display: "flex", alignItems: "center" }}>
                  {/* CP-5545: disabled, not hidden, without the delete permission for this message. */}
                  <DeleteMessageAction
                    as="div"
                    disabled={!(this.hasChatDeletePerm || (this.hasChatDeleteOwnPerm && this.isSelectedMessageOwn()))}
                    messageIdx={this.state.selectedMsgIdx}
                    conversationSID={this.state.channel?.sid}
                    onDeleted={(id) => {
                      this.setState({
                        showParticipantsList: false,
                      });
                      this.initializeChatScreen();
                      this.props.refreshFromBackendFunc?.current();
                      this.setState({
                        showParticipantsList: false,
                      });
                    }}
                  />
                  {/* TODO: consider a dedicated 'ai','debug' permission instead of 'ai','write' */}
                  {this.props.hasPerm('ai', 'write') && this.isSelectedMessageFromGuest() && (
                    <>
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => this.handleDebugMessage()}
                        disabled={this.state.debugLoading}
                        style={{ marginLeft: "auto" }}
                      >
                        {this.state.debugLoading ? "Loading..." : "AI Analyze Message"}
                      </Button>
                      {this.userIsAppSupport && (
                        <Tooltip title="Recompute AI analysis" arrow placement="top"><span>
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => this.handleDebugMessage({ recompute: true })}
                          disabled={this.state.debugLoading}
                          style={{ marginRight: "20px" }}
                        >
                          <ReloadIcon fontSize="small" />
                        </IconButton>
                        </span></Tooltip>
                      )}
                    </>
                  )}
                  <Divider sx={{ my: 0.5 }} />
                </div>
                : ("")}
              <DataGridPro
                sx={{
                  flex: 16,
                  borderRadius: 0,
                  marginTop: "45px",
                  maxHeight: this.state.selectedMsgIdx != null && (this.hasChatDeletePerm || (this.hasChatDeleteOwnPerm && this.isSelectedMessageOwn()) || this.props.hasPerm('ai', 'write')) ? "calc(100% - 94px)" : "calc(100% - 50px)",
                  '&, [class^=MuiDataGrid]': { border: 'none' },
                  "& .MuiDataGrid-columnHeaders": { display: "none" },
                  "& .MuiDataGrid-virtualScroller": { marginTop: "0!important" },
                  //"& .MuiDataGrid-main": {
                  //  border: "none",
                  //},
                }}
                style={{ border: `0px solid ${cv('border', 'rgb(212, 212, 212)')}` }}
                getRowId={(row) => row.id}
                filterMode="client"
                paginationMode="client"
                sortingMode={"client"}
                hideFooter={true}
                // Row virtualization is the insertion and removal of rows as the grid scrolls vertically.
                // Disabling it can hurt performance, but there shouldn't be enough rows here to 
                // cause too many issues.
                // Without 'disableVirtualization' set, scrolling here is very jumpy
                disableVirtualization
                onRowClick={this.onUserProfileRowClick}
                columns={[
                  {
                    field: 'display_name', headerName: 'Members', sortable: true, flex: 6, renderCell: p => {
                      const thisUserProfileIsSelected = (this.state.selectedUserProfileID === p.row.id);
                      const smallScreenSizeReduction = !show1pageScreen ? 0 : 4;
                      const imgSize = thisUserProfileIsSelected ? 51 - smallScreenSizeReduction : 30 - smallScreenSizeReduction;
                      const avatarColor = p.row.avatar ? null : this.state.participantsAvatarColorDict[p.row.twilio_identity];
                      const imgUrl = p.row.avatar ? images.url(this.props.settings.images.base, p.row.avatar, `cover_${imgSize}x${imgSize}`) : null;

                      let userIsYou = false;
                      if (tw_identity === p.row.twilio_identity) {
                        userIsYou = true;
                      }
                      if (this.state.selectedMsgIdx != null && userIsYou) {
                        return ("")
                      }

                      return (
                        <span style={styles.userProfileRow(thisUserProfileIsSelected)}>
                          {(() => {


                            let rowRoleLabel = null;
                            const role_group_key = this.roleGroups[p.row.conversation_role];
                            let role_group_key_plural = this.roleGroups[p.row.conversation_role] === "staff" ? this.roleGroups[p.row.conversation_role] : this.roleGroups[p.row.conversation_role] + "s";
                            if (p.row.is_admin && role_group_key_plural === "guests") {
                              role_group_key_plural = "admins"
                            }
                            else if (p.row.is_guide && role_group_key_plural === "guests") {
                              role_group_key_plural = "guides"
                            }

                            let role_total = 0;
                            let rowReadStatusLabel = null;
                            let rowReadStatusLabelColor = null;
                            let rowReadStatusSubtext = null;

                            // roleGroups knows guest/observer/guide/admin, but readStatusLabels/roleLabels
                            // only have guest/staff — observers (and any unmapped/blank role) have no entry.
                            // The sort loop skips those participants (see the guard where counts are tallied),
                            // yet renderCell still runs for them, so guard here too or these lookups crash the
                            // whole render (white screen) on undefined['read'].
                            const roleStats = role_group_key ? this.readStatusLabels[role_group_key] : undefined;
                            const roleLabelInfo = role_group_key ? this.roleLabels[role_group_key] : undefined;
                            if (roleStats && roleLabelInfo) {
                              role_total = roleStats['read']['count'] + roleStats['shared']['count'] + roleStats['unread']['count'];

                              if (p.row.id === roleLabelInfo['id']) {
                                rowRoleLabel = roleLabelInfo['label'] + ' (' + role_total + ')';
                              }
                              if (p.row.id === roleStats['read']['id']) {
                                let pct = 100 * roleStats['read']['count'] / role_total
                                pct = pct.toFixed(0)
                                rowReadStatusLabel = roleStats['read']['label'] + ' ' + pct + "%";
                                rowReadStatusSubtext = roleStats['read']['count'] + "/" + role_total + " of " + role_group_key_plural + " read"
                                rowReadStatusLabelColor = "primary";
                              }
                              else if (p.row.id === roleStats['shared']['id']) {
                                let pct = 100 * roleStats['shared']['count'] / role_total
                                pct = pct.toFixed(0)
                                rowReadStatusLabel = roleStats['shared']['label'] + ' ' + pct + "%";
                                rowReadStatusSubtext = roleStats['shared']['count'] + "/" + role_total + " of " + role_group_key_plural + " were marked read without opening it"
                              }
                              else if (p.row.id === roleStats['unread']['id']) {
                                let pct = 100 * roleStats['unread']['count'] / role_total
                                pct = pct.toFixed(0)
                                rowReadStatusLabel = roleStats['unread']['label'] + ' ' + pct + "%";
                                rowReadStatusSubtext = roleStats['unread']['count'] + "/" + role_total + " of " + role_group_key_plural + " didn\'t read or status unknown"
                              }
                            }


                            let friendlyName = p.row.display_name;
                            let roleSubtext = "";
                            if (this.userIsGuest === true) {
                              //shortened display name aims to hide last name from view
                              friendlyName = p.row.shortened_display_name;
                            }



                            // "You" indicator change per Bozana's recommendation in 
                            // "Updated Chat QA" Google Chat threaded space (11/28/22)
                            if (p.row.conversation_role === "admin") {
                              roleSubtext = userIsYou ? "You, Admin" : "Admin";
                            }
                            else if (p.row.conversation_role === "guide") {
                              roleSubtext = userIsYou ? "You, Guide" : "Guide";
                            }
                            else if (p.row.conversation_role === "observer") {
                              roleSubtext = userIsYou ? "You, Observer" : "Observer";
                            }
                            else if (p.row.conversation_role === "guest" && p.row.is_admin === true) {
                              roleSubtext = userIsYou ? "You, Admin" : "Admin";
                            }
                            else if (p.row.conversation_role === "guest" && p.row.is_guide === true) {
                              roleSubtext = userIsYou ? "You, Guide" : "Guide";
                            }
                            else if (p.row.conversation_role === "guest") {
                              roleSubtext = userIsYou ? "You" : "";
                            }
                            else if (userIsYou === true) {
                              roleSubtext = "You";
                            }

                            //const user_profile_link = p.row.gtu_id ? "/trip/" + this.state.channelTopicID + "/users/manager/" + p.row.gtu_id + "/{}" : "/user/" + p.row.id
                            const user_profile_link = "/user/" + p.row.id
                            const participant_display_name = userIsYou ? <span>{friendlyName}{" (You)"}</span> : friendlyName
                            if (this.state.selectedUserProfileID === p.row.id) {
                              return (
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", flexShrink: 0 }}>
                                  <Avatar name={friendlyName} style={{ marginRight: 12 }} size={imgSize} round={true} src={imgUrl} color={avatarColor} maxInitials={1} textSizeRatio={2} />

                                  <Typography style={{ marginTop: 6 }}>
                                    <a href={user_profile_link} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}>{(() => { return (userIsYou ? <b>{friendlyName}</b> : friendlyName) })()}</a>
                                    <br />
                                    {p.row.email}
                                    <br />
                                    <a href={"tel:" + this.formatPhoneNumber(p.row.phone) || p.row.phone}>{this.formatPhoneNumber(p.row.phone) || p.row.phone}</a>
                                  </Typography>
                                </div>
                              )
                            }
                            else {
                              return (
                                <span style={{ width: "100%" }}>
                                  {rowReadStatusLabel && p.row.id !== this.firstParticipantIdToShow.current ? <hr background-color="#eee" border="0 none" color="#eee" height="1px" /> : ""}
                                  {rowRoleLabel ? <div style={{ fontWeight: "600", fontSize: "17px", marginBottom: rowReadStatusLabel ? null : 4 }}>{rowRoleLabel}</div> : ""}
                                  {rowReadStatusLabel ? <div><DoneAllIcon fontSize="small" color={rowReadStatusLabelColor || "default"} /><span style={{ fontWeight: "500" }}>&nbsp;{rowReadStatusLabel}</span></div> : ""}
                                  {rowReadStatusSubtext ? <div style={{ marginBottom: 12, fontSize: 12 }}>{rowReadStatusSubtext}</div> : ""}

                                  <span style={{ display: "flex", flexDirection: "row", alignItems: "center", flexShrink: 0 }}>
                                    <span style={{ width: imgSize, marginRight: 12 }}>
                                      <Avatar name={friendlyName} size={imgSize} round={true} src={imgUrl} color={avatarColor} maxInitials={1} textSizeRatio={2} />
                                    </span>
                                    <span style={{ width: "100%" }}>
                                      <Typography style={{ fontSize: show1pageScreen ? "12px" : null, display: "inline-block", maxWidth: !this.props.show1pageScreen === true ? "12vw" : "65vw", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                                        <Tooltip title={`Open ${friendlyName}'s profile`} arrow placement="top-start"><a style={{ color: cv('text', 'black') }} href={user_profile_link} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}>{participant_display_name}</a></Tooltip>
                                      </Typography>
                                      <Typography style={{ fontSize: show1pageScreen ? "12px" : null, display: "inline-block", float: "right" }}>
                                        {p.row.phone ? <Tooltip title={"Call " + (this.formatPhoneNumber(p.row.phone) || p.row.phone)} arrow placement="top"><a style={{ color: cv('accent', '#007AFF'), textDecoration: "none", fontWeight: "600", fontFamily: "Roboto", fontSize: '.9rem' }} href={"tel:" + this.formatPhoneNumber(p.row.phone) || p.row.phone}>CALL</a></Tooltip> : ""}
                                      </Typography>
                                      {/* CP-7814: when this person read the selected message */}
                                      {this.state.selectedMsgIdx != null && readAtText({ status: p.row.read_status, readAt: p.row.read_at, readViaName: p.row.read_via_name, readViaMarkAll: p.row.read_via_mark_all }) ?
                                        <Typography style={{ fontSize: show1pageScreen ? "10px" : "12px", color: cv('text-muted', "#6c757d") }}>
                                          {readAtText({ status: p.row.read_status, readAt: p.row.read_at, readViaName: p.row.read_via_name, readViaMarkAll: p.row.read_via_mark_all })}
                                        </Typography> : ""}
                                      {/*
                                      <Typography style={{ fontSize: show1pageScreen ? "10px" : ".9em", color: "#6c757d" }}>
                                        {(() => { return (userIsYou ? <b>{roleSubtext}</b> : roleSubtext) })()}
                                      </Typography>
                                      */}
                                    </span>
                                  </span>
                                </span>
                              )
                            }
                          })()}
                        </span>)
                    }
                  },
                ]}
                getRowHeight={() => 'auto'}
                //disableSelectionOnClick={disableSelectionOnClick}
                density="compact"
                rows={this.participantsListSortedByReadStatus(this.state.participantsList, this.state.selectedMsgIdx, this.state.selectedMsgReceipts)}

                //loading={loading || props.relatedLoading}
                localeText={{ noRowsLabel: <MoonLoader size={35} color={cv('accent', '#007AFF')} /> }}
              />
            </div>

            : ("")
          }
          {this.state.showChatbotSettingsPanel ?
            <div style={{ position: "absolute", width: "90%", right: 0, height: "100%", border: `1px solid ${cv('border', 'rgb(212, 212, 212)')}`, backgroundColor: cv('surface', 'white'), zIndex: 11, padding: "24px", borderRadius: "16px", maxWidth: "500px", display: "flex", flexDirection: "column" }} onClick={e => e.stopPropagation()}>
              <span style={{ position: "absolute", left: 0, top: 0, height: "50px", width: "100%", backgroundColor: cv('surface-muted', '#F5F5F5'), borderRadius: "15px 15px 0px 0px" }}>
                <span style={{ fontSize: "1rem", lineHeight: "50px", paddingLeft: "16px", fontWeight: 600 }}>Chatbot status</span>
                <span onClick={e => this.toggleChatbotSettingsPanel(e)} style={styles.closeButton}>&times;</span>
              </span>
              <div style={{ marginTop: "50px", padding: "0 0px", flex: 1, overflowY: "auto" }}>
                <Typography style={{ fontSize: "0.875rem", color: cv('text', '#000'), marginBottom: "24px", lineHeight: "1.5" }}>
                  Quickly change chatbot status so it doesn't interfere with your conversation.
                </Typography>
                
                <Divider style={{ marginBottom: "24px", backgroundColor: cv('border', '#E0E0E0') }} />
                
                <div style={{ marginBottom: "24px" }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.pauseChatbot}
                        onChange={(e) => this.handlePauseChatbotChange(e.target.checked)}
                        size="small"
                      />
                    }
                    label={
                      <div>
                        <Typography style={{ fontWeight: 600, fontSize: "0.875rem", marginBottom: "4px" }}>
                          Pause chatbot
                        </Typography>
                        <Typography style={{ fontSize: "0.75rem", color: cv('text-secondary', '#666'), lineHeight: "1.4", marginBottom: this.state.pauseChatbot ? "12px" : "0" }}>
                          Temporarily suspend chatbot for this conversation. It will automatically resume after the selected time.
                        </Typography>
                        {this.state.pauseChatbot && (
                          <div style={{ marginTop: "12px" }}>
                            {(!this.state.savedPauseChatbot || (this.originalChatbotState && (this.state.pauseChatbot !== this.originalChatbotState.pauseChatbot || this.pauseWasToggled))) && (
                              <FormControl size="small" style={{ minWidth: 200, marginBottom: "8px" }}>
                                <InputLabel id="pause-duration-label">Reactivate chatbot after:</InputLabel>
                                <Select
                                  labelId="pause-duration-label"
                                  label="Reactivate chatbot after:"
                                  value={this.state.pauseChatbotDuration}
                                  onChange={(e) => this.handlePauseDurationChange(Number(e.target.value))}
                                >
                                  <MenuItem value={5}>5 min</MenuItem>
                                  <MenuItem value={10}>10 min</MenuItem>
                                  <MenuItem value={15}>15 min</MenuItem>
                                  <MenuItem value={30}>30 min</MenuItem>
                                  <MenuItem value={60}>60 min</MenuItem>
                                  <MenuItem value={120}>120 min</MenuItem>
                                  <MenuItem value={240}>240 min</MenuItem>
                                  <MenuItem value={PAUSE_CHATBOT_UNLIMITED}>Unlimited</MenuItem>
                                </Select>
                              </FormControl>
                            )}
                            {this.state.chatbotResumeDateTime && this.state.savedPauseChatbot && (
                              <div style={{ marginTop: "8px" }}>
                                <Typography style={{ fontSize: "0.75rem", color: cv('text-secondary', '#666'), marginBottom: "4px" }}>
                                  Chatbot will resume activity {this.state.chatbotResumeDateTime.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}, {this.state.chatbotResumeDateTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}
                                </Typography>
                                <Link
                                  onClick={this.handleResumeNow}
                                  style={{
                                    color: cv('accent', '#007AFF'),
                                    textDecoration: "underline",
                                    fontSize: "0.75rem",
                                    cursor: "pointer"
                                  }}
                                >
                                  Resume now
                                </Link>
                              </div>
                            )}
                            {!this.state.chatbotResumeDateTime && this.state.pauseChatbot && !this.state.savedPauseChatbot && (
                              <div style={{ marginTop: "8px" }}>
                                <Typography style={{ fontSize: "0.75rem", color: cv('text-secondary', '#666'), marginBottom: "4px" }}>
                                  {this.state.pauseChatbotDuration < 0
                                    ? 'The chatbot will stay off until you resume it.'
                                    : 'Select a duration above to see when the chatbot will resume.'}
                                </Typography>
                              </div>
                            )}
                            {!this.state.chatbotResumeDateTime && this.state.pauseChatbot && this.state.savedPauseChatbot && (
                              <div style={{ marginTop: "8px" }}>
                                <Typography style={{ fontSize: "0.75rem", color: cv('text-secondary', '#666'), marginBottom: "4px" }}>
                                  Chatbot will stay off until you resume it.
                                </Typography>
                                <Link
                                  onClick={this.handleResumeNow}
                                  style={{
                                    color: cv('accent', '#007AFF'),
                                    textDecoration: "underline",
                                    fontSize: "0.75rem",
                                    cursor: "pointer"
                                  }}
                                >
                                  Resume now
                                </Link>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    }
                    labelPlacement="end"
                    sx={{ alignItems: 'flex-start', marginLeft: 0 }}
                  />
                </div>
                
                <Divider style={{ marginBottom: "24px", backgroundColor: cv('border', '#E0E0E0') }} />
                
                <div style={{ marginBottom: "32px" }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.stopChatbot}
                        onChange={(e) => this.handleStopChatbotChange(e.target.checked)}
                        size="small"
                      />
                    }
                    label={
                      <div>
                        <Typography style={{ fontWeight: 600, fontSize: "0.875rem", marginBottom: "4px" }}>
                          Stop chatbot
                        </Typography>
                        <Typography style={{ fontSize: "0.75rem", color: cv('text-secondary', '#666'), lineHeight: "1.4" }}>
                          Permanently disable chatbot for this conversation. It will not respond or suggest replies unless manually re-enabled in settings.
                        </Typography>
                      </div>
                    }
                    labelPlacement="end"
                    sx={{ alignItems: 'flex-start', marginLeft: 0 }}
                  />
                </div>
              </div>
              
              <div style={{ paddingTop: "16px", marginTop: "auto" }}>
                <FormActionButtons
                  mode="edit"
                  size="medium"
                  sx={{ mb: 1.5 }}
                  onSubmit={this.handleSaveChatbotSettings}
                  submitDisabled={!this.hasChatbotSettingsChanged() || this.state.savingChatbotSettings}
                  submitLabel={this.state.savingChatbotSettings ? "Saving..." : undefined}
                  submitIcon={this.state.savingChatbotSettings ? <CircularProgress size={16} color="inherit" /> : undefined}
                  onCancel={this.handleCancelChatbotSettings}
                />
                
                <Link
                  href="/settings/ai"
                  target="_blank"
                  style={{
                    color: cv('text-secondary', '#667085'),
                    textDecoration: "underline",
                    fontSize: "0.875rem",
                    cursor: "pointer"
                  }}
                >
                  Go to settings
                </Link>
              </div>
            </div>
            : ("")
          }
          {this.state.showTrainResponsePanel ?
            <div style={{ position: "absolute", width: "90%", right: 0, height: "100%", border: `1px solid ${cv('border', 'rgb(212, 212, 212)')}`, backgroundColor: cv('surface', 'white'), zIndex: 11, padding: "24px", borderRadius: "16px", maxWidth: "500px", overflowY: "auto", overflowX: "hidden" }} onClick={e => e.stopPropagation()}>
              <span style={{ position: "absolute", left: 0, top: 0, height: "50px", width: "100%", backgroundColor: cv('surface-muted', '#F5F5F5'), borderRadius: "15px 15px 0px 0px" }}>
                <span style={{ fontSize: "1rem", lineHeight: "50px", paddingLeft: "16px", fontWeight: 600 }}>Train response</span>
                <span onClick={e => this.closeTrainResponsePanel(e)} style={styles.closeButton}>&times;</span>
              </span>
              <div style={{ marginTop: "50px", padding: "0 16px", paddingBottom: "24px" }}>
                <Typography style={{ fontSize: "0.875rem", color: cv('text', '#000'), marginBottom: "24px", lineHeight: "1.5" }}>
                  Make edits to chatbot responses to train chatbot for similar questions in the future.
                </Typography>
                
                <TextField
                  label="Question"
                  fullWidth
                  value={this.state.trainingQuestion}
                  disabled
                  variant="outlined"
                  style={{ marginBottom: "16px" }}
                />
                <TextField
                  label="Suggested Response"
                  fullWidth
                  multiline
                  rows={window.innerHeight < 700 ? 6 : window.innerHeight < 900 ? 8 : 10}
                  value={this.state.trainingResponse}
                  onChange={(e) => this.setState({ trainingResponse: e.target.value })}
                  variant="outlined"
                  style={{ marginBottom: "16px" }}
                  sx={{
                    '& .MuiInputBase-root': {
                      maxHeight: 'calc(100vh - 400px)',
                      overflowY: 'auto'
                    },
                    '& .MuiInputBase-input': {
                      overflowY: 'auto !important'
                    }
                  }}
                />
                <TextField
                  label={this.state.trainingNotes ? "Notes" : ""}
                  fullWidth
                  multiline
                  rows={window.innerHeight < 700 ? 2 : window.innerHeight < 900 ? 2 : 3}
                  value={this.state.trainingNotes}
                  onChange={(e) => this.setState({ trainingNotes: e.target.value })}
                  variant="outlined"
                  style={{ marginBottom: "16px" }}
                  placeholder="Optional: Add notes or explanation about this training response..."
                  InputLabelProps={{
                    shrink: !!this.state.trainingNotes
                  }}
                />
                
                <div style={{ display: "flex", gap: "8px", justifyContent: "flex-start", marginTop: "0px", flexWrap: "wrap", width: "100%" }}>
                  <Button
                    variant="contained"
                    onClick={this.handleSaveTrainResponse}
                    disabled={this.state.savingTrainResponse || 
                      (this.state.trainingResponse.trim() === this.state.originalTrainingResponse.trim() && 
                       this.state.trainingNotes.trim() === this.state.originalTrainingNotes.trim())}
                    sx={{
                      backgroundColor: this.state.savingTrainResponse ? "#777777" : cv('accent-fill', "#007AFF"),
                      color: "white",
                      textTransform: "uppercase",
                      fontWeight: 600,
                      flex: { xs: "1 1 0", md: "1 1 0" },
                      padding: "8px 8px",
                      minHeight: "36px",
                      borderRadius: "4px",
                      position: "relative",
                      '@media (max-width: 500px)': {
                        padding: "8px 16px"
                      },
                      '& .MuiButton-label': {
                        whiteSpace: "normal !important",
                        overflowWrap: "break-word",
                        wordBreak: "normal",
                        lineHeight: "1.2",
                        textAlign: "center"
                      }
                    }}
                  >
                    {this.state.savingTrainResponse ? (
                      <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <CircularProgress size={16} style={{ color: "white" }} />
                        SAVING...
                      </span>
                    ) : (
                      <span style={{ whiteSpace: "normal", overflowWrap: "break-word", wordBreak: "normal", lineHeight: "1.2", display: "block" }}>TRAIN CHATBOT</span>
                    )}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={this.closeTrainResponsePanel}
                    sx={{
                      borderColor: cv('accent', '#007AFF'),
                      color: cv('accent', '#007AFF'),
                      textTransform: "uppercase",
                      fontWeight: 600,
                      flex: { xs: "1 1 0", md: "0.5 1 0" },
                      padding: "8px 12px",
                      minHeight: "36px",
                      borderRadius: "4px",
                      '& .MuiButton-label': {
                        whiteSpace: "normal !important",
                        overflowWrap: "break-word",
                        wordBreak: "normal",
                        lineHeight: "1.2"
                      }
                    }}
                  >
                    <span style={{ whiteSpace: "normal", overflowWrap: "break-word", wordBreak: "normal", lineHeight: "1.2", display: "block" }}>CANCEL</span>
                  </Button>
                  {this.state.hasUserSuggestedEdit && (
                    <Button
                      variant="outlined"
                      onClick={this.handleDeleteTrainResponse}
                      disabled={this.state.savingTrainResponse}
                      sx={{
                        borderColor: cv('danger-text', '#DC3545'),
                        color: cv('danger-text', '#DC3545'),
                        textTransform: "uppercase",
                        fontWeight: 600,
                        flex: "1.0 1 0",
                        minWidth: "110px",
                        padding: "8px 4px",
                        minHeight: "36px",
                        borderRadius: "4px",
                        '& .MuiButton-label': {
                          whiteSpace: "normal !important",
                          overflowWrap: "break-word",
                          wordBreak: "normal",
                          lineHeight: "1.2",
                          textAlign: "center"
                        }
                      }}
                    >
                      <span style={{ whiteSpace: "normal", overflowWrap: "break-word", wordBreak: "normal", lineHeight: "1.2", display: "block" }}>DELETE FEEDBACK</span>
                    </Button>
                  )}
                </div>
              </div>
            </div>

            : ("")
          }
          {this.state.showTemplatedMessagesPane &&

            <TemplatedMessagesMenu
              subjectUserLanguage={this.state.subjectUserLanguage}
              disabled={(this.state.conversation_id === null)}
              setTextAreaText={this.setTextAreaText}
              isSmallScreen={isSmallScreen}
              handleDeleteTemplatedMsg={this.handleDeleteTemplatedMsg}
              handleDeleteTemplatedMsgTopic={this.handleDeleteTemplatedMsgTopic}
              templatedMsgRefreshKey={this.state.templatedMsgRefreshKey}
              updateTemplatedMsgRefreshKey={this.updateTemplatedMsgRefreshKey}
              dataAPI={this.props.dataAPI}
              handleTypingChange={this.handleTypingChange}
              setState={this.setState}
              closeTemplatedMessagesPane={this.closeTemplatedMessagesPane}
              askToCloseTemplatedmessagesPaneKey={this.state.askToCloseTemplatedmessagesPaneKey}
              styles={styles}
              conversation_unique_name={this.state.conversation_id}
              messages={this.state.messages}
              participantsRoleDict={this.state.participantsRoleDict}
            />
          }
          <AppBar position="relative" elevation={0} style={styles.header(show1pageScreen)}>
            {!show1pageScreen && this.props.selectedScreen === "ChatScreen" && (
              <IconButton
                onClick={this.goBack}
                style={{
                  position: "absolute",
                  right: 4,
                  top: 4,
                  zIndex: 10,
                  color: cv('text-secondary', '#666'),
                  padding: "2px"
                }}
                size="small"
              >
                <Close sx={{ fontSize: "14px" }} />
              </IconButton>
            )}
            <div style={{ minHeight: 64, paddingLeft: !show1pageScreen ? "12px" : "4px", paddingTop: "4px" }}>
              <div style={{ display: "flex" }}>
                {(show1pageScreen && this.props.selectedScreen === "ChatScreen") ? <NavigateBefore style={{ cursor: "pointer", color: cv('accent', '#007AFF'), marginTop: "7px", fontSize: "28px" }} onClick={this.goBack} /> : ""}
                {this.props.checkboxMode ? (
                  <span><MultipleRecipientsIcon style={styles.topicImg} /></span>
                ) : conversation_name === null ? ("") :
                  showAnnouncementsHeader ? (<span><Megaphone style={styles.topicImg} /></span>) :
                    showGroupChatHeader ? (<span><GroupChat style={styles.topicImg} /></span>) :
                      showGuidesAndStaffHeader ? (<span><GuidesAndStaff style={styles.topicImg} /></span>) :
                        showMainOfficeHeader ? (<span><MainOfficeIcon style={styles.topicImg} /></span>) :
                          showAppSupportHeader ? (<span><AppSupportIcon style={styles.topicImg} /></span>) :
                            showOnTripSupportHeader ? (<span><OnTripSupport style={styles.topicImg} /></span>) :
                              (<Avatar style={styles.avatar(`${conversation_name}`)} name={`${conversation_name}`} size={!show1pageScreen ? "32" : "32"} round={true} color={avatarColor} src={avatarImg} maxInitials={1} textSizeRatio={2} />
                              )
                }
                {this.props.checkboxMode ? (
                  <div style={{ width: "100%", overflow: "hidden", position: "relative" }}>
                    <Typography style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", maxWidth: !show1pageScreen ? !this.tourUserBookingRef.current ? "85%" : "65%" : !this.tourUserBookingRef.current ? "78%" : "71%", display: "inline-block", marginBottom: -6 }}>
                      <span title="Multiple recipients" style={{ fontWeight: 600, lineHeight: "1.0rem" }}>Multiple recipients</span>
                    </Typography>
                    {this.props.selectedConversationsForMessaging && this.props.selectedConversationsForMessaging.length > 0 && (
                      <span style={{ position: "absolute", right: 8, top: 0, display: "flex", alignItems: "center" }}>
                        <Chip
                          label={`${this.props.selectedConversationsForMessaging.length} selected`}
                          onDelete={() => {
                            // This will be handled by the parent component
                            if (this.props.onClearSelection) {
                              this.props.onClearSelection();
                            }
                          }}
                          deleteIcon={<Cancel style={{ fontSize: '16px' }} />}
                          color="primary"
                          size="small"
                          style={{ backgroundColor: cv('accent-fill', '#007AFF'), color: 'white' }}
                        />
                      </span>
                    )}
                    {this.state.sendingProgress && (
                      <div style={{ marginTop: "8px", marginBottom: "4px", maxWidth: "85%", paddingRight: "12px" }}>
                        <LinearProgress 
                          variant="determinate" 
                          value={(this.state.sendingProgress.current / this.state.sendingProgress.total) * 100} 
                          style={{ height: "6px", borderRadius: "3px" }}
                        />
                        <Typography variant="caption" style={{ fontSize: "0.75rem", color: cv('text-secondary', '#666'), marginTop: "4px", display: "block" }}>
                          Sending to {this.state.sendingProgress.current} of {this.state.sendingProgress.total} conversations...
                        </Typography>
                      </div>
                    )}
                    {this.props.channelTitleForMultipleRecipients && (
                      <>
                        <Typography 
                          title={this.props.channelTitleForMultipleRecipients} 
                          style={{
                            maxWidth: !show1pageScreen ? 'calc(100% - 110px)' : isSmallScreen ? "calc(100% - 120px)" : "calc(100% - 110px)", 
                            margin: 0, 
                            padding: 0, 
                            marginTop: -6, 
                            fontFamily: "Roboto", 
                            overflow: "hidden", 
                            whiteSpace: "nowrap", 
                            textOverflow: "ellipsis", 
                            color: cv('text-muted', '#6c757d'), 
                            fontSize: "13px",
                            cursor: 'default'
                          }}
                        >
                          {this.props.channelTitleForMultipleRecipients}
                        </Typography>
                        {(this.props.travelDateForMultipleRecipients || (this.props.tourTagsForMultipleRecipients && this.props.tourTagsForMultipleRecipients.length > 0)) && (
                          <Tooltip title={this.props.tourTagsForMultipleRecipients?.length ? formatTourTagsTooltip(this.props.tourTagsForMultipleRecipients) : ''} arrow placement="top-start">
                          <Typography style={{ maxWidth: !show1pageScreen ? 'calc(100% - 100px)' : "calc(100% - 100px)", color: cv('text-muted', '#6c757d'), fontSize: "13px", margin: 0, padding: 0, marginTop: -2, overflowY: "hidden", overflowX: !isSmallScreen ? 'hidden' : 'auto', whiteSpace: 'nowrap', textOverflow: !isSmallScreen ? 'ellipsis' : null }}>
                          {this.props.travelDateForMultipleRecipients}
                          {this.props.tourTagsForMultipleRecipients && this.props.tourTagsForMultipleRecipients.length > 0 && this.props.tourTagsForMultipleRecipients.map(tag =>
                            <span key={tag.id} style={headerTourTagStyle(tag.category === 'departure')}>{tag.data?.friendly_name || tag.name}</span>
                          )}
                        </Typography>
                        </Tooltip>
                        )}
                      </>
                    )}
                  </div>
                ) : (!conversation_name) ?
                  <div style={{}}>
                    <Typography style={{ color: cv('text-muted', '#999999'), fontWeight: "500", fontFamily: "Roboto", fontSize: ".875rem" }}>
                      {"CONVERSATION"}
                    </Typography>
                  </div> :
                  <div style={{ width: "100%", overflow: "hidden" }}>
                    <Typography style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", maxWidth: !show1pageScreen ? !this.tourUserBookingRef.current ? "85%" : "65%" : !this.tourUserBookingRef.current ? "78%" : "71%", display: "inline-block", marginBottom: -6 }}>
                      {this.tourUserLinkRef.current && conversation_name ?
                        <Tooltip title={`View/Edit ${conversation_name}'s Registration Info`} arrow placement="top"><a style={{ color: cv('text', 'black') }} href={this.tourUserLinkRef.current} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}>
                          <span style={{ fontWeight: 600, lineHeight: "1.0rem" }}>{conversation_display_name}</span>
                        </a></Tooltip> :
                        <span title={conversation_display_name} style={{ fontWeight: 600, lineHeight: "1.0rem" }}>{conversation_display_name}</span>}
                    </Typography>
                    {/*
                    <span style={{ position: "absolute", right: 8, top: 0, maxWidth: "100px", overflow: "hidden", textOverflow: "ellipsis" }}>
                      <AssignToMenu conversation_id={this.state.conversation_id} admins={this.state.participantsList?.filter(p => p.conversation_role==="admin")} assignedToAdmin={this.state.assignedToAdmin} setAssignedToAdmin={this.setAssignedToAdmin} show1pageScreen={show1pageScreen}/>
                    </span>*/
                    }
                    {this.tourUserBookingRef.current?.map((booking_ref, idx) =>
                      <Tooltip key={idx} title={<BookingRefsTooltipContent rows={bookingRefRows(this.tourUserRefDetails.current, this.tourUserBookingRef.current)} />} arrow placement="top" leaveDelay={200}><span style={{ position: "absolute", right: 8, top: !show1pageScreen ? 22 + (idx * 14) : idx * 14, color: cv('text', 'black'), fontSize: !isSmallScreen ? ".75em" : ".6em", maxWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {idx === 0 && "BR:"}&nbsp;{idx < 2 || this.tourUserBookingRef.current.length === 3 ? booking_ref : idx === 2 ? "..." : ""}{idx + 1 !== this.tourUserBookingRef.current.length && idx < 2 && ","}
                          </span></Tooltip>
                    )}
                    {/*
                    <FormControlLabel
                      style={{ position: "absolute", right: 18, bottom: 4 }}
                      control={<Switch size="small" color="primary" onChange={this.handleIssuesStateChange} checked={this.state.issuesState === 0 || this.state.issuesState === 2} />}
                      labelPlacement="start"
                      label={<Typography style={{ fontSize: ".75rem" }}>{this.state.issuesState === 0 ? "Closed" : this.state.issuesState === 2 ? "Auto-Closed" : "Open"}</Typography>}
                    />
                    */}

                    <Typography 
                      title={this.tourNameSubtext()} 
                      onClick={this.props.chatView === 'recent_activity' ? (e) => {
                        e.stopPropagation();
                        if (this.props.setChatView) {
                          this.props.setChatView('channels');
                        }
                        // Pass 'channels' as override since setChatView is async and prop won't update immediately
                        this.goBack(e, 'channels');
                      } : undefined}
                      style={{
                        maxWidth: !show1pageScreen ? 'calc(100% - 110px)' : isSmallScreen ? "calc(100% - 120px)" : "calc(100% - 110px)", 
                        margin: 0, 
                        padding: 0, 
                        marginTop: -6, 
                        fontFamily: "Roboto", 
                        overflow: "hidden", 
                        whiteSpace: "nowrap", 
                        textOverflow: "ellipsis", 
                        color: cv('text-muted', '#6c757d'), 
                        fontSize: "13px",
                        cursor: this.props.chatView === 'recent_activity' ? 'pointer' : 'default',
                        textDecoration: this.props.chatView === 'recent_activity' ? 'underline' : 'none',
                        textDecorationColor: this.props.chatView === 'recent_activity' ? cv('text-disabled', 'rgba(0, 0, 0, 0.2)') : 'transparent'
                      }}
                    >
                      {channelTopicID === "main_office" ? "Main Office" : channelTopicID === "app_support" ? "App Support" : this.tourNameSubtext()}
                    </Typography>
                    <Tooltip
                      title={this.headerSubtextTooltip()}
                      arrow
                      placement="top-start"
                      slotProps={{
                        tooltip: { sx: { bgcolor: cv('surface', '#fff'), color: cv('text', '#202020'), border: `1px solid ${cv('border', 'rgba(0,0,0,0.12)')}`, boxShadow: '0 2px 10px rgba(0,0,0,0.18)', p: 0.75, maxWidth: 360 } },
                        arrow: { sx: { color: cv('surface', '#fff'), '&::before': { border: `1px solid ${cv('border', 'rgba(0,0,0,0.12)')}` } } },
                      }}
                    >
                    <Typography style={{ maxWidth: !show1pageScreen ? 'calc(100% - 100px)' : "calc(100% - 100px)", color: cv('text-muted', '#6c757d'), fontSize: "13px", margin: 0, padding: 0, marginTop: -2, overflowY: "hidden", overflowX: !isSmallScreen ? 'hidden' : 'auto', whiteSpace: 'nowrap', textOverflow: !isSmallScreen ? 'ellipsis' : null }}>
                      {this.dateSubtext()}
                      {this.tagsSubtext()}
                      {this.state.visibleOnlyChatTags?.map((tag) => <span key={tag.id} style={headerChatTagStyle()}>{tag.data?.friendly_name || tag.name}</span>)}
                      {this.state.subjectIsLeadBooker != null && (() => {
                        const isLead = this.state.subjectIsLeadBooker;
                        const pax = this.state.subjectPaxCount || 1;
                        return (
                          <span style={headerPaxStyle(true)}>
                            {isLead ? `PAX: ${pax}` : '+1'}
                          </span>
                        );
                      })()}
                      {this.state.subjectWaiverSigned ? <span style={{ display: 'inline-flex', verticalAlign: 'middle', position: 'relative', top: '-1px', marginLeft: 4 }}><WaiverSignedIcon width={19} height={19} /></span> : null}
                      {(() => {
                        // Time only: the range above already ends on the check-out day.
                        const checkout = this.props.isGuideGroupChannel === true ? null : checkoutTimeLabel(this.state.subjectCheckoutTs, this.state.tourTimezone);
                        return checkout ? <span style={this.checkoutChipStyle(checkout)}>{checkout.label}</span> : null;
                      })()}
                    </Typography>
                    </Tooltip>
                  </div>}
              </div>
            </div>
            {this.props.selectedScreen === "ChatScreen" && !this.props.checkboxMode &&
              <div style={{ marginLeft: "12px", marginTop: "-.0rem" }}>
                {messages && messages.length > 0 && !(channel?.lastReadMessageIndex === null || channel?.lastReadMessageIndex < channel?.lastMessage?.index) ?
                  <Tooltip title="Mark as Unread" arrow placement="top"><IconButton style={{ width: "2.5rem", height: "2.5rem", cursor: 'pointer' }} onClick={e => this.markConversationUnread(e)}>
                    <MarkUnread style={{ fontSize: "2.5em" }} />
                  </IconButton></Tooltip>
                  :
                  <Tooltip title="Mark as Unread" arrow placement="top"><IconButton style={{ width: "2.5rem", height: "2.5rem", cursor: 'default' }}>
                    <MarkUnreadDisabled style={{ fontSize: "2.5em" }} />
                  </IconButton></Tooltip>
                }


                <IconButton style={{ display: "none", marginLeft: "-.27rem", width: "2.5rem", height: "2.5rem" }} title={(this.state.notificationLevel === 'default' ? 'Mute' : 'Unmute') + " notifications"} onClick={e => this.handleToggleNotificationLevel(e)}>
                  {this.state.notificationLevel == null ?
                    <NotificationBellOffGray style={{ fontSize: '2.5em' }} />
                    :
                    this.state.notificationLevel === 'default' ?
                      <NotificationBellOff style={{ fontSize: "2.5em" }} />
                      :
                      <NotificationBellOn style={{ fontSize: "2.5em" }} />
                  }
                </IconButton>
                {(false && this.state.gtuNotificationsPaused != null) ? this.state.gtuNotificationsPaused === false ?
                  <IconButton style={{ marginLeft: "-.33rem", width: "2.5rem", height: "2.5rem" }} title={"Pause all notifications for this guest on this tour"} onClick={e => this.handleToggleGtuNotifications(e)}>
                    <PauseAutoCommunications style={{ fontSize: "2.5em" }} />
                  </IconButton> :
                  <IconButton style={{ marginLeft: "-.33rem", width: "2.5rem", height: "2.5rem" }} title={"Unpause all notifications for this guest on this tour"} onClick={e => this.handleToggleGtuNotifications(e)}>
                    <UnpauseAutoCommunications style={{ fontSize: "2.5em" }} />
                  </IconButton> :
                  ""
                }
                <Tooltip title="Add Note" arrow placement="top"><IconButton style={{ cursor: channelSubjectID ? 'pointer' : "default", marginLeft: "-.45rem", width: "2.5rem", height: "2.5rem" }} onClick={channelSubjectID ? e => this.toggleNotesPane(e) : null}>
                  {channelSubjectID ? <NewNote style={{ fontSize: "2.5em" }} /> : <NewNoteDisabled style={{ fontSize: "2.5em" }} />}
                </IconButton></Tooltip>
                {/* CP-8458: hand an unmatched franchise Main Office chat to the licensee that should answer it. */}
                <MoveToLicenseeButton
                  conversationId={this.state.conversation_id}
                  isMainOffice={channelTopicID === "main_office" && Boolean(channelSubjectID)}
                  guestName={conversation_name}
                  onMoved={() => this.goBack({ stopPropagation: () => {} })}
                />
                <InternalTagsMenu
                  selectedScreen={this.props.selectedScreen}
                  channelSubjectID={channelSubjectID}
                  channelUniqueName={this.state.conversation_id}
                  internalTags={this.state.internalTags}
                  setInternalTags={this.setInternalTags}
                />
                {
                  // hide participants list in announcements if guest (so that they can't see other travelers) 
                  (false && (channelSubjectID !== "announcements" || this.userIsGuest === false)) && (
                    <IconButton style={{ cursor: channelSubjectID ? 'pointer' : "default", marginBottom: 1, marginLeft: "-.4rem", width: "2.5rem", height: "2.5rem" }} title="Show Participants" onClick={channelSubjectID ? e => this.toggleParticipantsList(e) : null}>
                      {channelSubjectID ? <ViewParticipants style={{ fontSize: "2.5em" }} /> : <ViewParticipantsDisabled style={{ fontSize: "2.5em" }} />}
                    </IconButton>
                  )
                }
                {false && !isNaN(channelSubjectID) &&
                  <span>
                    <IconButton style={{ cursor: channelSubjectID ? 'pointer' : "default", marginLeft: "-.3rem", width: "2.5rem", height: "2.5rem" }} title="Open User Profile">
                      <a href={"/user/" + channelSubjectID} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()} style={{ marginTop: 3 }} >
                        <LinkOutIcon style={{ fontSize: "2.5em", transform: "scale(1.2)" }} />
                      </a>
                    </IconButton>
                    {this.state.subjectUserMagicLink &&
                      <IconButton style={{ cursor: channelSubjectID ? 'pointer' : "default", marginLeft: "-.3rem", width: "2.5rem", height: "2.5rem" }} title="Copy user's magic link to clipboard" onClick={() => { navigator.clipboard.writeText(this.state.subjectUserMagicLink); this.props.enqueueSnackbar("Link copied to clipboard", { variant: 'success' }); }}>
                        <LinkIcon style={{ color: cv('accent', '#007AFF') }} />
                      </IconButton>
                    }
                  </span>
                }
                <MoreOptionsMenu
                  style={{position: "absolute", right: "10px", marginTop: "4px"}}
                  selectedScreen={this.props.selectedScreen}
                  channelSubjectID={channelSubjectID}
                  channelUniqueName={this.state.conversation_id}
                  internalTags={this.state.internalTags}
                  setInternalTags={this.setInternalTags}
                  messages={this.state.messages}
                  channel={this.state.channel}
                  MarkUnread={this.MarkUnread}
                  MarkUnreadDisabled={this.MarkUnreadDisabled}
                  markConversationUnread={this.markConversationUnread}
                  notificationLevel={this.state.notificationLevel}
                  handleToggleNotificationLevel={this.handleToggleNotificationLevel}
                  gtuNotificationsPaused={this.state.gtuNotificationsPaused}
                  handleToggleGtuNotifications={this.handleToggleGtuNotifications}
                  toggleNotesPane={this.toggleNotesPane}
                  toggleParticipantsList={this.toggleParticipantsList}
                  userIsGuest={this.userIsGuest}
                  subjectUserMagicLink={this.state.subjectUserMagicLink}
                  subjectUserReviewLink={this.state.subjectUserReviewLink}
                  subjectUserPreCheckinLink={this.state.subjectUserPreCheckinLink}
                  enqueueSnackbar={this.props.enqueueSnackbar}
                  issuesState={this.state.issuesState}
                  handleIssuesStateChange={this.handleIssuesStateChange}
                />



              </div>}
            {this.state.confirmationDialogAction ? (
              <ConfirmationDialog
                classes={{ paper: this.props.paperClass }}
                keepMounted
                onCancel={this.confirmationDialogCancel}
                onConfirm={this.confirmationDialogConfirm}
                title={this.ConfirmationDialogText[this.state.confirmationDialogAction].title}
                okButtonText={this.ConfirmationDialogText[this.state.confirmationDialogAction].okButtonText}
                cancelButtonText={this.ConfirmationDialogText[this.state.confirmationDialogAction].cancelButtonText}
                open={!!this.state.confirmationDialogAction}
                sx={{
                  '& .MuiBackdrop-root': {
                    opacity: '1 !important',
                    visibility: "visible !important",
                  },
                  '& .MuiDialog-container': {
                    opacity: '1 !important',
                    visibility: "visible !important",
                  },
                }}
              >
                <span className="content" dangerouslySetInnerHTML={{__html: this.ConfirmationDialogText[this.state.confirmationDialogAction].body.replace("{templatedMsgTopicInFocusNumAssociatedMsgs}", this.state.templatedMsgTopicInFocusNumAssociatedMsgs)}}></span>
              </ConfirmationDialog>
            ) : null}
          </AppBar>

          {!this.userIsGuest && this.state.internalTags && this.state.internalTags.length > 0 ?
            <Grid item style={{ flex: 3, borderRight: `1px solid ${cv('border', 'rgb(224, 224, 224)')}`, borderLeft: !show1pageScreen ? null : `1px solid ${cv('border', 'rgb(224, 224, 224)')}`, }}>
              <Grid item xs={chatWindowCols} style={styles.internalTagsPane(show1pageScreen)}>
                <Typography style={{ position: "absolute", left: "14px", top: "11px", color: cv('text-muted', '#8A8A8F'), fontWeight: "600", fontFamily: "Roboto", fontSize: '.9rem', }}>
                  {"INTERNAL TAGS"}
                </Typography>
                <div style={{ position: "absolute", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis",right: "14px", maxWidth: "calc(100% - 140px)", top: "11px", color: cv('text-muted', '#8A8A8F'), fontWeight: "500", fontFamily: "Roboto", fontSize: '.9rem', }}>
                  {this.state.internalTags?.map((tag) => <Tag key={tag.id} title={this.state.internalTags.map(x => x.name).join(", ")} style={headerInternalTagStyle()}>{tag.data?.friendly_name || tag.name}</Tag>)}
                </div>
              </Grid>
              <Divider sx={{ my: 0.5 }} />
            </Grid> : ("")}

          {!this.userIsGuest && this.state.notesList && this.state.notesList.length > 0 ?
            <Grid item style={{ flex: 3 }}>
              <Grid item xs={chatWindowCols} style={styles.notesItemList(show1pageScreen)}>
                <Typography style={{ position: "absolute", left: "14px", top: "11px", color: cv('text-muted', '#8A8A8F'), fontWeight: "600", fontFamily: "Roboto", fontSize: '.9rem', }}>
                  {"NOTES"}
                </Typography>
                <Link style={{ zIndex: 10, cursor: "pointer", textDecoration: 'none', position: "absolute", right: "14px", top: "11px", color: cv('accent', '#007AFF'), fontWeight: "600", fontFamily: "Roboto", fontSize: '.9rem', }} onClick={e => this.toggleNotesPane(e)}>
                  {"VIEW ALL"}
                </Link>
                <List dense={true}>
                  {this.state.notesList &&
                    this.state.notesList.map((note, index, arr) => {
                      const prevMsg = arr[index - 1];
                      const nextMsg = arr[index + 1];
                      return (
                        <div key={note.id}>
                          {(() => {
                            return ((index === 0 || new Date(prevMsg.updated_ts).toDateString() !== new Date(note.updated_ts).toDateString()) ?
                              <DateSeparator followingGap={6}>
                                {new Date(note.updated_ts).toLocaleDateString('en-gb', { weekday: "short", month: "long", day: "numeric" })}
                              </DateSeparator> : "")
                          })()}
                          <NotesItem
                            key={note.id}
                            message={note}
                            tw_identity={tw_identity}
                            scrollToBottom={this.scrollToBottomIfPinned}
                            showNotesPane={this.state.showNotesPane}
                            participantsDict={this.state.participantsDict}
                            participantsRoleDict={this.state.participantsRoleDict}
                            colorPalette={this.palette}
                            participantsAvatarColorDict={this.state.participantsAvatarColorDict}
                            participantsAvatarImgDict={this.state.participantsAvatarImgDict}
                            getUserFromTwilio={this.getUserFromTwilio}
                            prevMsg={prevMsg}
                            nextMsg={nextMsg}
                          >
                          </NotesItem>
                        </div>
                      )
                    })}
                </List>
              </Grid>
            </Grid> : ("")}

          <div direction="column" style={{
            height: (() => {
              const isMobile = window.innerWidth < 500;
              const isActivityView = isRecentActivityView;
              const baseHeight = isMobile && isActivityView ? '86svh' : '86svh';
              const notesHeight = isMobile && isActivityView ? '69svh' : '69svh';
              const tagsAdjustment = this.state.internalTags && this.state.internalTags.length > 0 ? 44 : 0;
              
              if (this.state.notesList && this.state.notesList.length) {
                return tagsAdjustment > 0 
                  ? `calc(${notesHeight} - 49px - ${tagsAdjustment}px + 0.5px)` 
                  : `calc(${notesHeight} - 49px + 0.5px)`;
              }
              return tagsAdjustment > 0 
                ? `calc(${baseHeight} - 49px - ${tagsAdjustment}px + 0.5px)` 
                : `calc(${baseHeight} - 49px + 0.5px)`;
            })(),
            width: "100%",
            display: "flex",
            flexDirection: "column",
            // In the single-page layout the parent grid has a definite height
            // (see the Container above), so the height calc above is only the
            // preferred size (flex-basis): minHeight 0 lets the column shrink
            // to fit short viewports, keeping the composer in flow instead of
            // letting the sticky composer cover the end of the message list.
            // Desktop 3-panel keeps the exact 86svh geometry (parent is
            // content-sized there, so no shrink ever happens).
            minHeight: show1pageScreen ? 0 : null
          }}>
            <div style={styles.gridItemChatList(this.state.notesList && this.state.notesList.length > 0, channelSubjectID === "announcements", show1pageScreen, isSmallScreen, this.state.internalTags && this.state.internalTags.length, this.state.attachedFiles && this.state.attachedFiles.length > 0)} ref={this.scrollDiv} onScroll={this.handleChatListScroll}>
              <List dense={true}>
                {!this.props.checkboxMode && messages &&
                  messages.map((message, index, arr) => {
                    const prevMsg = arr[index - 1];
                    const nextMsg = arr[index + 1];
                    // The web-widget holding message is the bot handing off. Mark it in
                    // the thread; only the most recent handoff carries the live state
                    // ("stopped for this conversation" + Resume), earlier ones are history.
                    const isHandoff = isHandoffMessage(message);
                    const quietSentence = index === latestHandoffIndex
                      ? chatbotQuietSentence({
                          stopped: this.state.savedStopChatbot,
                          paused: this.state.savedPauseChatbot,
                          pausedUntil: this.state.chatbotResumeDateTime,
                        })
                      : null;
                    return (
                      <div key={message.index}>
                        {(() => {
                          return ((index === 0 || prevMsg.dateCreated.toDateString() !== message.dateCreated.toDateString()) ?
                            <DateSeparator>
                              {message.dateCreated.toLocaleDateString('en-gb', { weekday: "short", month: "long", day: "numeric" })}
                            </DateSeparator> : "")
                        })()}
                        <ChatItem
                          key={message.index}
                          message={message}
                          tw_identity={tw_identity}
                          onMediaLoad={this.scrollToBottomIfPinned}
                          participantsDict={this.state.participantsDict}
                          participantsRoleDict={this.state.participantsRoleDict}
                          colorPalette={this.palette}
                          participantsAvatarColorDict={this.state.participantsAvatarColorDict}
                          participantsAvatarImgDict={this.state.participantsAvatarImgDict}
                          operatorLogoUrl={this.getOperatorLogoUrl()}
                          getUserFromTwilio={this.getUserFromTwilio}
                          prevMsg={prevMsg}
                          nextMsg={nextMsg}
                          toggleParticipantsList={this.toggleParticipantsList}
                          openTrainResponsePanel={this.openTrainResponsePanel}
                          handleThumbsUpFeedback={this.handleThumbsUpFeedback}
                          translateMessage={this.translateMessage}
                        >
                        </ChatItem>
                        {isHandoff && (
                          <ChatbotHandoffMarker
                            quietSentence={quietSentence}
                            onResume={this.handleResumeFromThread}
                            resuming={this.state.resumingChatbotFromThread}
                          />
                        )}
                      </div>
                    )
                  })}
              </List>
              {
                (conversation_name && (!messages || messages.length === 0)) ? (
                  <div style={styles.noMessagesPlaceholder}>
                    {(() => {
                      if (channelSubjectID === "announcements") {
                        // Same gate as the composer (CP-8136): guests and guide-group
                        // staff without chat.post_guide_group_announcements get the
                        // iOS read-only copy. Regular-tour staff keep "Post…".
                        if (this.canPostAnnouncements) {
                          return <span>Post announcements here.</span>
                        }
                        else {
                          return <span>See important announcements here.</span>
                        }
                      }
                      else if (channelSubjectID === userID && channelTopicID === "main_office") {
                        if (this.userIsGuest === true) {
                          return <span>Chat with our booking team.</span>
                        }
                        else {
                          return <span>Chat with our main office here.</span>
                        }
                      }
                      else if (channelSubjectID === userID && channelTopicID === "app_support") {
                        return <span>Chat with our app support team.</span>
                      }
                      else if (channelSubjectID === userID) {  // group tour
                        if (this.userIsGuide) {
                          return <span>Chat with your manager here.</span>
                        }
                        return <span>Contact your tour guides/support here.</span>
                      }
                      else if (channelSubjectID === "group_chat") {
                        return <span>Chat with your entire tour group here.</span>
                      }
                      else if (channelSubjectID === "guides_and_staff") {
                        if (this.userIsAdmin === true) {
                          return <span>Chat internally with this tour's guide(s) here.</span>
                        }
                        else if (this.userIsGuide === true) {
                          return <span>Chat internally with other guides/staff here.</span>
                        }
                      }
                      else {
                        return <span>Chat with {conversation_name} here.</span>
                      }
                    })()}
                  </div>
                ) : ("")
              }
            </div>
            {
              (channelSubjectID === "announcements") ? (
                <div style={styles.announcementsBanner}>
                  <div style={{ textAlign: "center" }}>
                    {/* Guide groups are gated by chat.post_guide_group_announcements
                        (CP-8136); the banner states the intended setup -- admins
                        only -- rather than the viewer's own permission. Regular
                        tours keep the pre-CP-8136 rule and text: any non-guest
                        (guides and admins) may post. */}
                    {this.props.isGuideGroupChannel === true
                      ? "Only admins can make announcements."
                      : "Only guides and admins can make announcements."}&nbsp;

                    {(this.userIsGuest === true) ? (
                      <Link style={{ color: cv('accent', '#007AFF'), cursor: 'pointer' }} onClick={e => this.navigate_to_on_trip_support(e)}>
                        <br />Tap here to reply to your guide/support team
                      </Link>
                    ) : ("")}
                  </div>
                  <ErrorOutline style={{ margin: 0, padding: 0, fontSize: "1.4em" }} />
                </div>
              ) : ("")}
            {this.state.anotherUserTyping ? (
              <div style={{ marginBottom: -6, paddingTop: 3, fontSize: "12px", color: cv('text-muted', '#6c757d'), width: "100%", textAlign: "center", borderLeft: show1pageScreen ? `1px solid ${cv('border', 'rgb(224, 224, 224)')}` : null, borderRight: `1px solid ${cv('border', 'rgb(224, 224, 224)')}` }}>
                <Avatar style={{ marginRight: "6px", marginBottom: "2px" }} name={this.state.participantsDict[this.state.anotherUserTyping]} size="15" round={true} color={this.state.participantsAvatarColorDict[this.state.anotherUserTyping]} src={this.state.participantsAvatarImgDict[this.state.anotherUserTyping]} maxInitials={1} textSizeRatio={2} />{this.state.participantsDict[this.state.anotherUserTyping]} is typing
                <span class="container"><div class="typing-dot"></div><div class="typing-dot"></div><div class="typing-dot"></div></span>
              </div>) : ""}
            {
              // In guide groups, announcements are broadcast-only for anyone without
              // chat.post_guide_group_announcements (CP-8136); guests never had the
              // composer here in any channel.
              (channelSubjectID !== "announcements" || this.canPostAnnouncements) ? (

                <div style={styles.gridItemMessageEntryArea(this.state.anotherUserTyping, this.state.showTextAreaBorder, show1pageScreen, isSmallScreen)} ref={this.textAreaGridRef}>
                  {!this.state.subjectUserHasMissingContactInfo ?
                    <>
                      {/* On mobile, show attachments above the entire message entry area when more than 2 files */}
                      {isSmallScreen && window.innerWidth < 500 && this.state.attachedFiles && this.state.attachedFiles.length > 2 && (
                        <Box sx={{ 
                          width: "100%", 
                          padding: "8px", 
                          marginBottom: "8px",
                          maxHeight: "15vh",
                          overflowY: "auto",
                          overflowX: "hidden"
                        }} ref={this.attachedFileRef}>
                          {this.renderAttachedFileDiv()}
                        </Box>
                      )}
                      <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="stretch"
                        alignSelf="center"
                        // Phones: height 100% + the 6px margin inside an auto-height
                        // section is over-constrained (100% resolves to the section's
                        // already-computed height, the margin then pokes 6px past it),
                        // which manufactured a permanent scrollbar. Content-size it.
                        style={{ height: isSmallScreen && window.innerWidth < 500 ? undefined : "100%", paddingBottom: this.state.showTextAreaBorder ? null : "10px", marginTop: "6px" }}
                      >
                        {/* Show attachments on top when 2 or more files (desktop only) */}
                        {(!isSmallScreen || window.innerWidth >= 500) && this.state.attachedFiles && this.state.attachedFiles.length > 1 && (
                          <Grid item style={{ width: "100%", marginBottom: "8px", paddingLeft: "85px" }} ref={this.attachedFileRef}>
                            {this.renderAttachedFileDiv()}
                          </Grid>
                        )}

                        {/* Pill gutters mirror the composer geometry so the pill centers on the
                            textarea: desktop 85 = 48 attach + 38 template, mobile 40 = stacked
                            icon column; right 38 = 12 textarea margin + 26 send button. */}
                        {this.state.missedTourRebooking && (
                          <Grid item style={{ width: "100%" }}>
                            <RebookingRequestCard
                              key={this.state.missedTourRebooking.id}
                              request={this.state.missedTourRebooking}
                              busy={this.state.rebookingBusy}
                              onApprove={(edits) => this.resolveRebooking('approve', edits)}
                              onDecline={() => this.resolveRebooking('decline')}
                            />
                          </Grid>
                        )}

                        {this.state.aiIsProcessing && this.state.aiSuggestedReplyConfidence == null && (
                          <Grid item style={{ width: "100%", paddingLeft: isSmallScreen ? "40px" : "85px", paddingRight: "38px", marginBottom: "4px", display: 'flex', justifyContent: 'center' }}>
                            <Box sx={{
                              display: 'flex', alignItems: 'center', gap: '8px',
                              backgroundColor: cv('tag-indigo', '#E8EAF6'), borderRadius: '8px',
                              padding: '3px 12px 3px 8px', width: 'fit-content', maxWidth: '100%',
                              '@keyframes aiPulse': {
                                '0%, 100%': { opacity: 1 },
                                '50%': { opacity: 0.5 },
                              },
                              animation: 'aiPulse 1.8s ease-in-out infinite',
                            }}>
                              <AutoAwesomeIcon sx={{ fontSize: 14, color: '#5C6BC0' }} />
                              <Typography sx={{ fontSize: '0.72rem', color: cv('text-secondary', '#444'), fontWeight: 500, whiteSpace: 'nowrap' }}>
                                AI is generating a response…
                              </Typography>
                              <CircularProgress size={10} thickness={5} sx={{ color: '#5C6BC0' }} />
                            </Box>
                          </Grid>
                        )}

                        {this.state.aiSuggestedReplyConfidence != null && (() => {
                          const pct = Math.round(this.state.aiSuggestedReplyConfidence * 100);
                          const step = Math.min(Math.floor(pct / 5), 19);
                          const colors = [
                            ['#B71C1C','#FFCDD2'], ['#C62828','#FFCDCA'], ['#D32F2F','#FFCCBC'], ['#D84315','#FFD0B6'],
                            ['#E53935','#FFD5B2'], ['#E64A19','#FFDAB2'], ['#EF6C00','#FFE0B2'], ['#F57C00','#FFE5B2'],
                            ['#FF8F00','#FFECB3'], ['#FF9800','#FFF0B8'], ['#FFA000','#FFF3BC'], ['#FFB300','#FFF6C0'],
                            ['#FFC107','#FFF8C8'], ['#FFCA28','#FFFAD0'], ['#FFD54F','#FFFBD8'], ['#FDD835','#FFF9C4'],
                            ['#C0CA33','#F0F4C3'], ['#7CB342','#DCEDC8'], ['#43A047','#C8E6C9'], ['#2E7D32','#A5D6A7'],
                          ];
                          const [color, bgColor] = colors[step];
                          return (
                            <Grid item style={{ width: "100%", paddingLeft: isSmallScreen ? "40px" : "85px", paddingRight: "38px", marginBottom: "4px", display: 'flex', justifyContent: 'center' }}>
                              <Box sx={{
                                display: 'flex', alignItems: 'center', gap: isSmallScreen ? '5px' : '8px',
                                backgroundColor: bgColor, borderRadius: '8px',
                                padding: '1px 10px 1px 8px', width: 'fit-content', maxWidth: '100%',
                              }}>
                                <AutoAwesomeIcon sx={{ fontSize: 14, color: color, flexShrink: 0 }} />
                                <Typography sx={{ fontSize: '0.72rem', color: '#555', fontWeight: 500, whiteSpace: 'nowrap' }}>
                                  {isSmallScreen ? 'AI Reply' : 'AI Suggested Reply'}
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px', minWidth: 0 }}>
                                  <Box sx={{ width: isSmallScreen ? 36 : 48, height: 5, borderRadius: 3, backgroundColor: '#e0e0e0', overflow: 'hidden', flexShrink: 0 }}>
                                    <Box sx={{ width: `${pct}%`, height: '100%', borderRadius: 3, backgroundColor: color, transition: 'width 0.3s ease' }} />
                                  </Box>
                                  <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: color, whiteSpace: 'nowrap' }}>
                                    {isSmallScreen ? `${pct}%` : `${pct}% Confidence`}
                                  </Typography>
                                </Box>
                                {(() => {
                                  const operatorLang = JSON.parse(window.localStorage.getItem('bootstrap'))?.user?.lang || null;
                                  // If we don't know the operator's language client-side, the backend
                                  // will default target_lang to request.user.lang (then DEFAULT_LANG).
                                  // For the suggestion-vs-target match check we fall back to 'en'.
                                  const effectiveTarget = (operatorLang || 'en').toLowerCase();
                                  const suggestionLang = this.state.aiSuggestedReplyLanguage;
                                  if (suggestionLang && suggestionLang.toLowerCase() === effectiveTarget) return null;
                                  return (
                                    <Tooltip title={operatorLang
                                        ? `Translate this suggestion to ${operatorLang.toUpperCase()} (does not modify the draft)`
                                        : `Translate this suggestion to my language (does not modify the draft)`} arrow placement="top">
                                    <Box
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        // Pass operatorLang when we know it; otherwise let the backend resolve.
                                        this.openDraftTranslationPreview(e.currentTarget, operatorLang || undefined);
                                      }}
                                      sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginLeft: '2px', color: '#666', '&:hover': { color: '#007AFF' } }}
                                    >
                                      <TranslateIcon sx={{ fontSize: 14 }} />
                                    </Box>
                                    </Tooltip>
                                  );
                                })()}
                                <Tooltip title="Dismiss" arrow placement="top">
                                <Box
                                  onClick={() => this.setState({ aiSuggestedReplyConfidence: null })}
                                  sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginLeft: '2px', color: '#999', '&:hover': { color: '#555' } }}
                                >
                                  <Close sx={{ fontSize: 14 }} />
                                </Box>
                                </Tooltip>
                              </Box>
                            </Grid>
                          );
                        })()}
                      
                      {this.chatWriteRestricted &&
                        <Grid item style={{ width: "100%" }}>
                          <Typography style={{ fontSize: ".8rem", color: cv('text-secondary', '#5F5F60'), fontStyle: "italic", padding: "8px 12px" }}>
                            You have read-only access to chat. You can view conversations but cannot send messages.
                          </Typography>
                        </Grid>
                      }
                      {!this.chatWriteRestricted &&
                      <Grid item style={{width:"100%", marginBottom: -8}}>
                        <Grid
                          container
                          direction="row"
                          justify="center"
                          alignItems={this.state.showTextAreaBorder ? "center" : "end"}
                          alignSelf="center"
                          wrap="nowrap"
                          style={{ height: "100%", paddingBottom: this.state.showTextAreaBorder ? null : "10px", flexWrap: "nowrap" }}
                        >

                          {/* Small screens: attach + templates collapse into one "+" button with
                              a popover menu so the narrow composer keeps its width for the
                              textarea. The AI pill gutters above assume this column is 40px.
                              Desktop keeps the two side-by-side icons. */}
                          {isSmallScreen ? (
                          <Grid item style={{ width: "40px", display: "flex", justifyContent: "center", paddingBottom: this.state.showTextAreaBorder ? null : "9px" }}>
                            <Tooltip title="Attachments and templates" arrow placement="top"><span>
                            <IconButton
                              onClick={(e) => this.setState({ composerPlusMenuAnchor: e.currentTarget })}
                              disabled={!this.props.checkboxMode && (this.state.conversation_id === null)}
                            >
                              <AddCircleOutline sx={{ color: (!this.props.checkboxMode && (this.state.conversation_id === null)) ? cv('text-disabled', 'rgba(0, 0, 0, 0.26)') : cv('accent', '#007AFF') }} />
                            </IconButton>
                            </span></Tooltip>
                            <input
                              ref={this.attachmentFileInput}
                              style={{ visibility: "hidden", position: "absolute", width: "1px", height: "1px", overflow: "hidden" }}
                              type="file"
                              accept={this.acceptFileTypes.join(",")}
                              onChange={this.onFileChange}
                              multiple
                            />
                            <Menu
                              anchorEl={this.state.composerPlusMenuAnchor}
                              open={Boolean(this.state.composerPlusMenuAnchor)}
                              onClose={() => this.setState({ composerPlusMenuAnchor: null })}
                              anchorOrigin={{ vertical: "top", horizontal: "left" }}
                              transformOrigin={{ vertical: "bottom", horizontal: "left" }}
                            >
                              <MenuItem onClick={() => {
                                this.setState({ composerPlusMenuAnchor: null });
                                if (this.attachmentFileInput.current) {
                                  this.attachmentFileInput.current.value = "";
                                  this.attachmentFileInput.current.click();
                                }
                              }}>
                                <AttachFile sx={{ fontSize: 20, color: cv('accent', '#007AFF'), marginRight: "10px" }} />
                                Attach files
                              </MenuItem>
                              {this.props.hasPerm('chat_template', 'read') &&
                              <MenuItem onClick={(e) => {
                                this.setState({ composerPlusMenuAnchor: null });
                                this.toggleTemplatedMessagesPane(e);
                              }}>
                                <span style={{ display: "flex", marginRight: "10px" }}><TemplatedMessagesIcon /></span>
                                Templated messages
                              </MenuItem>
                              }
                            </Menu>
                          </Grid>
                          ) : (
                          <>
                          <Grid item style={{ paddingLeft: "2px", width: "40px", paddingBottom: this.state.showTextAreaBorder ? null : "9px" }}>
                            <AttachFileButton onFileChange={this.onFileChange} textAreaRef={this.textAreaRef} validFileTypes={this.acceptFileTypes} clearAttachedFiles={this.clearAttachedFiles} disabled={!this.props.checkboxMode && (this.state.conversation_id === null)} />
                          </Grid>
                          {this.props.hasPerm('chat_template', 'read') &&
                          <Grid item style={{ marginLeft: "-10px", paddingBottom: this.state.showTextAreaBorder ? null : "9px" }}>
                            <Tooltip title={'Templated messages'} arrow placement="top"><span>
                            <IconButton

                              onClick={this.toggleTemplatedMessagesPane}
                              variant="contained"
                              disabled={!this.props.checkboxMode && (this.state.conversation_id === null)}

                            >
                              {this.props.checkboxMode || this.state.conversation_id != null ? <TemplatedMessagesIcon /> : <TemplatedMessagesIconDisabled />}
                            </IconButton>
                            </span></Tooltip>

                          </Grid>
                          }
                          </>
                          )}
                          {/* Show attachments to the left when 2 or fewer files */}
                          {this.state.attachedFiles && this.state.attachedFiles.length <= 1 && (
                            <Grid item style={{ paddingRight: this.state.attachedFiles && this.state.attachedFiles.length > 0 ? "6px" : "2px", marginBottom: "4px" }} ref={this.attachedFileRef}>
                              {this.renderAttachedFileDiv()}
                            </Grid>
                          )}

                          <DragAndDrop handleDrop={this.handleAttachmentDrop}>
                            <Grid item style={styles.textFieldContainer} ref={this.textAreaContainerRef}>
                              <TextField
                                required
                                inputRef={this.textAreaRef}
                                key={"ChatScreenTextArea"}
                                style={styles.textField}
                                placeholder="Enter message"
                                variant="outlined"
                                multiline
                                minRows={this.state.isShortScreen || this.state.anotherUserTyping ? 1 : 2}
                                maxRows={isSmallScreen && window.innerWidth < 500 ? 3 : (this.state.isShortScreen ? 10 : 15)}
                                disabled={!this.props.checkboxMode && !channel}
                                onChange={this.handleTypingChange}
                              />
                              {(() => {
                                // Bottom-right "preview in customer's language" icon. Floats inside
                                // the textarea's bottom-right corner. Hidden when we don't know the
                                // customer's language, in checkbox/bulk mode, or when operator
                                // and customer speak the same language.
                                const customerLang = this.state.subjectUserLanguage;
                                const operatorLang = JSON.parse(window.localStorage.getItem('bootstrap'))?.user?.lang || null;
                                if (this.props.checkboxMode) return null;
                                if (!customerLang) return null;
                                if (operatorLang && customerLang.toLowerCase() === operatorLang.toLowerCase()) return null;
                                if (this.state.conversation_id === null || !this.state.textAreaHasText) return null;
                                return (
                                  <Tooltip
                                    title={`Preview in recipient's language (${customerLang.toUpperCase()})`}
                                    arrow
                                    placement="top"
                                  >
                                    <span style={{ position: 'absolute', bottom: 4, right: 6, zIndex: 2 }}>
                                      <IconButton
                                        size="small"
                                        onClick={(e) => this.openDraftTranslationPreview(e.currentTarget, customerLang)}
                                        sx={{
                                          padding: '4px',
                                          color: cv('text-muted', '#8A8A8F'),
                                          '&:hover': { color: cv('accent', '#007AFF') },
                                        }}
                                      >
                                        <TranslateIcon sx={{ fontSize: 16 }} />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                );
                              })()}
                            </Grid>
                          </DragAndDrop>
                          <Grid item onClick={this.sendMessage} style={{ paddingBottom: this.state.showTextAreaBorder ? null : "17px", flexShrink: 0 }}>
                            <IconButton
                              style={styles.sendButton(this.props.checkboxMode ? (!this.props.selectedConversationsForMessaging || this.props.selectedConversationsForMessaging.length === 0) : (!textAreaHasText && (typeof attachedFiles === 'undefined' || attachedFiles.length === 0)))}
                              //onClick={this.sendMessage}
                              disabled={this.props.checkboxMode ? (!this.props.selectedConversationsForMessaging || this.props.selectedConversationsForMessaging.length === 0) : (!channel || (!textAreaHasText && (typeof attachedFiles === 'undefined' || attachedFiles.length === 0)))}
                            >
                              <Send style={styles.sendIcon} />
                            </IconButton>
                          </Grid>
                        </Grid>
                      </Grid>
                      }
                      {!(this.state.keyboardOpen && isSmallScreen && window.innerWidth < 500) &&
                      <Grid item style={{marginLeft: isSmallScreen && window.innerWidth < 500 ? "40px" : "85px", paddingRight: '38px', paddingTop: '2px', paddingBottom: '0px', marginBottom: '0px', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', gap: '0px'}}>
                        {!this.chatWriteRestricted &&
                        <FormGroup sx={{ gap: '0px' }}>
                          <Tooltip title="Exclude delivery to travel agencies and OTAs. Message will only be sent via direct channels. If no direct channels exist, the message will not be delivered." arrow placement="top">
                          <FormControlLabel
                            disabled={!this.props.checkboxMode && (this.state.conversation_id === null)}
                            sx={{
                              '& .MuiFormControlLabel-label': { fontSize: '.75em'},
                              marginRight: '2px',
                              marginBottom: '-4px',
                            }}
                            control={<Checkbox checked={this.state.exclude_delivery_to_agents} style={{marginLeft: "-4px", marginRight: "-6px"}} sx={{ '& .MuiSvgIcon-root': { fontSize: ".75rem" } }} onChange={e => this.setState({ exclude_delivery_to_agents: e.target.checked })} />}
                            label={<Typography style={{ fontSize: isMediumScreen ? ".65rem" : ".75rem", color: !this.props.checkboxMode && this.state.conversation_id === null ? cv('text-disabled', 'rgba(0, 0, 0, 0.2)') : null }} ref={this.excludeAgentsCheckboxRef}>Exclude Delivery to Agents <HelpOutlineIcon style={{marginBottom: -2.5, fontSize: isSmallScreen ? ".65rem" : ".75rem", color: cv('text-secondary', '#5F5F60') }} /></Typography>} />
                          </Tooltip>
                          <Tooltip title="Exclude message delivery to SMS and WhatsApp" arrow placement="top">
                          <FormControlLabel
                            disabled={!this.props.checkboxMode && (this.state.conversation_id === null)}
                            sx={{
                              '& .MuiFormControlLabel-label': { fontSize: '.75em'},
                              marginRight: '2px',
                              marginTop: '-8px',
                            }}
                            control={<Checkbox checked={this.state.exclude_delivery_to_sms_whatsapp} style={{marginLeft: "-4px", marginRight: "-6px"}} sx={{ '& .MuiSvgIcon-root': { fontSize: ".75rem" } }} onChange={e => this.setState({ exclude_delivery_to_sms_whatsapp: e.target.checked })} />}
                            label={<Typography style={{ fontSize: isMediumScreen ? ".65rem" : ".75rem", marginRight: '-5px', color: !this.props.checkboxMode && this.state.conversation_id === null ? cv('text-disabled', 'rgba(0, 0, 0, 0.2)') : null }}>Exclude Delivery to SMS/WhatsApp <HelpOutlineIcon style={{marginBottom: -2.5, fontSize: isSmallScreen ? ".65rem" : ".75rem", color: cv('text-secondary', '#5F5F60') }} /></Typography>} />
                          </Tooltip>
                          </FormGroup>
                        }
                        {(() => {
                          // Don't show chatbot settings icon in checkbox mode
                          if (this.props.checkboxMode) return null;
                          
                          // Only show the chatbot settings icon where a bot can answer:
                          // support chat (auto_reply_with_ai) or the web widget, which
                          // auto-replies on web_chat_widget_enabled alone (backend
                          // ChatMessage.auto_reply_enabled). Gating on the support flag
                          // hid the dot -- and the only Resume path -- from widget-only
                          // operators such as ExperienceFirst.
                          try {
                            const bootstrap = this._bootstrap || {};
                            const cfg = bootstrap?.tour_operator?.config || {};
                            const botCanAnswer = !!(cfg.auto_reply_with_ai || cfg.web_chat_widget_enabled);
                            if (!botCanAnswer) return null;
                          } catch {
                            return null;
                          }
                          
                          // Use saved state for icon (what's actually saved to backend)
                          // This way icon doesn't change until SAVE is clicked
                          const { savedPauseChatbot, savedStopChatbot } = this.state;
                          let IconComponent = ChatBotSettingsGreenDot; // Default: active (green)
                          if (savedStopChatbot) {
                            IconComponent = ChatBotSettingsRedDot; // Stopped (red)
                          } else if (savedPauseChatbot) {
                            IconComponent = ChatBotSettingsYellowDot; // Paused temporarily (yellow)
                          }
                          const isDisabled = this.state.conversation_id === null;
                          // The tooltip says what the colour means and, when the bot is
                          // quiet, why: a handoff (the visitor is waiting for a person)
                          // reads differently from a colleague's Stop (someone owns it).
                          const headline = chatbotStatusHeadline({
                            stopped: savedStopChatbot,
                            paused: savedPauseChatbot,
                            pausedUntil: this.state.chatbotResumeDateTime,
                            reason: this.state.chatbotPauseReason,
                          });
                          const cause = (savedStopChatbot || savedPauseChatbot)
                            ? describePauseCause({
                                reason: this.state.chatbotPauseReason,
                                byName: this.state.chatbotPausedByName,
                                at: this.state.chatbotPausedAt,
                              })
                            : null;
                          const tooltipTitle = (
                            <span>
                              {headline}
                              {cause ? <><br /><span style={{ fontWeight: 400, opacity: 0.85 }}>{cause}</span></> : null}
                              <br /><span style={{ fontWeight: 400, opacity: 0.7 }}>Chatbot settings</span>
                            </span>
                          );
                          return (
                            <div style={{ marginLeft: 'auto'}}>
                              <Tooltip title={tooltipTitle} arrow placement="top"><span>
                              <IconButton disabled={isDisabled} style={{ padding: "5px", marginTop: "4px", marginRight: "-5px" }} onClick={(e) => { e.stopPropagation(); this.toggleChatbotSettingsPanel(e); }}>
                                <IconComponent
                                  style={{
                                    width: 20,
                                    height: 20,
                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                    opacity: isDisabled ? 0.38 : 1,
                                    filter: isDisabled ? 'grayscale(100%)' : 'none'
                                  }}
                                />
                              </IconButton>
                              </span></Tooltip>
                            </div>
                          );
                        })()}
                        </Grid>
                      }
                    </Grid>
                    </>
                    :
                    <div style={{ marginLeft: 40, marginTop: 12, marginBottom: 8 }}>
                      <ErrorIcon style={{ position: "absolute", marginLeft: "-24px", height: "18", width: 18, marginTop: 1, color: cv('accent', '#007AFF') }} />
                      <span style={{ fontSize: ".875rem", marginBottom: 8, marginRight: 36 }}>
                        {!this.state.subjectUserHasOptedOutOfAllValidContactMethods ?
                          "To chat with this user, please add a direct email or phone." :
                          "This user opted out of all valid contact methods (by replying OFF or STOP). We recommend calling this user directly."}
                      </span>
                      <a href={"/user/" + channelSubjectID} target="_blank" rel="noreferrer">
                        <Button
                          style={{ height: "32px", marginTop: 4 }}
                          variant="outlined"
                          color="primary"
                        >EDIT USER</Button>
                      </a>
                    </div>}
                </div>
              )
                : ("")
            }
          </div>
        </Grid>

        {/* Draft translation preview popover */}
        <Popover
          open={Boolean(this.state.draftTranslationAnchorEl)}
          anchorEl={this.state.draftTranslationAnchorEl}
          onClose={this.closeDraftTranslationPreview}
          // CP-6445: see StyledMenu wrappers — avoid an orphaned body scroll lock.
          disableScrollLock
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          PaperProps={{
            sx: {
              p: 1.5,
              maxWidth: 380,
              minWidth: 240,
              borderRadius: 2,
              border: `1px solid ${cv('border', 'rgba(0,0,0,0.08)')}`,
            },
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.75 }}>
            <TranslateIcon sx={{ fontSize: 14, color: cv('text-muted', '#8A8A8F') }} />
            <Typography sx={{ fontSize: 10, fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase', color: cv('text-muted', '#8A8A8F') }}>
              Translation {this.state.draftTranslationLang ? `→ ${this.state.draftTranslationLang.toUpperCase()}` : ''}
            </Typography>
          </Box>
          {this.state.draftTranslationLoading && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
              <CircularProgress size={14} />
              <Typography sx={{ fontSize: 12, color: cv('text-secondary', '#666') }}>Translating…</Typography>
            </Box>
          )}
          {this.state.draftTranslationError && (
            <Typography sx={{ fontSize: 12, color: cv('danger-text', '#B00020'), fontStyle: 'italic' }}>
              {this.state.draftTranslationError}
            </Typography>
          )}
          {this.state.draftTranslationText && !this.state.draftTranslationLoading && (
            <Typography sx={{ fontSize: 13, whiteSpace: 'pre-wrap', overflowWrap: 'break-word', color: cv('text', '#222') }}>
              {this.state.draftTranslationText}
            </Typography>
          )}
          {(() => {
            // Soft "Set your language" nudge, shown only when the operator's
            // own language isn't on file. Bootstrap.user.lang is the cache;
            // self-corrects after the operator sets it and logs back in.
            if (!this.state.draftTranslationText || this.state.draftTranslationLoading) return null;
            const operatorLang = JSON.parse(window.localStorage.getItem('bootstrap'))?.user?.lang || null;
            if (operatorLang) return null;
            const bootstrap = JSON.parse(window.localStorage.getItem('bootstrap')) || {};
            const operatorUserId = bootstrap?.user?.id;
            if (!operatorUserId) return null;
            return (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  mt: 1,
                  pt: 0.75,
                  borderTop: `1px solid ${cv('border', 'rgba(0,0,0,0.06)')}`,
                }}
              >
                <Link
                  href={`/user/${operatorUserId}`}
                  target="_blank"
                  rel="noreferrer"
                  underline="hover"
                  sx={{
                    fontSize: 10,
                    fontWeight: 600,
                    letterSpacing: '0.04em',
                    textTransform: 'uppercase',
                    color: cv('text-muted', '#8A8A8F'),
                    '&:hover': { color: cv('accent', '#007AFF') },
                  }}
                >
                  Set your language ↗
                </Link>
              </Box>
            );
          })()}
          {(() => {
            // Only expose "Apply this translation" when the popover target is the
            // CUSTOMER's language. The same popover is reused by the AI-suggestion
            // chip to translate INTO the operator's language, where replacing the
            // draft would send the customer a reply in the wrong language.
            if (!this.state.draftTranslationText || this.state.draftTranslationLoading) return null;
            const customerLang = (this.state.subjectUserLanguage || '').toLowerCase();
            const popoverTarget = (this.state.draftTranslationLang || '').toLowerCase();
            if (!customerLang || popoverTarget !== customerLang) return null;
            return (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  mt: 1,
                  pt: 0.75,
                  borderTop: `1px solid ${cv('border', 'rgba(0,0,0,0.06)')}`,
                }}
              >
                <Link
                  component="button"
                  type="button"
                  onClick={this.useDraftTranslation}
                  underline="none"
                  sx={{
                    fontSize: 10,
                    fontWeight: 600,
                    letterSpacing: '0.04em',
                    textTransform: 'uppercase',
                    color: cv('accent', '#007AFF'),
                    cursor: 'pointer',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    '&:hover': { color: cv('accent-hover', '#005FCC') },
                  }}
                >
                  <span style={{ fontSize: 16, lineHeight: 1, marginRight: 2 }}>←</span>
                  Apply this translation
                </Link>
              </Box>
            );
          })()}
        </Popover>

        {/* Debug Message Dialog */}
        <Dialog
          open={this.state.debugDialogOpen}
          onClose={this.handleCloseDebugDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Debug Message Information</DialogTitle>
          <DialogContent>
            {this.state.debugLoading ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                <CircularProgress />
              </div>
            ) : (
              <pre style={{ 
                whiteSpace: 'pre-wrap', 
                wordBreak: 'break-word',
                fontSize: '12px',
                fontFamily: 'monospace',
                backgroundColor: cv('surface-muted', '#f5f5f5'),
                padding: '10px',
                borderRadius: '4px',
                maxHeight: '400px',
                overflow: 'auto'
              }}>
                {this.state.debugSummary ? JSON.stringify(this.state.debugSummary, null, 2) : 'No debug information available'}
              </pre>
            )}
          </DialogContent>
        </Dialog>

      </Container>
    );
  }
}

const styles = {
  header: (show1pageScreen) => ({
    marginTop: 4,
    color: cv('text', 'black'),
    width: "100%",
    //textAlign: "center",
    backgroundColor: cv('surface-muted', '#F5F5F5'),
    borderTop: `1px solid ${cv('border', 'rgb(224, 224, 224)')}`,
    borderRight: `1px solid ${cv('border', 'rgb(224, 224, 224)')}`,
    borderBottom: `1px solid ${cv('border', 'rgb(224, 224, 224)')}`,
    borderLeft: !show1pageScreen ? null : `1px solid ${cv('border', 'rgb(224, 224, 224)')}`,
    borderRadius: !show1pageScreen ? "0px 10px 0px 0px" : "10px 10px 0px 0px",
    height: 109.5,
    // The single-page layout gives the surrounding grid a definite height so
    // the chat column can flex-shrink on short viewports; the header must not
    // be the thing that shrinks.
    flexShrink: 0
  }),
  avatar: (text) => ({
    display: text ? "inline-block" : "none",
    marginRight: 12,
    marginTop: 5,
    minWidth: 32
  }),
  topicImg: {
    display: "inline-block",
    height: '32px',
    width: '32px',
    borderRadius: '50%',
    marginRight: 12,
    marginTop: 6
  },
  userProfileRow: (isSelected) => ({
    display: "flex",
    flexDirection: "row",
    paddingTop: 6,
    paddingBottom: 6,
    width: "100%",
    //cursor: "pointer",
    //overflowX: "auto",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  }),
  textField: { width: "100%", borderWidth: 0, borderColor: "transparent", paddingBottom: "1px" },
  notesField: { maxHeight: "15%", height: "15%", width: "100%", top: 0, borderWidth: 0, borderColor: "transparent" },
  textFieldContainer: { flex: 1, minWidth: 0, marginRight: 12, position: "relative" },
  gridItem: { paddingTop: 12, paddingBottom: 12 },
  gridItemChatList: (notesAreShown, announcementsBannerIsShown, show1pageScreen, isSmallScreen, internalTagsAreShown, hasAttachments) => ({
    position: "relative",
    overflowX: !show1pageScreen ? "auto" : "hidden",
    overflowY: "auto",
    // Small screens: the parent column has a definite (possibly shrunk)
    // height, so take exactly what remains above the natural-height composer
    // instead of a hardcoded 67%/74% split (which could sum past 100% with a
    // tall composer, e.g. with AI Reply suggestions, letting the sticky
    // composer overlap the end of the list).
    height: !isSmallScreen ? "100%" : "auto",
    flex: !isSmallScreen ? null : "1 1 auto",
    minHeight: !isSmallScreen ? null : 0,

    borderRight: `1px solid ${cv('border', 'rgb(224, 224, 224)')}`,
    borderBottom: `1px solid ${cv('border', 'rgb(224, 224, 224)')}`,
    borderLeft: !show1pageScreen ? null : `1px solid ${cv('border', 'rgb(224, 224, 224)')}`,
    borderTop: notesAreShown ? `2px solid ${cv('border', 'rgb(224, 224, 224)')}` : null,
    backgroundColor: cv('surface-alt', '#FCFCFE'),
  }),
  notesItemList: (show1pageScreen) => ({
    position: "relative",
    overflow: "auto",
    height: "17svh",
    borderRight: `1px solid ${cv('border', 'rgb(224, 224, 224)')}`,
    borderLeft: !show1pageScreen ? null : `1px solid ${cv('border', 'rgb(224, 224, 224)')}`,
    backgroundColor: cv('surface-alt', '#FCFCFE'),
    WebkitMask: "conic-gradient(from 90deg at 1px 1px, #0000 25%,#000 0) 0 0/calc(100% - 1px) calc(100% - 1px), linear-gradient(180deg, #FCFCFE 60%, transparent)",
    //WebkitMaskBorder: "1px solid rgb(224, 224, 224)"
  }),
  internalTagsPane: (show1pageScreen) => ({
    position: "relative",
    overflow: "auto",
    height: "35px",
    minHeight: "35px",
    backgroundColor: cv('surface-alt', '#FCFCFE'),
  }),
  notesItemListInOverlay: (notesInputHeight) => ({
    position: "relative",
    maxHeight: notesInputHeight ? "calc(72vh - " + notesInputHeight + "px)" : "72vh",
    overflow: "auto",
    //border: "1px solid rgb(212, 212, 212)",
    //backgroundColor: "#FCFCFE"
  }),
  gridItemMessageEntryArea: (anotherUserIsTyping, showBorder, show1pageScreen, isSmallScreen) => ({
    //paddingTop: anotherUserIsTyping ? 0 : "1.3vh",
    //paddingBottom: anotherUserIsTyping ? 3 : "1.3vh",
    paddingRight: 10,
    //marginLeft: "auto",
    //marginRight: "auto",
    borderBottom: showBorder ? `1px solid ${cv('border', 'rgb(224, 224, 224)')}` : null,
    borderRight: showBorder ? `1px solid ${cv('border', 'rgb(224, 224, 224)')}` : null,
    borderLeft: showBorder && show1pageScreen ? `1px solid ${cv('border', 'rgb(224, 224, 224)')}` : null,
    //height: anotherUserIsTyping ? "calc(17.6vh - 66px)" : "calc(17.6vh - 51px)",
    // No position:sticky here any more: it was a band-aid for the chat
    // column overflowing short viewports (the composer rode up over the end
    // of the message list, hiding the last message — Ventrata side panel
    // report). The column is now flex-shrunk to the real viewport height, so
    // the composer's in-flow position is always visible; sticky would only
    // pin it to an unrelated wrapper edge and overlap the list again.
    flexShrink: 0,
    // No maxHeight/overflowY cap on phones: the composer's natural height is
    // already bounded (textarea maxRows=3 under 500px, attachments box has its
    // own 15vh scroll), so the section should never scroll internally — the
    // message list above is the flex child that shrinks. The old 35vh cap plus
    // an inner height:100%+margin over-constraint produced a permanent 6px
    // scrollbar over the send/checkbox controls (partner report 9/13).
    ...(isSmallScreen && window.innerWidth < 500 ? {
      backgroundColor: cv('surface-alt', '#FCFCFE'),
      paddingBottom: 'env(safe-area-inset-bottom, 0px)',
    } : {})
  }),
  // Rules run out to both edges so the break between days reads at a glance
  // while scrolling. (The old paddingTop: "10" was unitless and therefore
  // ignored by the browser.)
  //
  // followingGap = the top padding the item BELOW the separator applies to
  // itself; subtracting it from the bottom keeps the whitespace on either side
  // of the rule equal. Padding rather than margin so nothing collapses into the
  // wrapper divs these sit in.
  dateSeparator: (followingGap) => ({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: `${DATE_SEPARATOR_GAP_PX}px`,
    paddingBottom: `${Math.max(0, DATE_SEPARATOR_GAP_PX - followingGap)}px`,
    lineHeight: 1.4,
    fontSize: "12px",
    color: cv('text-muted', '#8A8A8F'),
  }),
  dateSeparatorLine: { flex: 1, height: "1px", backgroundColor: cv('border', '#E0E0E0') },
  dateSeparatorText: { whiteSpace: "nowrap" },
  sendButton: (isDisabled) => ({ width: 26, height: 26, backgroundColor: isDisabled ? "#777777" : cv('accent-fill', "#007AFF"), cursor: "pointer" }),
  sendIcon: { color: "white", width: 16, position: "relative", left: 1 },
  mainGrid: { position: "relative" },
  attachedFileDivLink: { fontWeight: 'bold', fontSize: '8px', textAlign: "center" },
  noMessagesPlaceholder: {
    borderRadius: 12,
    padding: 16,
    color: cv('text', 'black'),
    fontSize: 12,
    backgroundColor: cv('surface-muted', '#e5e5ea'),
    maxWidth: "400px",
    overflowWrap: "break-word",
    textAlign: "center",
    position: "absolute",
    bottom: 8,
    left: 0,
    right: 0,
    margin: "auto"
  },
  announcementsBanner: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: cv('surface-muted', '#F0F0F0'),
    borderBottom: `1px solid ${cv('border', 'rgb(224, 224, 224)')}`,
    borderRight: `1px solid ${cv('border', 'rgb(224, 224, 224)')}`,
    height: "3vh",
    fontSize: 13
  },
  closeButton: {
    border: "none",
    display: "inline-block",
    padding: "0px 16px",
    verticalAlign: "middle",
    overflow: "hidden",
    textDecoration: "none",
    color: "inherit",
    backgroundColor: "inherit",
    textAlign: "center",
    cursor: "pointer",
    whiteSpace: "nowrap",
    position: "absolute",
    right: 0,
    top: 0,
    fontSize: "2rem",
    borderRadius: "50%",
    zIndex: 12
  }
};


export default connect(mapStateToProps)(withRouter(withParams(withSnackbar(ChatScreen))));
